/* eslint-disable array-callback-return, eqeqeq */
import React, { forwardRef, useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Highstock from "highcharts/highstock";
import icon_download from "assets/images/icon-download.png";
import icon_checkbox_outline from "assets/images/icon-checkbox-outline.svg";
import icon_checkbox from "assets/images/icon-checkbox.svg";
import icon_undo from "assets/images/icon-undo.svg";
import icon_undo_active from "assets/images/icon-undo-active.svg";
import icon_redo from "assets/images/icon-redo.svg";
import icon_redo_active from "assets/images/icon-redo-active.svg";
import icon_reset from "assets/images/icon-reset.svg";
import icon_reset_active from "assets/images/icon-reset-active.svg";
import icon_delete from "assets/images/icon-delete.svg";
import icon_edit_small from "assets/images/icon-edit-cat.png";
import icon_checkbox_checked_round from "assets/images/icon-checkbox-checked-round.png";
import icon_checkbox_round from "assets/images/icon-checkbox-round.png";
import image_loader from "assets/images/loader.gif";
import reportLogo from "assets/images/reportLogo.png";
import waveImage from "assets/images/WaveImg.svg";
import footerWave from "assets/images/footer.svg";
import ratingImage from "assets/images/img_rating_bar.png";
import icon_clock from "assets/images/icon_clock.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ls from "local-storage";
import useUndo from "use-undo";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import domtoimage from "dom-to-image";
import { isNotEmpty } from "util/helpers";
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    MenuItem,
    Chip,
    IconButton,
    ListItemText,
    Input,
    Checkbox,
    Drawer,
    Fab,
    InputBase,
    FormControl,
    Select as MSelect,
} from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import Close from "@material-ui/icons/Close";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import TreeSelect from "antd/lib/tree-select";
import "antd/lib/tree-select/style/css";

import Charts from "./components/charts";
import TvCharts from "./components/charts/tv_index";
import KpiListComp from "components/wall/KpiListComp";
import DateListComp from "components/wall/DateListComp";
import ConfirmDeleteDialog from "./components/confirm_delete_dialog";
//mport ConfirmUploadDialog from "./components/confirmUploadReport";
import SamplePatientUpload from "./components/samplePatientUpload";
import AnnotateDialog from "./components/annotate_dialog";
// import Info from "./components/Info";
import RiiSlider from "./reports/RiiSlider";
import RIIDESlider from "./reports/RIIDESlider";
import SeCircle from "./reports/SeCircle";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import sleep_image from "assets/images/sleep.png";
import moon from "assets/images/moon.png";
import ahi from "assets/images/ahi.png";
import icon_edit from "assets/images/icon-edit.png";
import { treeData, denominators } from "constants/riiParameters";

import { initial_tv_kpis } from "common/index";
import TrendNightGraphs from "./reports/TrendNightGraphs";
import { getLocalMoment } from "util/timeZoneDate";
import { fetch_user_countries as fetch_user_countries_action } from "actions/user";

import {
    fetch_patient_data as fetch_patient_data_action,
    add_patient_comment as add_patient_comment_action,
    fetch_patient_comment as fetch_patient_comment_action,
    fetch_patients_qna_response as fetch_patients_qna_response_action,
    update_patient_comment as update_patient_comment_action,
    delete_patient_comment as delete_patient_comment_action,
    fetch_disease_list as fetch_disease_list_action,
    fetch_patient_disease as fetch_patient_disease_action,
    fetch_checkup_dates as fetch_checkup_dates_action,
    add_checkup_date as add_checkup_date_action,
    checkup_mark_as_complete as checkup_mark_as_complete_action,
    fetch_patients_summary as fetch_patients_summary_action,
    fetch_patient_medication_symptoms_history as fetch_patient_medication_symptoms_history_action,
    // upload_patient_report as upload_patient_report_action,
    reset_report_error as reset_report_error_action,
    refresh_statistics_action,
    generate_report_data_action,
} from "actions/patients";

import {
    fetch_nights_available as fetch_nights_available_action,
    fetch_available_kpis as fetch_available_kpis_action,
    // fetch_kpi_data as fetch_kpi_data_action,
    fetch_s3_kpi_data as fetch_s3_kpi_data_action,
    fetch_tv_kpi_data as fetch_tv_kpi_data_action,
    reset_tv_kpi_data as reset_tv_kpi_data_action,
    fetch_annotations as fetch_annotations_action,
    fetch_patients_rii_summary as fetch_patients_rii_summary_action,
    fetch_actigraph as fetch_actigraph_action,
    add_new_annotation as add_new_annotation_action,
    edit_annotation as edit_annotation_action,
    fetch_annotation_categories as fetch_annotation_categories_action,
    add_annotation_category as add_annotation_category_action,
    edit_annotation_category as edit_annotation_category_action,
    delete_annotation_category as delete_annotation_category_action,
    delete_annotations as delete_annotations_action,
    generate_system_annotations as generate_system_annotations_action,
    update_kpi_preference as update_kpi_preference_action,
    update_trendview_kpi_preference as update_trendview_kpi_preference_action,
    // fetch_patient_jira_cards_data as fetch_patient_jira_cards_data_action,
} from "actions/kpi";

import IntlMessages from "util/IntlMessages";
import TrendSingleNightGraphs from "./reports/TrendSingleNightGraphs";
import asyncComponent from "util/asyncComponent";

dayjs.extend(utc);
dayjs.extend(timezone);

window.onbeforeunload = function () {
    window.onunload = function () {
        if (performance.navigation.type !== 1) {
            window.localStorage.clear();
        }
    };
    return undefined;
};

const ref = React.createRef();

const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const kpi_names = {
    SLP_STGS: "Sleep Stages",
    Y_DIST: "Chest Displacement",
    MOV: "Body Movement",
    BR: "Breathing Rate",
    BRV: "BR Variability",
    HR: "Heart Rate Radar",
    HRV: "HR Variability",
    SPO2: "SPO2",
    PR: "Pulse Rate",
    SQ: "Rec. Sta.",
    AHI: "AHI",
    I: "I",
    Q: "Q",
    IQ: "IQ",
    SA: "Sleep Awake",
    TB: "Time in Bed",
    GSD: "GSD",
    RII: "RII",
    SE: "SE",
    bp: "Blood Pressure",
    blood_sugar: "Blood Sugar",
    body_temp: "Body Temperature",
    weight: "Weight",
    NC_PSG: "Nasal Cannula",
    THRX_PSG: "Thorax",
    ABD_PSG: "Abdomen",
    SPO2_PSG: "SPO2 PSG",
};

const kpi_preference = {
    SLP_STGS: true,
    Y_DIST: true,
    MOV: true,
    BR: true,
    BRV: true,
    HR: true,
    HRV: true,
    SPO2: true,
    PR: true,
    AHI: true,
    I: true,
    Q: true,
    SA: true,
    TB: true,
    GSD: true,
    RII: true,
    SE: true,
    SQ: true,
    bp: true,
    blood_sugar: true,
    body_temp: true,
    weight: false,
    NC_PSG: false,
    THRX_PSG: false,
    ABD_PSG: false,
    SPO2_PSG: false,
};

const summaryKpisList = ["MOV", "BR", "HR", "RECORDING", "AHI", "SPO2", "PR"];

//const summaryKpisList = ["MOV", "BR", "HR", "AHI", "SPO2", "PR"];

function createData(name, nightA, durationA) {
    return { name, nightA, durationA };
}

const pages_options = [
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "30", label: "30" },
    { value: "40", label: "40" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
];
const initial_tv_duration_options = [
    { type: "days", value: "3", label: "Last 3 Nights", disabled: true },
    { type: "days", value: "10", label: "Last 10 Nights", disabled: true },
    { type: "months", value: "1", label: "Last Month", disabled: true },
    { type: "custom", value: "custom", label: "Custom Duration", disabled: true },
];
const default_overviews = {
    AHI: {
        label: "AHI",
        target: "AHI",
        id: "ahi",
        value: "-- : --",
        img: <img alt="" width="30px" src={ahi} />,
    },
    GSD: {
        label: "GSD",
        target: "GSD",
        id: "gsd",
        value: "-- : --",
        img: <img alt="" width="30px" src={ahi} />,
    },
    SO: {
        label: "SO",
        target: "any",
        id: "so",
        value: "-- : --",
        img: <img alt="" width="30px" src={moon} />,
    },
    latency_deep_sleep: {
        label: "Latency Deep Sleep",
        target: "any",
        id: "latency_deep_sleep",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    latency_light_sleep: {
        label: "Latency Light Sleep",
        target: "any",
        id: "latency_light_sleep",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    latency_rem_sleep: {
        label: "Latency Rem Sleep",
        target: "any",
        id: "latency_rem_sleep",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    sleep_efficiency: {
        label: "Sleep Efficiency",
        target: "any",
        id: "sleep_efficiency",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    total_time_in_bed: {
        label: "Time in Bed",
        target: "any",
        id: "total_time_in_bed",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    TRT: {
        label: "TRT",
        target: "any",
        id: "trt",
        value: "-- : --",
        img: <img alt="" width="30px" src={sleep_image} />,
    },
    total_sleep_time: {
        label: "TST",
        target: "any",
        id: "total_sleep_time",
        value: "-- : --",
        img: <img alt="" width="30px" src={null} />,
    },
    wake_after_sleep_onset: {
        label: "WASO",
        target: "any",
        id: "wake_after_sleep_onset",
        value: "-- : --",
        img: <img alt="" width="30px" src={sleep_image} />,
    },
};

let extremes = {
    from: 0,
    to: 0,
};

const LazyPatientReportDialog = asyncComponent(() =>
    import("./reports/PatientReportDialog")
);
const LazyPatientReportRPM = asyncComponent(() =>
    import("./reports/PatientReportRPM")
);
const LazyPhysicianReportNightlyEN = asyncComponent(() =>
    import("./reports/PhysicianReportNightlyEN")
);
const LazyPhysicianReportNightlyDE = asyncComponent(() =>
    import("./reports/PhysicianReportNightlyDE")
);
const LazyPhysicianReportEN = asyncComponent(() =>
    import("./reports/PhysicianReportEN")
);
const LazyPhysicianReportDE = asyncComponent(() =>
    import("./reports/PhysicianReportDE")
);
const LazyPhysicianReportENStudy = asyncComponent(() =>
    import("./reports/PhysicianReportENstudy")
);
const LazyPhysicianReportDEStudy = asyncComponent(() =>
    import("./reports/PhysicianReportDEstudy")
);
const LazyPhysicianReportDU = asyncComponent(() =>
    import("./reports/PhysicianReportDU")
);
const LazyPatientTvReport = asyncComponent(() =>
    import("./reports/PatientTvReport")
);

const LazyPatientInsomniaReport = asyncComponent(() =>
    import("./reports/PhysicianReportUSInsomnia")
);

const SinglePatient = (props) => {
    const {
        fetch_patient_data,
        fetch_available_kpis,
        fetch_annotations,
        fetch_patients_qna_response,
        fetch_patients_qna_data,

        fetch_annotation_categories,
        add_annotation_category,
        edit_annotation_category,
        delete_annotation_category,
        generate_system_annotations,
        // fetch_kpi_data,
        fetch_s3_kpi_data,
        fetch_tv_kpi_data,
        match,
        patient_info,
        device_info,
        patients,
        kpi,
        add_new_annotation,
        edit_annotation,

        fetch_disease_list,
        fetch_patient_disease,
        doctor_id,
        add_checkup_date,
        checkup_mark_as_complete,
        fetch_patients_summary,
        fetch_patients_rii_summary,
        fetch_user_countries,

        update_kpi_preference,
        update_trendview_kpi_preference,
        physician_info,
        rii_parameters,
        fetch_patient_medication_symptoms_history,
        fetch_actigraph,
        //upload_patient_report,
        // fetch_patient_jira_cards_data,
        refresh_statistics,
        generate_report_data,
    } = props;

    const {
        available_kpis,
        non_graph_available_kpis,
        nights_available,
        fetching_nights_available,

        fetching_actigraph,
        actigraph_dates,
        actigraph,
        actigraph_meta,
        recording_meta,

        annotations,
        annotation_categories,
        fetching_annotations,
        analytics,
        no_system_annotations,
        no_system_desaturations,
        tv_analytics,
        fetching_available_kpis,
        fetching_kpi_data,
        fetching_tv_kpi_data,
        jira_cards_data,
    } = kpi;
    if (props.is_annotator) {
        kpi_preference.IQ = true;
        kpi_names.IQ = "I & Q";
    }

    if (props.membership_type !== "paid") {
        kpi_preference.ODI = true;
        kpi_names.ODI = "ODI";
    }

    const SAMPLE_PATIENT_PHYSICIAN = 2112;

    // Download Report
    const [treeSelect, toggleTreeSelect] = useState(false);
    const [confirm_del_dialog, setConfirmDelDialog] = useState(false);
    const [confirm_dialog_type, setConfirmDialogType] = useState("");
    const [isOpenReportDownloadDialog, set_isOpenReportDownloadDialog] = useState(
        false
    );
    const [reportComment, set_reportComment] = useState("");

    const [reportType, setReportType] = useState("");
    const [selectedDates, setSelectedDates] = useState("");
    const [jira_key, setJiraKey] = useState([]);
    //const [selectedJiraKey, setSelectedJiraKey] = useState("");
    //const [confirmModal, setConfirmModal] = useState(false);
    const [samplePatient, setSamplePatient] = useState(false);
    //const [finalBlob, setFinalBlob] = useState("");
    // const [finalFileName, setFinalFileName] = useState("");
    const generateReportBtn = useRef(null);
    const [showReport, setShowReport] = useState(false);

    const handleToggleActiGraphView = (is_actigraph_view) => {
        set_actigraph_view(!is_actigraph_view, tv_night_from, tv_night_to);
        let device = "";
        const selectedNight = Object.values(nights_available).find((night) => {
            const { device_start_date } = night[0];

            return device_start_date === dayjs(tv_night_from).format("YYYY-MM-DD");
        });

        if (selectedNight) {
            device = selectedNight[0].device_id;
            console.log(selectedNight);
        }

        if (is_actigraph_view) {
            // load trendview datap
            //props.reset_tv_kpi_data();
            //   set_selected_tv_kpis([]);
            //   set_selected_kpis([]);
        } else {
            // load actigraph data
            fetch_actigraph({
                start_date: tv_night_from,
                end_date: tv_night_to,
                patient_id: patients.patient_info.user_id,
                device_id: device_info ? device_info.device_id : device,
            });
        }
    };

    const handle_toggleReportDownloadDialog = () => {
        // if (props.is_annotator) return;
        set_isOpenReportDownloadDialog(!isOpenReportDownloadDialog);
        //  setSelectedJiraKey("");
        // setFinalFileName("");
        setReportType("");
        setShowReport(false);
    };

    const handle_onDownloadReportClick = (
        reportComment,
        report,
        selectedDates,
        jiraKey,
        isEdit
    ) => {
        if (report.label.includes("Automated")) {
            generate_report_data({
                patient_code: patient_info.patient_code,
                language: report.label.includes("German") ? "de" : "en",
                version: report.value.split("-")[0],
                dates: selectedDates,
            });
            set_show_loader(true);
            setShowReport(true);
            return;
        }

        if (report.value === "en" || report.value === "en-us") {
            reset_chartImgs();
            set_show_loader(true);
            process_convert(report.value);
        }
        if (!(isEdit === "edit") && report.value !== reportType) {
            set_show_loader(true);
            process_convert(report.value);
        }
        //setSelectedJiraKey(jiraKey.label);
        set_reportComment(reportComment);
        setSelectedDates(selectedDates);
        setReportType(report.value);
    };

    useEffect(
        () => {
            if (reportType) {
                set_show_loader(true);
                setShowReport(false);
                process_convert(reportType);
            }
            if (
                patients.automated_report_url.length > 0 ||
                patients.automated_report_failure_msg.length > 0
            ) {
                set_show_loader(false);
            }
        },
        [
            tv_analytics,
            patients.automated_report_url,
            patients.automated_report_failure_msg,
        ]
    );

    //   const handleUploadReport = (blob, fileName) => {
    //     set_isOpenReportDownloadDialog(!isOpenReportDownloadDialog);
    //     setConfirmModal(true);
    //     setFinalBlob(blob);
    //     setFinalFileName(fileName);
    //   };

    const handleDownloadReport = (blob, fileName) => {
        downloadReport(blob, fileName, true);
    };

    const downloadReport = async (blob, fileName, isDownload) => {
        set_show_loader(true);
        if (isDownload) {
            const link = document.createElement("a");
            //   create a blobURI pointing to our Blob
            link.href = URL.createObjectURL(blob);
            link.download = fileName;

            document.body.append(link);
            setTimeout(() => {
                link.click();
                link.remove();
            }, 1000);

            // in case the Blob uses a lot of memory
            setTimeout(() => {
                window.addEventListener("focus", URL.revokeObjectURL(link.href), {
                    once: true,
                });
                if (localStorage.getItem("auto-downloaded-report")) {
                    set_isOpenReportDownloadDialog(false);
                    localStorage.removeItem("auto-downloaded-report");
                }
            }, 1000);
            set_isOpenReportDownloadDialog(!isOpenReportDownloadDialog);
            setReportType("");
            reset_chartImgs();
        } else {
            //   await upload_patient_report({
            //     finalBlob,
            //     finalFileName,
            //     selectedJiraKey,
            //   });
            //   await fetch_patient_jira_cards_data({
            //     patient_code: patient_info.patient_code,
            //   });
        }

        setTimeout(() => {
            set_show_loader(false);
        }, 1000);
        set_reportComment("");
        setReportType("");
        // setSelectedJiraKey("");
        setSelectedDates("");
        //setFinalBlob("");
    };

    //   useEffect(
    //     () => {
    //       if (props.is_error) {
    //         setConfirmModal(true);
    //       } else {
    //         setConfirmModal(false);
    //       }
    //     },
    //     [patients.is_error, patients.uploading_patient_report]
    //   );

    async function process_convert(reportValue) {
        let promises = [];
        if (!(reportValue === "en-pyn") || !(reportValue === "de-pyn")) {
            for await (let item of asyncIterable) {
                promises.push(convertToImg(item[0], item[1]));
            }
        }

        if (
            tv_analytics &&
            Array.isArray(tv_analytics["RII"]) &&
            tv_analytics["RII"].length
        ) {
            if (
                reportValue === "en-pyn" ||
                reportValue === "de-pyn" ||
                reportValue === "en-py" ||
                reportValue === "de-py" ||
                reportValue === "du-pys" ||
                reportValue === "en-pys" ||
                reportValue === "de-pys"
            ) {
                promises.push(generate_rii_de_slider());
            }

            if (reportValue === "en-RPM" || reportValue === "en") {
                promises.push(generate_rii_slider());
            }
        }

        if (
            tv_analytics &&
            Array.isArray(tv_analytics["SE"]) &&
            tv_analytics["SE"].length &&
            selected_tv_kpis["SE"] &&
            (reportValue === "en-RPM" || reportValue === "en")
        ) {
            promises.push(generate_se_circle());
        }

        if (night_view === "single_night") {
            if (summary_table_9.length > 0) {
                if (reportValue === "en-RPM" || reportValue === "en") {
                    promises.push(generate_oneNight_rii_slider(summary_table_9));
                }

                if (
                    reportValue === "en-pyn" ||
                    reportValue === "de-pyn" ||
                    (reportValue === "en-py" ||
                        reportValue === "de-py" ||
                        reportValue === "du-pys") ||
                    reportValue === "en-pys" ||
                    reportValue === "de-pys"
                ) {
                    promises.push(generate_oneNight_de_rii_slider(summary_table_9));
                }
            }
        }
        if (
            tv_analytics &&
            Array.isArray(tv_analytics["SE"]) &&
            tv_analytics["SE"].length > 0 &&
            (reportValue === "en-RPM" || reportValue === "en")
        ) {
            promises.push(generate_single_se_circle());
        }

        Promise.all(promises)
            .then(() => {
                setTimeout(() => {
                    set_show_loader(false);
                    setShowReport(true);
                }, 1000);
            })
            .catch(() => {
                setTimeout(() => {
                    set_show_loader(false);
                }, 1000);
            });
    }

    useEffect(() => {
        fetch_patient_data(match.params.id);
        fetch_user_countries();

        const search = props.history.location.search;
        if (search !== "") {
            const queryData = search.split("?")[1].split("&");
            queryData.forEach((q) => {
                if (q.indexOf("night") === 0) {
                    const loaded_night = q.split("night=")[1];
                    set_url_night(loaded_night);
                }
            });
        }
        ls.remove("zoomMin");
        ls.remove("zoomMax");
    }, []);

    // TODO: tv_analytics['bp' ++] comes from backend... keep a watch on it
    //rangeFrom and rangeTo is the range of selected durations via the chart or the slider
    // This was done because useEffect wasn't detecting extremes since it's not a state variable
    const [rangeFrom, setRangeFrom] = useState(extremes.from);
    const [rangeTo, setRangeTo] = useState(extremes.to);
    const update_extremes = (new_extremes) => {
        extremes = {
            ...new_extremes,
        };
        setRangeFrom(extremes.from);
        setRangeTo(extremes.to);
    };

    const [url_night, set_url_night] = useState(null);

    const [tv_duration, set_tv_duration] = useState();
    const [tv_duration_options, set_tv_duration_options] = useState(
        JSON.parse(JSON.stringify(initial_tv_duration_options))
    );
    const [tv_night_from, set_tv_night_from] = useState(null);
    const [tv_night_to, set_tv_night_to] = useState(null);
    const [tv_kpis] = useState(initial_tv_kpis);

    const [sorted_tv_kpis, set_sorted_tv_kpis] = useState([]);
    const [selected_tv_kpis, set_selected_tv_kpis] = useState({});

    const [sorted_actigraph_dates, set_sorted_actigraph_dates] = useState([]);
    const [selected_actigraph_dates, set_selected_actigraph_dates] = useState({});

    const [night_view, set_night_view] = useState("single_night");
    const [actigraph_view, set_actigraph_view] = useState(false);
    const [show_loader, set_show_loader] = useState(false);
    const [show_patient_info, set_show_patient_info] = useState(false);
    const [selected_night, select_night] = useState(null);
    const [start_time, change_start_time] = useState(null);
    const [end_time, change_end_time] = useState(null);
    const [selected_kpis, set_selected_kpis] = useState({});
    const [sorted_kpis, set_sorted_kpis] = useState([]);
    const [sorted_array_kpis, set_sorted_array_kpis] = useState({});
    const [vital_parameters, set_vital_parameters] = useState({});
    const [sorted_tv_array_kpis, set_sorted_tv_array_kpis] = useState({});
    const [
        show_system_annotations_flag,
        set_show_system_annotations_flag,
    ] = useState(true);
    const [show_desaturations_flag, set_show_desaturations_flag] = useState(
        false
    );
    const [show_annotations_flag, set_show_annotations_flag] = useState(true);
    const [
        show_annotations_sidebar_flag,
        set_show_annotations_sidebar_flag,
    ] = useState(false);
    const [show_artifects_flag, set_show_artifects_flag] = useState(false);
    const [show_plotbands, set_show_plotbands] = useState(false);

    const [selected_annotation, set_selected_annotation] = useState({});
    const [
        selected_multiple_annotations,
        set_selected_multiple_annotations,
    ] = useState([]);
    const [annotation_map_id, set_annotation_map_id] = useState(null);
    const [view_annotation_flag, set_view_annotation_flag] = useState(false);
    const [edit_annotation_flag, set_edit_annotation_flag] = useState(false);
    const [overviews, update_overviews] = useState(default_overviews);

    const zoom_type = "x";
    const [annotate, set_annotate] = useState(false);
    const keyComboRef = useRef(false);
    const setKeyComboValue = useRef(false);
    const [annotate_range, set_annotate_range] = useState([]);

    const [summary_table_1, set_summary_table_1] = useState([]);
    const [summary_table_2, set_summary_table_2] = useState([]);
    const [summary_table_3, set_summary_table_3] = useState([]);
    const [summary_table_4, set_summary_table_4] = useState([]);
    const [summary_table_5, set_summary_table_5] = useState([]);
    const [summary_table_6, set_summary_table_6] = useState([]);
    const [summary_table_7, set_summary_table_7] = useState([]);
    const [summary_table_8, set_summary_table_8] = useState([]);
    const [summary_table_9, set_summary_table_9] = useState([]);
    const [summary_table_10, set_summary_table_10] = useState([]);
    const [summary_table_11, set_summary_table_11] = useState([]);
    const [summary_table_12, set_summary_table_12] = useState([]);
    const [summary_table_13, set_summary_table_13] = useState([]);
    const [summary_table_14, set_summary_table_14] = useState([]); // summary for symptoms histroy
    const [summary_table_15, set_summary_table_15] = useState([]); // summary for medication history
    const [summary_table_16, set_summary_table_16] = useState([]); // summary for diet plan history
    const [summary_table_17, set_summary_table_17] = useState([]); // bed time stats.
    const [spo2_details, set_spo2_details] = useState([]);

    const [
        annotationSidebarSubContent,
        setAnnotationSidebarSubContent,
    ] = useState([]);
    const [customTimeRange, setCustomTimeRange] = useState([]);
    const checkUpCalendarRef = useRef(null);
    const nightCalendarRef = useRef(null);
    const commentInputRef = useRef(null);
    const [commentsPerPage, setCommentsPerPage] = useState(
        pages_options[0].value
    );
    const [firstComment, setFirstComment] = useState(0);
    const [lastComment, setLastComment] = useState(
        firstComment + Number(commentsPerPage)
    );
    var [pageNumber, setPageNumber] = useState(1);
    const [checkupDate, setCheckupDate] = useState(dayjs.utc().toDate());
    const [annotation_flags, set_annotation_flags] = useState({});
    const [
        show_Custom_Annotation_Flag,
        set_show_Custom_Annotation_Flag,
    ] = useState(false);
    const [show_System_Annotation, set_show_System_Annotation] = useState(false);
    const [show_Desaturations, set_show_Desaturations] = useState(false);
    const [handle_artifects_flag, set_handle_artifects_flag] = useState(false);
    const [
        handle_annotations_sidebar_flag,
        set_handle_annotations_sidebar_flag,
    ] = useState(false);
    const [riiParameters, setRiiParameters] = useState(
        JSON.parse(rii_parameters || '["TBT"]')
    );
    const nightFromCalendarRef = useRef(null);
    const nightToCalendarRef = useRef(null);
    const preventResetDataTable = useRef({});
    const [windowViewActive, setWindowViewActive] = useState(false);
    const [trigger_reload, set_trigger_reload] = useState([]);
    const [
        selectedRange,
        { set: setSelectedRange, undo, redo, reset, canUndo, canRedo },
    ] = useUndo([]);
    const [foot, set_foot] = useState("");
    const [wave, set_wave] = useState("");
    const keyComboHandler = (e) => {
        if (
            (!e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) ||
            e.key === "Meta" ||
            e.key === "Shift" ||
            e.key === "Control" ||
            e.key === "alt"
        ) {
            return;
        }

        if (e.shiftKey && e.keyCode === 65) {
            setKeyComboValue.current = "Apnea";
        }
    };
    useEffect(() => {
        if (!keyComboRef.current) {
            keyComboRef.current = true;
            document.addEventListener("keydown", keyComboHandler);
        }
        return () => {
            document.removeEventListener(keyComboHandler);
        };
    }, []);

    useEffect(
        () => {
            setKeyComboValue.current = false;
        },
        [annotations]
    );

    useEffect(
        () => {
            const jira_cards = [];
            if (jira_cards_data && jira_cards_data.length && props.patient_info) {
                jira_cards_data
                    .filter((x) => x.patient_id === props.patient_info.patient_code)
                    .map((x) => {
                        jira_cards.push({
                            value: x.id,
                            label: x.card_key,
                        });
                    });
            }
            setJiraKey(jira_cards);
        },
        [jira_cards_data]
    );

    const exportToCSV = () => {
        if (show_loader || props.is_annotator) {
            return;
        }

        const allKpiList = Object.keys(selected_kpis);
        if (allKpiList.length === 0) {
            alert("Please select a KPI to download data points.");
            return;
        }

        set_show_loader(true);

        setTimeout(function () {
            const device_id = nights_available[selected_night][0].device_id;
            const selectedNight = dayjs(selected_night * 1000).format("YYYYMMDD");
            const allSortedKpiList = sorted_kpis.filter(
                (f) => -1 !== allKpiList.indexOf(f)
            );
            let sheetsNameList = [];
            let sheetsDataList = {};
            let csvData = [];
            let fileName = "";
            let wb = {};
            let excelBuffer;
            let blobData;

            allSortedKpiList.forEach((k) => {
                fileName = `${k}_${selectedNight}_${device_id}_${props.patient_info.patient_code
                    }.csv`;
                sheetsNameList = [];
                sheetsDataList = {};
                csvData = [];

                sheetsNameList.push(kpi_names[k]);

                analytics[k].ts.forEach((v, i) => {
                    csvData.push({
                        Timestamp: analytics[k].ts[i],
                        Value: analytics[k].dataset[i],
                    });
                });

                sheetsDataList[kpi_names[k]] = XLSX.utils.json_to_sheet(csvData);

                wb = {
                    SheetNames: [...sheetsNameList],
                    Sheets: { ...sheetsDataList },
                };

                excelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
                blobData = new Blob([excelBuffer], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                });
                FileSaver.saveAs(blobData, fileName);
            });

            set_show_loader(false);
        }, 1000);
    };

    const onChangeSelectedNight = (date) => {
        if (nights_available && Object.keys(nights_available).length > 0) {
            const calendarDate = Object.keys(nights_available).filter(
                (night) => (dayjs.utc(night * 1000).format('ddd MMM DD YYYY') === date.toDateString())
            );
            if (url_night !== calendarDate[0]) {
                props.history.push(
                    `/app/patients/id=${patient_info.user_id}?night=${calendarDate[0]}`
                );
            }
            //  set_selected_night(calendarDate[0]);
            reset();
        }
    };

    const onChangeTRDuration = (event) => {
        set_tv_duration(event);
        props.reset_tv_kpi_data();

        if (event.type !== "custom") {
            let addParam = 0;
            if (event.type === "days") {
                // addParam = 1;
            }

            // INFO: start_time should have 9PM and stop_time should have 9AM of next day
            let cal_start_date = dayjs()
                .subtract(parseInt(event.value) + addParam, event.type)
                .toDate();
            // const patient_create_date = patient_info && moment(patient_info.createdAt).toDate();
            const patient_create_date =
                patient_info &&
                dayjs(
                    dayjs(patient_info.createdAt).format("YYYY-MM-DD 00:00:00")
                ).toDate();
            if (cal_start_date < patient_create_date) {
                cal_start_date = patient_create_date;
            }
            set_tv_night_from(cal_start_date);

            const cal_start_end = dayjs()
                .subtract(1, "d")
                .toDate();
            set_tv_night_to(cal_start_end);

            let old_selected_tv_kpis = Object.keys(selected_tv_kpis);
            set_selected_tv_kpis({});
            set_trigger_reload(old_selected_tv_kpis);

            if (actigraph_view) {
                fetch_actigraph({
                    start_date: cal_start_date,
                    end_date: cal_start_end,
                    patient_id: patients.patient_info.user_id,
                    device_id: device_info.device_id,
                });
            }
        }
    };

    const onChangeSelectedNightFrom = (date) => {
        set_tv_night_from(date);
    };

    const onChangeSelectedNightTo = (date) => {
        set_tv_night_to(date);
        let old_selected_tv_kpis = Object.keys(selected_tv_kpis);
        set_selected_tv_kpis({});
        set_trigger_reload(old_selected_tv_kpis);

        if (actigraph_view) {
            fetch_actigraph({
                start_date: tv_night_from,
                end_date: date,
                patient_id: patients.patient_info.user_id,
                device_id: device_info.device_id,
            });
        }
    };

    const [selectedDiseases, setSelectedDiseases] = useState([]);
    const onSelectDisease = (event) => {
        if (patients.fetch_disease_list_data) {
            var disease = patients.fetch_disease_list_data.find(
                (d) => d.disease_description == event.currentTarget.dataset.value
            );
            let remove_none = false,
                remove_all_but_none = false,
                other_disease;

            if (disease) {
                // NOTE: don't update if nothing is selected
                if (!event.target.value.length) return;

                if (selectedDiseases.includes("None")) {
                    // NOTE: if event has none and another value selected remove none and select other values
                    if (
                        event.target.value.includes("None") &&
                        event.target.value.filter((v) => v !== "None").length
                    ) {
                        remove_none = true;
                        event.target.value = event.target.value.filter((v) => v !== "None");
                    }
                } else {
                    // NOTE: if incoming values have none and other values, toggle to none;
                    if (event.target.value.includes("None")) {
                        other_disease = event.target.value.filter((v) => v !== "None");
                        remove_all_but_none = true;
                        event.target.value = ["None"];
                    }
                }

                if (
                    JSON.stringify(event.target.value) !==
                    JSON.stringify(selectedDiseases)
                ) {
                    fetch_patient_disease({
                        patient_id: patients.patient_info.user_id,
                        type: "update",
                        disease_id: disease.disease_id,
                        docter_id: doctor_id,
                    });
                    if (remove_none) {
                        fetch_patient_disease({
                            patient_id: patients.patient_info.user_id,
                            type: "delete",
                            // NOTE: removes none whose ID is 1
                            disease_id: 1,
                            docter_id: doctor_id,
                        });
                    }
                    if (remove_all_but_none && other_disease && other_disease.length) {
                        for (let i = 0; i < other_disease.length; i++) {
                            const current_disease = patients.fetch_disease_list_data.find(
                                (d) => d.disease_description == other_disease[i]
                            );
                            fetch_patient_disease({
                                patient_id: patients.patient_info.user_id,
                                type: "delete",
                                disease_id: current_disease.disease_id,
                                docter_id: doctor_id,
                            });
                        }
                    }
                } else {
                    fetch_patient_disease({
                        patient_id: patients.patient_info.user_id,
                        type: "delete",
                        disease_id: disease.disease_id,
                        docter_id: doctor_id,
                    });
                }

                setSelectedDiseases(event.target.value);
            }
        }
    };

    const onDeleteDisease = (chip) => {
        const chipsData = [...selectedDiseases];
        const chipToDelete = chipsData.indexOf(chip);
        chipsData.splice(chipToDelete, 1);
        setSelectedDiseases(chipsData);
        if (patients.fetch_disease_list_data) {
            var disease = patients.fetch_disease_list_data.find(
                (d) => d.disease_description == chip
            );
            fetch_patient_disease({
                patient_id: patients.patient_info.user_id,
                type: "delete",
                disease_id: disease.disease_id,
                docter_id: doctor_id,
            });
        }
    };

    const generateSystemAnnotationsHandle = (type, kpi) => {
        const payloadData = {
            type: type,
            kpi: kpi,
            device_id: nights_available[selected_night][0].device_id,
            patient_id: patients.patient_info.user_id,
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            night: dayjs(selected_night * 1000).format("YYYY-MM-DD"),
            recording_date: nights_available[selected_night][0].recording_date,
        };

        generate_system_annotations(payloadData);
        set_show_system_annotations_flag(true);
        set_show_desaturations_flag(true);
    };

    const set_selected_night = async (night) => {
        select_night(night);
        set_selected_kpis({});

        const { device_id, recording_date } = nights_available[night][0];
        await fetch_available_kpis({
            device_id,
            patient_id: patient_info.user_id,
            recording_date,
        });

        await fetch_annotations({
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            patient_id: patient_info.user_id,
            night: dayjs
                .unix(night)
                .utc()
                .format(DATETIME_FORMAT),
            recording_date,
            device_id,
        });

        await generate_system_annotations({
            type: "system",
            kpi: "AP_timing",
            patient_id: patient_info.user_id,
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            night: dayjs
                .unix(night)
                .utc()
                .format("YYYY-MM-DD"),
            recording_date,
            device_id,
        });
        set_show_system_annotations_flag(true);

        await generate_system_annotations({
            type: "desaturation",
            kpi: "DSAT",
            patient_id: patient_info.user_id,
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            night: dayjs
                .unix(night)
                .utc()
                .format("YYYY-MM-DD"),
            recording_date,
            device_id,
        });
        set_show_desaturations_flag(true);

        await fetch_patients_rii_summary({
            device_id,
            night: dayjs
                .unix(night)
                .utc()
                .format("YYYY-MM-DD 05:30:00"),
            patient_id: patient_info.user_id,
        });
        // await fetch_patient_jira_cards_data({
        //   patient_code: patient_info.patient_code,
        // });
        set_show_loader(false);
    };

    const fetch_summary = async function (device_id, kpi, recording_date) {
        if (device_id != "" && kpi != "" && recording_date != "") {
            await fetch_patients_summary({
                patient_id: patient_info.user_id,
                device_id: device_id,
                recording_date: recording_date,
                kpi: kpi,
            });
        }
    };

    const calculateAnnotationValues = (allAnnotations) => {
        let values = {};

        if (Array.isArray(allAnnotations)) {
            for (let idx = 0; idx < allAnnotations.length; idx++) {
                if (allAnnotations[idx].type !== "system") {
                    switch (true) {
                        case allAnnotations[idx].label === "Apnea":
                            values["APN"] = values["APN"] ? (values["APN"] += 1) : 1;
                            break;
                        case allAnnotations[idx].label === "Hypoapnea":
                            values["AHI"] = values["AHI"] ? (values["AHI"] += 1) : 1;
                            break;
                        case allAnnotations[idx].label === "Movement":
                            values["MOV"] = values["MOV"] ? (values["MOV"] += 1) : 1;
                            break;
                        case allAnnotations[idx].label === "Central Apnea":
                            values["CAN"] = values["CAN"] ? (values["CAN"] += 1) : 1;
                            break;
                        case allAnnotations[idx].label === "Obstructive Apnea":
                            values["OBS"] = values["OBS"] ? (values["OBS"] += 1) : 1;
                            break;
                        case allAnnotations[idx].label === "Irregularities":
                            values["IRR"] = values["IRR"] ? (values["IRR"] += 1) : 1;
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return values;
    };

    const calculateRii = (allAnnotations, selectedRiiParameters) => {
        let selectedDenominator,
            otherValues = {},
            totalValue = 0,
            dividend;
        for (let idx = 0; idx < selectedRiiParameters.length; idx++) {
            if (!selectedDenominator && denominators[selectedRiiParameters[idx]]) {
                selectedDenominator = selectedRiiParameters[idx];
            } else {
                otherValues[selectedRiiParameters[idx]] = 0;
            }
        }

        const annotationValues = calculateAnnotationValues(allAnnotations);
        Object.keys(annotationValues).forEach((key) => {
            if (otherValues[key] !== undefined) {
                totalValue += annotationValues[key];
                otherValues[key] = annotationValues[key];
            }
        });

        if (Array.isArray(summary_table_8) && Array.isArray(summary_table_17)) {
            let denomObject;
            switch (selectedDenominator) {
                case "GSD":
                    denomObject = summary_table_8.find(
                        (v) => v.name === "Good Signal Duration"
                    );
                    break;
                case "TST":
                    denomObject = summary_table_8.find(
                        (v) => v.name === "Total Sleep Time"
                    );
                    break;
                case "TBT":
                    denomObject = summary_table_8.find(
                        (v) => v.name === "Total Bed Time"
                    );
                    break;
                case "TBR":
                    denomObject = summary_table_8.find(
                        (v) => v.name === "Total Breathing Time"
                    );
                    break;
                default:
                    break;
            }
            dividend = denomObject && denomObject.nightA ? denomObject.nightA : 0;
        }
        const calculated_ahi_value =
            dividend === 0 ? 0 : Math.round((totalValue / dividend) * 100) / 100;
        set_summary_table_10([
            createData(
                "Customized Index ",
                calculated_ahi_value === 0
                    ? 0
                    : calculated_ahi_value !== 0
                        ? calculated_ahi_value
                        : "-- : --",
                calculated_ahi_value === 0
                    ? 0
                    : calculated_ahi_value !== 0
                        ? calculated_ahi_value
                        : "-- : --"
            ),
        ]);
    };

    useEffect(
        () => {
            setRiiParameters(JSON.parse(rii_parameters || '["TBT"]'));
        },
        [rii_parameters]
    );

    useEffect(
        () => {
            calculateRii(annotations, riiParameters);
        },
        [annotations, summary_table_8]
    );

    useEffect(
        () => {
            let vitals_obj = {};
            if (patient_info !== null && patient_info.vital_parameters !== null) {
                vitals_obj = JSON.parse(patient_info.vital_parameters);
                set_vital_parameters(vitals_obj);
            } else {
                vitals_obj = {
                    spo2: { modFrom: "90", modTo: "93", sevFrom: "40", sevTo: "89" },
                    pr: {
                        modFromF: "100",
                        modToF: "120",
                        modFromS: "55",
                        modToS: "60",
                        sevFromF: "0",
                        sevToF: "55",
                        sevFromS: "120",
                        sevToS: "160",
                    },
                    br: {
                        modFromF: "10",
                        modToF: "12",
                        modFromS: "24",
                        modToS: "30",
                        sevFromF: "0",
                        sevToF: "10",
                        sevFromS: "30",
                        sevToS: "50",
                    },
                };
                set_vital_parameters(vitals_obj);
            }
        },
        [patient_info]
    );

    //Function to convert the svg image to blob for report footer
    async function convert() {
        let node = document.getElementById("foot");
        let node2 = document.getElementById("head");
        if (node != null) {
            const blob = await domtoimage.toBlob(node);
            let src = await URL.createObjectURL(new Blob([blob]));
            const blob2 = await domtoimage.toBlob(node2);
            let src2 = await URL.createObjectURL(new Blob([blob2]));
            set_foot(src);
            set_wave(src2);
        }
        if (isNotEmpty(node) && isNotEmpty(node2)) {
            node.remove();
            node2.remove();
        }
    }

    useEffect(
        () => {
            if (
                tv_kpis &&
                night_view === "multiple_night" &&
                nights_available &&
                Object.keys(nights_available).length > 0 &&
                tv_duration &&
                tv_night_from &&
                tv_night_to
            ) {
                if (fetching_tv_kpi_data) {
                    return;
                }

                if (trigger_reload && trigger_reload.length > 0) {
                    return;
                }
                let trendview_kpi_order_preference = {};
                if (
                    physician_info &&
                    physician_info.trendview_kpi_order_preference &&
                    physician_info.trendview_kpi_order_preference !== "" &&
                    physician_info.trendview_kpi_order_preference !== null
                ) {
                    trendview_kpi_order_preference = JSON.parse(
                        physician_info.trendview_kpi_order_preference
                    );
                    if (
                        Object.keys(trendview_kpi_order_preference)
                            .sort()
                            .toString() !== tv_kpis.sort().toString()
                    ) {
                        let trendview_kpi_preference_order = { ...kpi_preference };
                        let trendview_kpi_order_preference_array = Object.keys(
                            trendview_kpi_order_preference
                        );

                        Object.keys(trendview_kpi_preference_order).forEach((item) => {
                            if (
                                tv_kpis.indexOf(item) == -1 ||
                                trendview_kpi_order_preference_array.indexOf(item) == -1
                            ) {
                                if (
                                    tv_kpis.indexOf(item) !== -1 ||
                                    trendview_kpi_order_preference_array.indexOf(item) !== -1
                                ) {
                                    if (tv_kpis.indexOf(item) == -1) {
                                        delete trendview_kpi_order_preference[item];
                                    } else {
                                        trendview_kpi_order_preference[item] = true;
                                    }
                                }
                            }
                        });
                    }
                    //Auto Select for ODI
                    // if ((!tv_analytics || (tv_analytics && !tv_analytics['ODI'])) && (tv_kpis.indexOf('ODI') > -1) && props.membership_type !== "paid") {
                    //     select_tv_kpi('ODI');
                    //     return;
                    // }

                    set_show_loader(false);
                } else {
                    initial_tv_kpis.forEach((item) => {
                        trendview_kpi_order_preference[item] = true;
                    });
                }
                if (sorted_tv_kpis.length === 0) {
                    let sortedTVKpiList = Object.keys(kpi_names).filter(
                        (v) => -1 !== tv_kpis.indexOf(v)
                    );
                    sortedTVKpiList = Object.keys(trendview_kpi_order_preference).filter(
                        (element) => sortedTVKpiList.includes(element)
                    );
                    set_sorted_tv_kpis(sortedTVKpiList);
                    set_sorted_tv_array_kpis(trendview_kpi_order_preference);
                }

                set_show_loader(true);
                Object.keys(trendview_kpi_order_preference).forEach((item) => {
                    if (
                        (!tv_analytics || (tv_analytics && !tv_analytics[item])) &&
                        tv_kpis.indexOf(item) > -1 &&
                        !selected_tv_kpis[item]
                    ) {
                        if (trendview_kpi_order_preference[item]) {
                            select_tv_kpi(item);
                        }
                        return;
                    }

                    //Auto Select for ODI
                    // if (((!tv_analytics || (tv_analytics && !tv_analytics['ODI'])) && (tv_kpis.indexOf('ODI') > -1)) && ls.get('tv-kpi-' + doctor_id + '-' + patient_info.user_id + '-ODI') && !selected_tv_kpis['ODI'] && props.membership_type != "paid") {
                    //     select_tv_kpi('ODI');
                    //     return;
                    // }
                });
                set_show_loader(false);
            }
        },
        [night_view, fetching_tv_kpi_data]
    );

    useEffect(
        () => {
            if (kpi.ml_kpis && kpi.ml_kpis.summary) {
                const ml_kpis = kpi.ml_kpis.summary;

                Object.keys(ml_kpis).forEach((kpi) => {
                    const new_kpi = overviews[kpi];
                    new_kpi.value = ml_kpis[kpi] ? ml_kpis[kpi].toFixed(2) : "-- : --";
                    update_overviews({ ...overviews, [kpi]: new_kpi });
                });
            }
        },
        [kpi]
    );

    useEffect(
        () => {
            if (fetching_tv_kpi_data) {
                return;
            }

            set_show_loader(true);

            trigger_reload.forEach((item) => {
                if (!selected_tv_kpis[item]) {
                    select_tv_kpi(item);
                    return;
                }
            });

            set_show_loader(false);
        },
        [trigger_reload, fetching_tv_kpi_data]
    );

    useEffect(
        () => {
            if (fetching_actigraph) {
                set_show_loader(true);
            } else {
                set_show_loader(false);
            }
        },
        [fetching_actigraph]
    );

    useEffect(
        () => {
            set_sorted_actigraph_dates(actigraph_dates);
        },
        [actigraph_dates]
    );

    useEffect(
        () => {
            if (nights_available && Object.keys(nights_available).length > 0) {
                const nights_available_keys = Object.keys(nights_available);
                let night_value = Math.max(...nights_available_keys);
                if (
                    url_night &&
                    url_night !== "" &&
                    nights_available_keys.indexOf(url_night) > -1
                ) {
                    night_value = url_night;
                }
                set_selected_night(night_value);
            }
        },
        [nights_available]
    );

    useEffect(
        () => {
            if (
                nights_available &&
                Object.keys(nights_available).length > 0 &&
                selected_night
            ) {
                const { device_start_time, device_stop_time } = nights_available[
                    selected_night
                ][0];
                change_time("start", Number(device_start_time) * 1000);
                change_time("end", Number(device_stop_time) * 1000);
            }
        },
        [nights_available, selected_night]
    );

    useEffect(
        () => {
            if (props.patient_physician_id > 0) {
                fetch_disease_list({});
                fetch_annotation_categories({ doctor_id: props.patient_physician_id });
            }
        },
        [props.patient_physician_id]
    );

    useEffect(
        () => {
            setDiseaseList(patients.fetch_disease_list_data);
        },
        [patients.fetch_disease_list_data]
    );

    useEffect(
        () => {
            if (patients.patient_info) {
                fetch_patient_disease({
                    patient_id: patients.patient_info.user_id,
                    docter_id: props.is_annotator
                        ? props.patient_physician_id
                        : doctor_id,
                });
            }
        },
        [patients.patient_info]
    );

    const [upcomingCheckups, setUpcomingCheckups] = useState([]);
    useEffect(
        () => {
            if (
                patients.fetch_checkup_dates &&
                patients.fetch_checkup_dates.length > 0
            ) {
                let futureCheckups = [];
                let pastCheckups = [];
                let excludeCheckupDates = [];
                let upcomingchecklist = document.getElementById(
                    "upcoming-checkups-list"
                );
                let pastchecklist = document.getElementById("past-checkups-list");

                patients.fetch_checkup_dates.forEach((data) => {
                    if (data.mark_as_complete_flag == 0) {
                        futureCheckups.push(data);
                    } else {
                        pastCheckups.push(data);
                    }
                    if (
                        data.checkup_date >=
                        dayjs
                            .utc()
                            .toDate()
                            .toISOString()
                    ) {
                        excludeCheckupDates.push(dayjs.utc(data.checkup_date).toDate());
                    }
                });

                //ascending list as latest passed checkup date should be displayed
                pastCheckups.sort(
                    (a, b) => new Date(b.checkup_date) - new Date(a.checkup_date)
                );

                //descending list as latest upcoming checkup date should be displayed
                futureCheckups.sort(
                    (a, b) => new Date(a.checkup_date) - new Date(b.checkup_date)
                );

                setUpcomingCheckups(futureCheckups);
                patients.pastCheckups = pastCheckups;
                patients.unavailableDates = excludeCheckupDates;

                if (
                    upcomingchecklist &&
                    upcomingchecklist.classList.contains("in-progress")
                ) {
                    upcomingchecklist.classList.remove("in-progress");
                }
                if (pastchecklist && pastchecklist.classList.contains("in-progress")) {
                    pastchecklist.classList.remove("in-progress");
                }
            } else {
                patients.pastCheckups = [];
                patients.unavailableDates = [];
                setUpcomingCheckups([]);
            }
        },
        [patients.fetch_checkup_dates]
    );
    useEffect(
        () => {
            let initialMin = ls.get("initialMin");
            let initialMax = ls.get("initialMax");

            Highstock.charts.map((c) => {
                if (c && c.renderTo.id === "time-range-slider") {
                    let axis = c.xAxis[0];
                    if (selectedRange.present[1]) {
                        axis.setExtremes(
                            selectedRange.present[1],
                            selectedRange.present[0]
                        );
                    } else {
                        axis.setExtremes(initialMin, initialMax);
                    }
                }
            });
        },
        [selectedRange.present]
    );
    useEffect(
        () => {
            let patientDiseases = selectedDiseases;
            if (patients.fetch_patient_diseases_data) {
                patientDiseases = patients.fetch_patient_diseases_data.map(
                    (d) => d.disease_shortname
                );
            }
            setSelectedDiseases(patientDiseases);
        },
        [patients.fetch_patient_diseases_data]
    );

    useEffect(
        () => {
            if (props.patient_info !== null) {
                props.fetch_patient_comment({ id: props.patient_info.user_id });
                fetch_patient_medication_symptoms_history({
                    patient_id: props.patient_info.user_id,
                });
            }
        },
        [props.patient_info]
    );
    useEffect(
        () => {
            if (customTimeRange && customTimeRange.length == 2) {
                setSelectedRange(customTimeRange);

                if (night_view === "single_night") {
                    const { device_id, recording_date } = nights_available[
                        selected_night
                    ][0];

                    Object.keys(selected_kpis).forEach((kpi) => {
                        if (summaryKpisList.indexOf(kpi) > -1) {
                            fetch_summary(device_id, kpi, recording_date);
                        }
                    });

                    fetch_summary(device_id, "RECORDING", recording_date);
                }
            }
        },
        [customTimeRange]
    );

    useEffect(
        () => {
            let data = patients.fetch_patients_summary_data;
            if (
                nights_available &&
                Object.keys(nights_available).length > 0 &&
                selected_night
            ) {
                if (data && data.length > 0) {
                    if (data[0].kpi === "BR" && !preventResetDataTable.current["BR"]) {
                        preventResetDataTable.current = {
                            ...preventResetDataTable.current,
                            BR: true,
                        };
                        set_summary_table_1([
                            createData(
                                "Breathing Rate (Median)",
                                data[0].medianPercentile !== "null"
                                    ? data[0].medianPercentile
                                    : "-- : --",
                                data[0].medianPercentile ? data[0].medianPercentile : "-- : --"
                            ),
                            createData(
                                "LowerPercentile. Breathing Rate",
                                data[0].lowerPercentile !== "null"
                                    ? data[0].lowerPercentile
                                    : "-- : --",
                                data[0].lowerPercentile ? data[0].lowerPercentile : "-- : --"
                            ),
                            createData(
                                "UpperPercentile. Breathing Rate",
                                data[0].upperPercentile !== "null"
                                    ? data[0].upperPercentile
                                    : "-- : --",
                                data[0].upperPercentile ? data[0].upperPercentile : "-- : --"
                            ),
                        ]);
                    } else if (
                        data[0].kpi === "HR" &&
                        !preventResetDataTable.current["HR"]
                    ) {
                        preventResetDataTable.current = {
                            ...preventResetDataTable.current,
                            HR: true,
                        };
                        set_summary_table_2([
                            createData(
                                "Heart Rate Radar(Median)",
                                data[0].medianPercentile !== "null"
                                    ? data[0].medianPercentile
                                    : "-- : --",
                                data[0].medianPercentile ? data[0].medianPercentile : "-- : --"
                            ),
                            createData(
                                "LowerPercentile. Heart Rate Radar",
                                data[0].lowerPercentile !== "null"
                                    ? data[0].lowerPercentile
                                    : "-- : --",
                                data[0].lowerPercentile ? data[0].lowerPercentile : "-- : --"
                            ),
                            createData(
                                "UpperPercentile. Heart Rate Radar",
                                data[0].upperPercentile !== "null"
                                    ? data[0].upperPercentile
                                    : "-- : --",
                                data[0].upperPercentile ? data[0].upperPercentile : "-- : --"
                            ),
                        ]);
                    } else if (data[0].kpi === "MOV") {
                        set_summary_table_3([
                            createData(
                                "Restlessness-Index",
                                data[0].ri !== "null" ? data[0].ri : "-- : --",
                                data[0].ri ? data[0].ri : "-- : --"
                            ),
                        ]);
                    } else if (
                        data[0].kpi === "AHI" &&
                        props.membership_type !== "paid"
                    ) {
                        const ahi_value = data[0].ahi !== "null" ? data[0].ahi : "-- : --";
                        set_summary_table_5([createData("AHI", ahi_value, "-- : --")]);
                    } else if (
                        data[0].kpi === "ODI" &&
                        props.membership_type !== "paid"
                    ) {
                        const odi_value = data[0].odi !== "null" ? data[0].odi : "-- : --";
                        set_summary_table_12([
                            createData("Automated ODI", odi_value, "-- : --"),
                        ]);
                    } else if (
                        data[0].kpi === "SPO2" &&
                        !preventResetDataTable.current["SPO2"]
                    ) {
                        preventResetDataTable.current = {
                            ...preventResetDataTable.current,
                            SPO2: true,
                        };
                        set_summary_table_6([
                            createData(
                                "SPO2 (Median)",
                                data[0].medianPercentile !== "null"
                                    ? data[0].medianPercentile
                                    : "-- : --",
                                data[0].medianPercentile ? data[0].medianPercentile : "-- : --"
                            ),
                            createData(
                                "LowerPercentile. SPO2",
                                data[0].lowerPercentile !== "null"
                                    ? data[0].lowerPercentile
                                    : "-- : --",
                                data[0].lowerPercentile ? data[0].lowerPercentile : "-- : --"
                            ),
                            createData(
                                "UpperPercentile. SPO2",
                                data[0].upperPercentile !== "null"
                                    ? data[0].upperPercentile
                                    : "-- : --",
                                data[0].upperPercentile ? data[0].upperPercentile : "-- : --"
                            ),
                        ]);
                        set_spo2_details(data[0]);
                    } else if (
                        data[0].kpi === "PR" &&
                        !preventResetDataTable.current["PR"]
                    ) {
                        preventResetDataTable.current = {
                            ...preventResetDataTable.current,
                            PR: true,
                        };

                        set_summary_table_7([
                            createData(
                                "Pulse Rate (Median)",
                                data[0].medianPercentile !== "null"
                                    ? data[0].medianPercentile
                                    : "-- : --",
                                data[0].medianPercentile ? data[0].medianPercentile : "-- : --"
                            ),
                            createData(
                                "LowerPercentile. Pulse Rate",
                                data[0].lowerPercentile !== "null"
                                    ? data[0].lowerPercentile
                                    : "-- : --",
                                data[0].lowerPercentile ? data[0].lowerPercentile : "-- : --"
                            ),
                            createData(
                                "UpperPercentile. Pulse Rate",
                                data[0].upperPercentile !== "null"
                                    ? data[0].upperPercentile
                                    : "-- : --",
                                data[0].upperPercentile ? data[0].upperPercentile : "-- : --"
                            ),
                        ]);
                    } else if (data[0].kpi == "GSD") {
                        const gsd =
                            data[0].good_signal_duration !== null
                                ? data[0].good_signal_duration
                                : "-- : --";
                        const spo2_gsd =
                            data[0].total_good_oxygen_signal_duration !== null
                                ? data[0].total_good_oxygen_signal_duration
                                : "-- : --";
                        const todt =
                            data[0].total_oxygen_desaturation_time !== null
                                ? data[0].total_oxygen_desaturation_time
                                : "-- : --";
                        const tst =
                            data[0].total_sleep_time !== null
                                ? data[0].total_sleep_time
                                : "-- : --";
                        const tbt =
                            data[0].total_bed_time !== null
                                ? data[0].total_bed_time
                                : "-- : --";
                        const breathing_time =
                            data[0].total_breathing_time !== null
                                ? data[0].total_breathing_time
                                : "-- : --";
                        const bed_in =
                            data[0].bed_in_time !== null ? data[0].bed_in_time : "-- : --";
                        const bed_out =
                            data[0].bed_out_time !== null ? data[0].bed_out_time : "-- : --";
                        const awake_time =
                            data[0].total_awake_time !== null
                                ? data[0].total_awake_time
                                : "-- : --";
                        const waso =
                            data[0].waso !== null
                                ? data[0].waso === "undefined"
                                    ? "-- : --"
                                    : data[0].waso
                                : "-- : --";
                        const sol =
                            data[0].sol !== null
                                ? data[0].sol === "undefined"
                                    ? "-- : --"
                                    : data[0].sol
                                : "-- : --";
                        const se =
                            data[0].sleep_efficiency != null
                                ? data[0].sleep_efficiency
                                : data[0].sleep_efficiency_not_edited != null
                                    ? data[0].sleep_efficiency_not_edited
                                    : "-- : --";

                        set_summary_table_8([
                            createData("Good Signal Duration", gsd, "-- : --"),
                            createData("SpO2 Good Signal Duration", spo2_gsd, "-- : --"),
                            createData("Total Oxygen Desaturation Time", todt, "-- : --"),
                            createData(
                                "Total Sleep Time",
                                tst !== "null" ? tst : "-- : --",
                                tst !== "null" ? tst : "-- : --"
                            ),
                            createData("Total Breathing Time", breathing_time, "-- : --"),
                            createData("Sleep Awake", awake_time),
                            createData(
                                "Wake After Sleep Onset (mins) waso",
                                waso !== "undefined" ? waso : "-- : --",
                                "-- : --"
                            ),
                            createData(
                                "Sleep onset Latency",
                                sol !== "undefined" ? sol : "-- : --",
                                "-- : --"
                            ),
                            createData(
                                "Sleep Efficiency",
                                se !== "undefined" ? se : "-- : --",
                                "-- : --"
                            ),
                        ]);

                        set_summary_table_17([
                            createData(
                                "Total Bed Time",
                                tbt !== "null" ? tbt : "-- : --",
                                tbt !== "null" ? tbt : "-- : --"
                            ),
                            createData(
                                "Bed In Time",
                                bed_in !== "undefined" ? bed_in : "-- : --",
                                bed_in !== "undefined" ? bed_in : "-- : --"
                            ),
                            createData(
                                "Bed Out Time",
                                bed_out !== "undefined" ? bed_out : "-- : --",
                                bed_out !== "undefined" ? bed_out : "-- : --"
                            ),
                        ]);
                    }
                } else {
                    if (summary_table_3.length > 0) {
                        set_summary_table_3([
                            {
                                ...summary_table_3[0],
                                durationA: data[0] && data[0].ri ? data[0].ri : "-- : --",
                            },
                        ]);
                    }

                    set_summary_table_4(
                        summary_table_4.map((d) => {
                            if (d.name.indexOf("LO") >= 0) {
                                return {
                                    ...d,
                                    durationA:
                                        data[0] && data[0].lo
                                            ? dayjs(new Date(data[0].lo * 1000)).format("HH:mm")
                                            : "-- : --",
                                };
                            } else if (d.name.indexOf("TRT") >= 0) {
                                return {
                                    ...d,
                                    durationA: data[0] && data[0].trt ? data[0].trt : "-- : --",
                                };
                            }
                        })
                    );
                }
            }
        },
        [patients.fetch_patients_summary_data]
    );

    useEffect(
        () => {
            if (
                patients.patient_medication_symptoms_history &&
                patients.patient_medication_symptoms_history["symptoms"]
            ) {
                set_summary_table_14(
                    patients.patient_medication_symptoms_history["symptoms"]
                );
            }
            if (
                patients.patient_medication_symptoms_history &&
                patients.patient_medication_symptoms_history["medications"]
            ) {
                set_summary_table_15(
                    patients.patient_medication_symptoms_history["medications"]
                );
            }
            if (
                patients.patient_medication_symptoms_history &&
                patients.patient_medication_symptoms_history["diet_plan"]
            ) {
                set_summary_table_16(
                    patients.patient_medication_symptoms_history["diet_plan"]
                );
            }
        },
        [patients.patient_medication_symptoms_history]
    );

    //To compute dynamic summary
    const calcPercentile = (sortedArray, q) => {
        const pos = (sortedArray.length - 1) * q;
        const base = Math.floor(pos);
        const weight = pos % 1;
        if (base + 1 >= sortedArray.length) return sortedArray[base];
        return (
            sortedArray[base] + (sortedArray[base + 1] - sortedArray[base]) * weight
        );
        // = (sortedArray[base] * (1 - weight)) + (sortedArray[base + 1] * weight)
    };

    const calcDurationA = () => {
        const durationStart = Math.round(extremes["from"] / 1000); // extremes are the selected range
        const durationEnd = Math.round(extremes["to"] / 1000);
        if (durationStart !== durationEnd && analytics) {
            const KPIs = Object.keys(analytics);
            KPIs.forEach((kpi) => {
                if (
                    kpi === "BR" ||
                    kpi === "HR" ||
                    kpi === "SPO2" ||
                    kpi === "PR" ||
                    kpi === "TB" ||
                    kpi === "SA"
                ) {
                    const startIndex = analytics[kpi]["ts"].findIndex(
                        (t) => t >= durationStart
                    );
                    const endIndex = analytics[kpi]["ts"].findIndex(
                        (t) => t >= durationEnd
                    );
                    const selectedData = analytics[kpi]["dataset"].slice(
                        startIndex,
                        endIndex
                    );
                    const filteredData = selectedData.filter(function (value) {
                        return value !== null; //removing null values
                    });

                    // For percentile values
                    const sorted = filteredData.sort((a, b) => a - b);
                    const kpimean = calcPercentile(sorted, 0.5);
                    const kpimin = calcPercentile(sorted, 0.1);
                    const kpimax = calcPercentile(sorted, 0.9);
                    if (kpi === "BR") {
                        set_summary_table_1(
                            summary_table_1.map((d) => {
                                if (d.name.indexOf("Median") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimean ? kpimean : "-- : --",
                                    };
                                } else if (d.name.indexOf("UpperPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimax ? kpimax : "-- : --",
                                    };
                                } else if (d.name.indexOf("LowerPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimin ? kpimin : "-- : --",
                                    };
                                }
                            })
                        );
                    }

                    if (kpi === "HR") {
                        set_summary_table_2(
                            summary_table_2.map((d) => {
                                if (d.name.indexOf("Median") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimean ? kpimean : "-- : --",
                                    };
                                } else if (d.name.indexOf("UpperPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimax ? kpimax : "-- : --",
                                    };
                                } else if (d.name.indexOf("LowerPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimin ? kpimin : "-- : --",
                                    };
                                }
                            })
                        );
                    }

                    if (kpi === "SPO2") {
                        set_summary_table_6(
                            summary_table_6.map((d) => {
                                if (d.name.indexOf("Median") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimean ? kpimean : "-- : --",
                                    };
                                } else if (d.name.indexOf("UpperPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimax ? kpimax : "-- : --",
                                    };
                                } else if (d.name.indexOf("LowerPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimin ? kpimin : "-- : --",
                                    };
                                }
                            })
                        );
                    }

                    if (kpi === "PR") {
                        set_summary_table_7(
                            summary_table_7.map((d) => {
                                if (d.name.indexOf("Median") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimean ? kpimean : "-- : --",
                                    };
                                } else if (d.name.indexOf("UpperPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimax ? kpimax : "-- : --",
                                    };
                                } else if (d.name.indexOf("LowerPercentile") >= 0) {
                                    return {
                                        ...d,
                                        durationA: kpimin ? kpimin : "-- : --",
                                    };
                                }
                            })
                        );
                    }

                    if (kpi === "TB") {
                        set_summary_table_17(
                            summary_table_17.map((d) => {
                                if (d.name.indexOf("Total Bed Time") >= 0) {
                                    return {
                                        ...d,
                                        durationA:
                                            durationStart < durationEnd
                                                ? Number(durationEnd - durationStart) / 3600
                                                : "-- : --",
                                    };
                                } else if (d.name.indexOf("Bed In Time") >= 0) {
                                    return {
                                        ...d,
                                        durationA:
                                            durationStart < durationEnd
                                                ? dayjs
                                                    .unix(durationStart)
                                                    .utc()
                                                    .format("HH:mm:ss")
                                                : "-- : --",
                                    };
                                } else if (d.name.indexOf("Bed Out Time") >= 0) {
                                    return {
                                        ...d,
                                        durationA:
                                            durationStart < durationEnd
                                                ? dayjs
                                                    .unix(durationEnd)
                                                    .utc()
                                                    .format("HH:mm:ss")
                                                : "-- : --",
                                    };
                                } else {
                                    return {
                                        ...d,
                                    };
                                }
                            })
                        );
                    }

                    if (kpi === "SA") {
                        set_summary_table_8(
                            summary_table_8.map((d) => {
                                if (d.name.indexOf("Total Sleep Time") >= 0) {
                                    return {
                                        ...d,
                                        durationA:
                                            durationStart < durationEnd
                                                ? Number(durationEnd - durationStart) / 3600
                                                : "-- : --",
                                    };
                                } else {
                                    return {
                                        ...d,
                                    };
                                }
                            })
                        );
                    }
                }
            });
        }
    };

    useEffect(
        () => {
            calcDurationA();
        },
        [rangeFrom, rangeTo]
    );

    useEffect(
        () => {
            let data1 = kpi.fetch_patients_rii_summary_data;
            if (data1 && data1.latest_weight) {
                set_summary_table_13([{ weight: data1.latest_weight }]);
            }
            if (data1 && data1.rii_odi_calculation_result) {
                data1 = data1.rii_odi_calculation_result;
            }
            if (data1 && data1.length > 0) {
                if (data1 && data1.length > 0) {
                    if (data1[0].rii_value != 0 || data1[0].rii_value != null) {
                        set_summary_table_9([
                            createData(
                                "RII (Respiratory Irregularity Index)",
                                data1[0].rii_value ? data1[0].rii_value : "-- : --",
                                data1[0].rii_value ? data1[0].rii_value : "-- : --"
                            ),
                        ]);
                    }

                    if (available_kpis && available_kpis.includes("SPO2")) {
                        if (data1[1].odi_value != 0 || data1[1].odi_value != null) {
                            set_summary_table_11([
                                createData(
                                    "ODI",
                                    data1[1].odi_value ? data1[1].odi_value : "-- : --",
                                    data1[1].odi_value ? data1[1].odi_value : "-- : --"
                                ),
                            ]);
                        }
                    }
                }
            } else {
                set_summary_table_9(
                    summary_table_9.map((d) => {
                        if (
                            d.name.indexOf("ahi_value") != null &&
                            d.name.indexOf("ahi_value") != 0
                        ) {
                            return {
                                ...d,
                                durationA: data1 && data1[0] && data1[0].ahi_value,
                            };
                        }
                    })
                );
            }
        },
        [kpi.fetch_patients_rii_summary_data, patients.fetch_patients_summary_data]
    );

    useEffect(
        () => {
            if (
                nights_available &&
                Object.keys(nights_available).length > 0 &&
                selected_night &&
                available_kpis &&
                available_kpis.length > 0
            ) {
                if (fetching_available_kpis || fetching_kpi_data) {
                    return;
                }

                let kpi_order_preference = {};
                if (
                    physician_info.kpi_order_preference &&
                    physician_info.kpi_order_preference !== "" &&
                    physician_info.kpi_order_preference !== null
                ) {
                    kpi_order_preference = JSON.parse(
                        physician_info.kpi_order_preference
                    );

                    if (
                        Object.keys(kpi_order_preference)
                            .sort()
                            .toString() !== available_kpis.sort().toString()
                    ) {
                        let kpi_preference_order = { ...kpi_preference };
                        let kpi_order_preference_array = Object.keys(kpi_order_preference);

                        Object.keys(kpi_preference_order).forEach((item) => {
                            if (
                                available_kpis.indexOf(item) == -1 ||
                                kpi_order_preference_array.indexOf(item) == -1
                            ) {
                                if (
                                    available_kpis.indexOf(item) !== -1 ||
                                    kpi_order_preference_array.indexOf(item) !== -1
                                ) {
                                    if (available_kpis.indexOf(item) == -1) {
                                        delete kpi_order_preference[item];
                                    } else {
                                        kpi_order_preference[item] = true;
                                    }
                                }
                            }
                        });
                    }
                } else {
                    kpi_order_preference = { ...kpi_preference };
                    Object.keys(kpi_order_preference).forEach((item) => {
                        if (available_kpis.indexOf(item) == -1) {
                            delete kpi_order_preference[item];
                        }
                    });
                }

                if (sorted_kpis.length === 0) {
                    let sortedKpiList = Object.keys(kpi_names).filter(
                        (v) => -1 !== available_kpis.indexOf(v)
                    );
                    sortedKpiList = Object.keys(kpi_order_preference).filter((element) =>
                        sortedKpiList.includes(element)
                    );
                    set_sorted_kpis(sortedKpiList);
                    set_sorted_array_kpis(kpi_order_preference);
                }

                set_show_loader(true);

                let kpiLocalStorage = true;
                available_kpis.map((item) => {
                    if (
                        Object.keys(kpi_names).indexOf(item) > -1 &&
                        ls.get(
                            "kpi-" + doctor_id + "-" + patient_info.user_id + "-" + item
                        ) === null
                    ) {
                        kpiLocalStorage = false && kpiLocalStorage;
                    }
                });

                // if (
                //   (!analytics || (analytics && !analytics["SQB"])) &&
                //   (non_graph_available_kpis &&
                //     non_graph_available_kpis.indexOf("SQB") > -1)
                // ) {
                //   select_sqb_kpi();
                //   return;
                // }

                // if (!kpiLocalStorage) {
                //   if (
                //     kpi_order_preference.SLP_STGS &&
                //     (!analytics || (analytics && !analytics["SLP_STGS"])) &&
                //     available_kpis.indexOf("SLP_STGS") > -1
                //   ) {
                //     select_kpi("SLP_STGS");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.Y_DIST &&
                //     (!analytics || (analytics && !analytics["Y_DIST"])) &&
                //     available_kpis.indexOf("Y_DIST") > -1
                //   ) {
                //     select_kpi("Y_DIST");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.MOV &&
                //     (!analytics || (analytics && !analytics["MOV"])) &&
                //     available_kpis.indexOf("MOV") > -1
                //   ) {
                //     select_kpi("MOV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.BR &&
                //     (!analytics || (analytics && !analytics["BR"])) &&
                //     available_kpis.indexOf("BR") > -1
                //   ) {
                //     select_kpi("BR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.BRV &&
                //     (!analytics || (analytics && !analytics["BRV"])) &&
                //     available_kpis.indexOf("BRV") > -1
                //   ) {
                //     select_kpi("BRV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.HR &&
                //     (!analytics || (analytics && !analytics["HR"])) &&
                //     available_kpis.indexOf("HR") > -1
                //   ) {
                //     select_kpi("HR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.HRV &&
                //     (!analytics || (analytics && !analytics["HRV"])) &&
                //     available_kpis.indexOf("HRV") > -1
                //   ) {
                //     select_kpi("HRV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.SPO2 &&
                //     (!analytics || (analytics && !analytics["SPO2"])) &&
                //     available_kpis.indexOf("SPO2") > -1
                //   ) {
                //     select_kpi("SPO2");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.PR &&
                //     (!analytics || (analytics && !analytics["PR"])) &&
                //     available_kpis.indexOf("PR") > -1
                //   ) {
                //     select_kpi("PR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.I &&
                //     (!analytics || (analytics && !analytics["I"])) &&
                //     available_kpis.indexOf("I") > -1
                //   ) {
                //     select_kpi("I");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.Q &&
                //     (!analytics || (analytics && !analytics["Q"])) &&
                //     available_kpis.indexOf("Q") > -1
                //   ) {
                //     select_kpi("Q");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.IQ &&
                //     (!analytics || (analytics && !analytics["IQ"])) &&
                //     available_kpis.indexOf("IQ") > -1
                //   ) {
                //     select_kpi("IQ");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.SA &&
                //     (!analytics || (analytics && !analytics["SA"])) &&
                //     available_kpis.indexOf("SA") > -1
                //   ) {
                //     select_kpi("SA");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.TB &&
                //     (!analytics || (analytics && !analytics["TB"])) &&
                //     available_kpis.indexOf("TB") > -1
                //   ) {
                //     select_kpi("TB");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.bp &&
                //     (!analytics || (analytics && !analytics["bp"])) &&
                //     available_kpis.indexOf("bp") > -1
                //   ) {
                //     select_kpi("bp");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.blood_sugar &&
                //     (!analytics || (analytics && !analytics["blood_sugar"])) &&
                //     available_kpis.indexOf("blood_sugar") > -1
                //   ) {
                //     select_kpi("blood_sugar");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.body_temp &&
                //     (!analytics || (analytics && !analytics["body_temp"])) &&
                //     available_kpis.indexOf("body_temp") > -1
                //   ) {
                //     select_kpi("body_temp");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.NC_PSG &&
                //     (!analytics || (analytics && !analytics["NC_PSG"])) &&
                //     available_kpis.indexOf("NC_PSG") > -1
                //   ) {
                //     select_kpi("NC_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.THRX_PSG &&
                //     (!analytics || (analytics && !analytics["THRX_PSG"])) &&
                //     available_kpis.indexOf("THRX_PSG") > -1
                //   ) {
                //     select_kpi("THRX_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.ABD_PSG &&
                //     (!analytics || (analytics && !analytics["ABD_PSG"])) &&
                //     available_kpis.indexOf("ABD_PSG") > -1
                //   ) {
                //     select_kpi("ABD_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.SPO2_PSG &&
                //     (!analytics || (analytics && !analytics["SPO2_PSG"])) &&
                //     available_kpis.indexOf("SPO2_PSG") > -1
                //   ) {
                //     select_kpi("SPO2_PSG");
                //     return;
                //   }
                set_show_loader(false);
                // } else {
                //   if (
                //     kpi_order_preference.SLP_STGS &&
                //     kpi_order_preference.SLP_STGS &&
                //     ((!analytics || (analytics && !analytics["SLP_STGS"])) &&
                //       available_kpis.indexOf("SLP_STGS") > -1) &&
                //     !selected_kpis["SLP_STGS"]
                //   ) {
                //     select_kpi("SLP_STGS");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.Y_DIST &&
                //     kpi_order_preference.Y_DIST &&
                //     ((!analytics || (analytics && !analytics["Y_DIST"])) &&
                //       available_kpis.indexOf("Y_DIST") > -1) &&
                //     !selected_kpis["Y_DIST"]
                //   ) {
                //     select_kpi("Y_DIST");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.MOV &&
                //     ((!analytics || (analytics && !analytics["MOV"])) &&
                //       available_kpis.indexOf("MOV") > -1) &&
                //     !selected_kpis["MOV"]
                //   ) {
                //     select_kpi("MOV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.BR &&
                //     ((!analytics || (analytics && !analytics["BR"])) &&
                //       available_kpis.indexOf("BR") > -1) &&
                //     !selected_kpis["BR"]
                //   ) {
                //     select_kpi("BR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.BRV &&
                //     ((!analytics || (analytics && !analytics["BRV"])) &&
                //       available_kpis.indexOf("BRV") > -1) &&
                //     !selected_kpis["BRV"]
                //   ) {
                //     select_kpi("BRV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.HR &&
                //     ((!analytics || (analytics && !analytics["HR"])) &&
                //       available_kpis.indexOf("HR") > -1) &&
                //     !selected_kpis["HR"]
                //   ) {
                //     select_kpi("HR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.HRV &&
                //     ((!analytics || (analytics && !analytics["HRV"])) &&
                //       available_kpis.indexOf("HRV") > -1) &&
                //     !selected_kpis["HRV"]
                //   ) {
                //     select_kpi("HRV");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.SPO2 &&
                //     ((!analytics || (analytics && !analytics["SPO2"])) &&
                //       available_kpis.indexOf("SPO2") > -1) &&
                //     !selected_kpis["SPO2"]
                //   ) {
                //     select_kpi("SPO2");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.PR &&
                //     ((!analytics || (analytics && !analytics["PR"])) &&
                //       available_kpis.indexOf("PR") > -1) &&
                //     !selected_kpis["PR"]
                //   ) {
                //     select_kpi("PR");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.I &&
                //     ((!analytics || (analytics && !analytics["I"])) &&
                //       available_kpis.indexOf("I") > -1) &&
                //     !selected_kpis["I"]
                //   ) {
                //     select_kpi("I");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.Q &&
                //     ((!analytics || (analytics && !analytics["Q"])) &&
                //       available_kpis.indexOf("Q") > -1) &&
                //     !selected_kpis["Q"]
                //   ) {
                //     select_kpi("Q");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.IQ &&
                //     ((!analytics || (analytics && !analytics["IQ"])) &&
                //       available_kpis.indexOf("IQ") > -1) &&
                //     !selected_kpis["IQ"]
                //   ) {
                //     select_kpi("IQ");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.SA &&
                //     ((!analytics || (analytics && !analytics["SA"])) &&
                //       available_kpis.indexOf("SA") > -1) &&
                //     !selected_kpis["SA"]
                //   ) {
                //     select_kpi("SA");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.TB &&
                //     ((!analytics || (analytics && !analytics["TB"])) &&
                //       available_kpis.indexOf("TB") > -1) &&
                //     !selected_kpis["TB"]
                //   ) {
                //     select_kpi("TB");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.bp &&
                //     ((!analytics || (analytics && !analytics["bp"])) &&
                //       available_kpis.indexOf("bp") > -1) &&
                //     !selected_kpis["bp"]
                //   ) {
                //     select_kpi("bp");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.body_temp &&
                //     ((!analytics || (analytics && !analytics["body_temp"])) &&
                //       available_kpis.indexOf("body_temp") > -1) &&
                //     !selected_kpis["body_temp"]
                //   ) {
                //     select_kpi("body_temp");
                //     return;
                //   }

                //   if (
                //     kpi_order_preference.blood_sugar &&
                //     ((!analytics || (analytics && !analytics["blood_sugar"])) &&
                //       available_kpis.indexOf("blood_sugar") > -1) &&
                //     !selected_kpis["blood_sugar"]
                //   ) {
                //     select_kpi("blood_sugar");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.NC_PSG &&
                //     ((!analytics || (analytics && !analytics["NC_PSG"])) &&
                //       available_kpis.indexOf("NC_PSG") > -1) &&
                //     !selected_kpis["NC_PSG"]
                //   ) {
                //     select_kpi("NC_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.THRX_PSG &&
                //     ((!analytics || (analytics && !analytics["THRX_PSG"])) &&
                //       available_kpis.indexOf("THRX_PSG") > -1) &&
                //     !selected_kpis["THRX_PSG"]
                //   ) {
                //     select_kpi("THRX_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.ABD_PSG &&
                //     ((!analytics || (analytics && !analytics["ABD_PSG"])) &&
                //       available_kpis.indexOf("ABD_PSG") > -1) &&
                //     !selected_kpis["ABD_PSG"]
                //   ) {
                //     select_kpi("ABD_PSG");
                //     return;
                //   }
                //   if (
                //     kpi_order_preference.SPO2_PSG &&
                //     ((!analytics || (analytics && !analytics["SPO2_PSG"])) &&
                //       available_kpis.indexOf("SPO2_PSG") > -1) &&
                //     !selected_kpis["SPO2_PSG"]
                //   ) {
                //     select_kpi("SPO2_PSG");
                //     return;
                //   }
                set_show_loader(false);
                // }

                if (
                    non_graph_available_kpis &&
                    non_graph_available_kpis.indexOf("AHI") > -1 &&
                    props.membership_type !== "paid"
                ) {
                    fetch_ahi_summary();
                    fetch_odi_summary();
                }
                if (
                    non_graph_available_kpis &&
                    non_graph_available_kpis.indexOf("GSD" > -1)
                ) {
                    fetch_gsd_summary();
                }
            }
        },
        [
            nights_available,
            selected_night,
            fetching_available_kpis,
            available_kpis,
            //   fetching_kpi_data,
            physician_info,
        ]
    ); //,kpi_order

    const deleteAnnotationHandler = (id) => {
        const status = window.confirm("Are you sure to delete this annotation ?");
        if (!status) {
            return false;
        }
        const { device_id, recording_date } = nights_available[selected_night][0];
        const annotation = annotations.find((a) => (a.annotation_map_id = id));
        const data = {
            ...annotation,
            start_time: dayjs.utc(annotation.startDate).format(DATETIME_FORMAT),
            end_time: dayjs.utc(annotation.endDate).format(DATETIME_FORMAT),
            updated_date: dayjs.utc().format(DATETIME_FORMAT),
            patient_id: patient_info.user_id,
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            delete_flag: 1,
            device_id,
            recording_date,
        };

        edit_annotation(data);
    };

    const getAnnotation = (a) => {
        let kpiList = [];
        a.kpi.split(",").forEach((k) => {
            kpiList.push(kpi_names[k]);
        });
        const duration = a.duration.split(":");
        return (
            <div
                className="annotation-item"
                key={"annotation-item-" + a.annotation_map_id}
            >
                <div className="annotation-title">
                    <span
                        className="annotation-name red"
                        style={{ background: a.color_code }}
                    >
                        {a.label}
                    </span>
                    <div>
                        <span
                            className="delete-annotation"
                            title="Delete"
                            onClick={() => deleteAnnotationHandler(a.annotation_map_id)}
                        >
                            <img src={icon_delete} alt="Icon" />
                        </span>
                        <span
                            className="edit-annotation"
                            title="Edit"
                            onClick={() => showEditAnnotationPopup(a.annotation_map_id)}
                        >
                            <img src={icon_edit} alt="Icon" />
                        </span>
                    </div>
                </div>
                <div
                    className="annotation-info-content"
                    onClick={() => showViewAnnotationPopup(a.annotation_map_id)}
                >
                    <div className="annotation-info">
                        <span className="annotation-label">Channels</span>
                        <span className="annotation-value">
                            {props.is_annotator
                                ? kpiList.join(", ")
                                : kpiList.filter((k) => k !== "IQ").join(", ")}
                        </span>
                    </div>
                    <div className="annotation-info">
                        <span className="annotation-label">Start time</span>
                        <span className="annotation-value">
                            {dayjs.utc(a.start_date).format("HH:mm:ss")}
                        </span>
                    </div>
                    <div className="annotation-info">
                        <span className="annotation-label">End time</span>
                        <span className="annotation-value">
                            {dayjs.utc(a.end_date).format("HH:mm:ss")}
                        </span>
                    </div>
                    <div className="annotation-info">
                        <span className="annotation-label">Duration</span>
                        <span className="annotation-value">
                            {duration[0] + "hr " + duration[1] + "min " + duration[2] + "sec"}
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    useEffect(
        () => {
            if (
                !fetching_annotations &&
                night_view === "single_night" &&
                show_annotations_sidebar_flag
            ) {
                let selected_region_annotations = [];
                let annotationSidebarSubContentList =
                    annotations &&
                    annotations.length > 0 &&
                    annotations.map((a) => {
                        if (extremes.from && extremes.to) {
                            const startDate = dayjs.utc(a.start_date).format(DATETIME_FORMAT);
                            const endDate = dayjs.utc(a.end_date).format(DATETIME_FORMAT);
                            const extremesFrom = dayjs
                                .utc(extremes.from)
                                .format(DATETIME_FORMAT);
                            const extremesTo = dayjs.utc(extremes.to).format(DATETIME_FORMAT);

                            if (
                                (startDate >= extremesFrom && endDate <= extremesTo) ||
                                //annotation end date is greater then selected time range from but less than selected time range to
                                //overlapes at starting
                                (endDate > extremesFrom && startDate < extremesFrom) ||
                                //annotation start date is less then selected time range to but end date is greater then selected time range to
                                //overlapes at ending
                                (endDate > extremesTo && startDate < extremesTo)
                            ) {
                                selected_region_annotations.push(a);
                                return getAnnotation(a);
                            }
                        } else {
                            return getAnnotation(a);
                        }
                    });
                set_selected_multiple_annotations(selected_region_annotations);
                annotationSidebarSubContentList = annotationSidebarSubContentList
                    ? annotationSidebarSubContentList.filter((a) => a)
                    : [];
                const apnea_events_count = [];
                const custom_annotations_count = [];
                const desaturation_events_count = [];
                const custom_desaturations_count = [];
                selected_region_annotations.forEach((a) => {
                    if (a.type === "system" || a.type === "system-edit") {
                        apnea_events_count.push(a);
                    }
                });
                selected_region_annotations.forEach((a) => {
                    if (a.type === "custom" && a.color_code !== "#EE814C") {
                        custom_annotations_count.push(a);
                    }
                });
                selected_region_annotations.forEach((a) => {
                    if (a.type === "desaturation" && a.color_code === "#EE814C") {
                        desaturation_events_count.push(a);
                    }
                });
                selected_region_annotations.forEach((a) => {
                    if (a.type === "custom" && a.color_code === "#EE814C") {
                        custom_desaturations_count.push(a);
                    }
                });
                if (
                    !annotationSidebarSubContentList ||
                    annotationSidebarSubContentList.length === 0
                ) {
                    annotationSidebarSubContentList = (
                        <div className="no-data">No annotations available.</div>
                    );
                } else if (annotations.filter((a) => a.type === "custom").length) {
                    annotationSidebarSubContentList = (
                        <>
                            <div className="delete-all-annotations">
                                <Button
                                    className="my-3"
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => {
                                        setConfirmDelDialog(true);
                                        setConfirmDialogType("delete-custom");
                                    }}
                                >
                                    <DeleteIcon fontSize="small" />
                                    DELETE CUSTOM
                                </Button>
                            </div>
                            {annotationSidebarSubContentList}
                        </>
                    );
                }

                if (annotations.length) {
                    annotationSidebarSubContentList = (
                        <>
                            {selected_region_annotations &&
                                selected_region_annotations.length ? (
                                <div className="delete-all-annotations">
                                    <Button
                                        className="my-3"
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        onClick={() => {
                                            setConfirmDelDialog(true);
                                            setConfirmDialogType("delete-multiple");
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                        DELETE SELECTED
                                    </Button>
                                </div>
                            ) : null}
                            {apnea_events_count && apnea_events_count.length ? (
                                <div className="delete-all-annotations">
                                    <Button
                                        className="my-3"
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        onClick={() => {
                                            setConfirmDelDialog(true);
                                            setConfirmDialogType("delete-system");
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                        DELETE SYSTEM
                                    </Button>
                                </div>
                            ) : null}
                            {apnea_events_count.length || custom_annotations_count.length ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="125px">
                                                <IntlMessages id="so.annotationsCount" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="35px">
                                                System Annotations: {apnea_events_count.length}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="35px">
                                                Custom Annotations: {custom_annotations_count.length}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            ) : null}
                            {desaturation_events_count && desaturation_events_count.length ? (
                                <div className="delete-all-annotations">
                                    <Button
                                        className="my-3"
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        onClick={() => {
                                            setConfirmDelDialog(true);
                                            setConfirmDialogType("delete-desaturation");
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                        DELETE DESATURATION
                                    </Button>
                                </div>
                            ) : null}
                            {desaturation_events_count.length ||
                                custom_desaturations_count.length ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="125px">
                                                <IntlMessages id="so.desaturationsCount" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="35px">
                                                System Desaturations: {desaturation_events_count.length}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="35px">
                                                Custom Desaturations:{" "}
                                                {custom_desaturations_count.length}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            ) : null}
                            {annotationSidebarSubContentList}
                        </>
                    );
                }

                if (!fetching_kpi_data) {
                    setAnnotationSidebarSubContent(annotationSidebarSubContentList);
                }
            }
        },
        [
            extremes,
            selectedRange,
            annotate_range,
            customTimeRange,
            fetching_kpi_data,
            show_annotations_sidebar_flag,
            fetching_annotations,
        ]
    );

    useEffect(
        () => {
            if (selected_night && night_view === "single_night") {
                const formatted_date = dayjs
                    .unix(selected_night)
                    .utc()
                    .format("YYYY-MM-DD");
                fetch_patients_qna_response({
                    patient_id: props.patient_info.user_id,
                    date: formatted_date,
                });
            }
        },
        [selected_night]
    );

    useEffect(
        () => {
            if (
                patients.fetch_comment_data &&
                pageNumber !== 1 &&
                pageNumber >
                Math.ceil(patients.fetch_comment_data.length / commentsPerPage)
            ) {
                setPageNumber(
                    Math.ceil(patients.fetch_comment_data.length / commentsPerPage)
                );

                setLastComment(firstComment);
                setFirstComment(Number(firstComment) - Number(commentsPerPage));
            }
        },
        [patients.fetch_comment_data]
    );

    const [chartImgMOV, set_chartImgMOV] = useState("");
    const [chartImgBR, set_chartImgBR] = useState("");
    const [chartImgYDIST, set_chartImgYDIST] = useState("");
    const [chartImgHR, set_chartImgHR] = useState("");
    const [chartImgBRV, set_chartImgBRV] = useState("");
    const [chartImgHRV, set_chartImgHRV] = useState("");
    const [chartImgSPO2, set_chartImgSPO2] = useState("");
    const [chartImgBP, set_chartImgBP] = useState("");
    const [chartImgBloodSugar, set_chartBloodSugar] = useState("");
    const [chartImgBodyTemperature, set_chartImgBodyTemperature] = useState("");
    const [chartImgWeight, set_chartImgWeight] = useState("");
    const [chartImgPR, set_chartImgPR] = useState("");
    const [chartImgSQ, set_chartImgSQ] = useState("");
    const [chartImgRII, set_chartImgRII] = useState("");
    const [chartImgSA, set_chartImgSA] = useState("");
    const [chartImgTB, set_chartImgTB] = useState("");
    const [riiCharts, setRIICharts] = useState("");
    const [riiDECharts, setRiiDECharts] = useState("");
    const [singleriiCharts, setSingleRIICharts] = useState("");
    const [chartImgSE, set_chartImgSE] = useState("");
    const [seCharts, setSECharts] = useState("");
    const [singleSECharts, setSingleSECharts] = useState("");
    const [chartImgODI, set_chartImgODI] = useState("");
    const [chartImgSPO2TV, set_chartImgSPO2TV] = useState("");
    const [chartImgAg, set_chartImgAg] = useState("");

    const textStyle = `
    color: #8F8F8F;
    cursor: default;
    font-size: 10px;
    font-family: Nunito;
    fill: #8F8F8F;`;

    async function convertToImg(elm, setFunc) {
        let node = document.getElementById(elm);
        if (node !== "" && node != null) {
            if (elm === "charts-TV" || elm === "charts-AG") {
                let imgGroup = [];
                node.removeAttribute("style");
                const promiseArray = Object.values(node.children).map(async (d) => {
                    let temp = {};
                    let node5 = d.getElementsByTagName("text");

                    if (node5.length > 0) {
                        Object.keys(node5).forEach((d) => {
                            node5[d].setAttribute("style", "font-size:14px;");
                        });
                    }
                    let date =
                        d.firstElementChild.firstElementChild.firstElementChild.innerHTML;
                    d.firstElementChild.firstElementChild.firstElementChild.style =
                        "display:none;";
                    const blob = await domtoimage.toBlob(d);
                    if (blob != null) {
                        temp.graphDate = date;
                        temp.url = await URL.createObjectURL(new Blob([blob]));
                        imgGroup.push(temp);
                    }
                    if (node5.length > 0) {
                        Object.keys(node5).forEach((d) => {
                            node5[d].setAttribute("style", textStyle);
                        });
                    }
                });
                await Promise.all(promiseArray);
                await setFunc(imgGroup);
                if (elm === "charts-TV") {
                    node.setAttribute("style", "display:none;");
                }
                return imgGroup;
            } else {
                let node2 = node.getElementsByClassName("collapse-chart-details")[0];
                let node3 = node.getElementsByClassName("icon drag-icon")[0];
                let node4 = node.getElementsByClassName("graph-title")[0];
                let node5 = node.getElementsByTagName("text");
                if (node5.length > 0) {
                    Object.keys(node5).forEach((d) => {
                        node5[d].setAttribute("style", "font-size:14px;");
                    });
                }
                node2.setAttribute("style", "display:none;");
                node3.setAttribute("style", "display:none;");
                node4.setAttribute("style", "font-size:17px;font-weight:800;");

                const blob = await domtoimage.toBlob(node);
                let src = await URL.createObjectURL(new Blob([blob]));

                node2.removeAttribute("style");
                node3.removeAttribute("style");
                node4.removeAttribute("style");
                if (node5.length > 0) {
                    Object.keys(node5).forEach((d) => {
                        node5[d].setAttribute("style", textStyle);
                    });
                }
                await setFunc(src);
                return src;
            }
        } else {
            node = null;
            return "";
        }
    }

    const asyncIterable = {
        //'chart-MOV': set_chartImgMOV,
        "chart-BR": set_chartImgBR,
        //'chart-Y_DIST': set_chartImgYDIST,
        "chart-HR": set_chartImgHR,
        //'chart-BRV': set_chartImgBRV,
        //'chart-HRV': set_chartImgHRV,
        "chart-SPO2": set_chartImgSPO2,
        "charts-AG": set_chartImgAg,

        "charts-TV": set_chartImgSPO2TV,
        "chart-PR": set_chartImgPR,
        "chart-SQ": set_chartImgSQ,
        "chart-RII": set_chartImgRII,
        //'chart-SA': set_chartImgSA,
        // 'chart-TB': set_chartImgTB,
        "chart-SE": set_chartImgSE,
        // 'chart-ODI': set_chartImgODI,
        "chart-bp": set_chartImgBP,
        "chart-body_temp": set_chartImgBodyTemperature,
        "chart-blood_sugar": set_chartBloodSugar,
        "chart-weight": set_chartImgWeight,

        [Symbol.asyncIterator]: function () {
            const keys = Object.keys(this);
            let i = 0;
            return {
                next: () => {
                    if (i == keys.length)
                        return Promise.resolve({ value: null, done: true });

                    return Promise.resolve({
                        value: [keys[i], this[keys[i++]]],
                        done: false,
                    });
                },
            };
        },
    };

    async function generate_rii_slider() {
        // Create a dom element in document
        const rii_slider_holder = document.createElement("div");
        rii_slider_holder.setAttribute("id", "rii-slider-holder");
        document.body.appendChild(rii_slider_holder);

        let rii_data = props.kpi.tv_analytics["RII"],
            rii_components = {};
        const rii_slider_ids = {};
        rii_data = rii_data.filter((v) => v.rii);
        rii_data.slice(Math.max(rii_data.length - 5, 0)).forEach((rii, i) => {
            rii_components[rii.night] = (
                <RiiSlider
                    key={String(rii.date) + i}
                    rii={rii.editedrii ? rii.editedrii : rii.rii}
                    id={String(rii.date)}
                />
            );
            // push slider ids
            rii_slider_ids[dayjs(rii.night).format("YYYY-MM-DD")] =
                "#rii-slider-" + rii.date;
        });
        // DOM render array of components
        ReactDOM.render(
            Object.values(rii_components),
            document.querySelector("#rii-slider-holder")
        );

        const sliders = {};
        for (let slider_date in rii_slider_ids) {
            let node = document.querySelector(rii_slider_ids[slider_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            sliders[slider_date] = URL.createObjectURL(blob);
        }

        setRIICharts(sliders);
        // remove graph from ui
        return document.body.removeChild(rii_slider_holder);
    }

    async function generate_rii_de_slider() {
        // Create a dom element in document
        const rii_de_slider_holder = document.createElement("div");
        rii_de_slider_holder.setAttribute("id", "rii-de-slider-holder");
        document.body.appendChild(rii_de_slider_holder);
        let rii_de_data = tv_analytics["RII"],
            rii_de_components = {};
        const rii_de_slider_ids = {};

        rii_de_data = rii_de_data.filter((v) => v.rii);
        // rii_de_data.slice(Math.max(rii_de_data.length - 10, 0))
        rii_de_data.forEach((rii, i) => {
            rii_de_components[rii.night] = (
                <RIIDESlider
                    key={String(rii.date) + i}
                    rii_de={
                        rii.editedrii ? Math.round(rii.editedrii) : Math.round(rii.rii)
                    }
                    id={String(rii.date)}
                />
            );
            // push slider ids
            rii_de_slider_ids[rii.night] = "#rii-de-slider-" + rii.date;
        });

        // DOM render array of components
        ReactDOM.render(
            Object.values(rii_de_components),
            document.querySelector("#rii-de-slider-holder")
        );

        const sliders = {};
        for (let slider_date in rii_de_slider_ids) {
            let node = document.querySelector(rii_de_slider_ids[slider_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            sliders[slider_date] = URL.createObjectURL(blob);
        }
        setRiiDECharts(sliders);
        // remove graph from ui
        return document.body.removeChild(rii_de_slider_holder);
    }

    async function generate_oneNight_rii_slider(data) {
        // Create a dom element in document
        const rii_slider_holder = document.createElement("div");
        rii_slider_holder.setAttribute("id", "rii-slider-holder");
        document.body.appendChild(rii_slider_holder);

        let rii_data = data,
            rii_components = {};
        let date = nights_available[selected_night][0].device_start_time * 1000;
        const rii_slider_ids = {};
        rii_data.slice(Math.max(rii_data.length - 5, 0)).forEach((rii, i) => {
            if (typeof rii.durationA != "number") {
                rii.durationA = 0;
            }
            rii_components[date] = (
                <RiiSlider
                    key={String(date) + i}
                    rii={
                        rii.editeddurationA
                            ? Math.round(rii.editeddurationA)
                            : Math.round(rii.durationA)
                    }
                    id={String(date)}
                />
            );
            // push slider ids
            rii_slider_ids[date] = "#rii-slider-" + date;
        });

        // DOM render array of components
        ReactDOM.render(
            Object.values(rii_components),
            document.querySelector("#rii-slider-holder")
        );

        const sliders = {};
        for (let slider_date in rii_slider_ids) {
            let node = document.querySelector(rii_slider_ids[slider_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            sliders[slider_date] = URL.createObjectURL(blob);
        }

        setSingleRIICharts(sliders);
        // remove graph from ui
        return document.body.removeChild(rii_slider_holder);
    }

    async function generate_oneNight_de_rii_slider(data) {
        // Create a dom element in document
        const rii_de_slider_holder = document.createElement("div");
        rii_de_slider_holder.setAttribute("id", "rii-de-slider-holder");
        document.body.appendChild(rii_de_slider_holder);

        let rii_de_data = data,
            rii_de_components = {};
        let date = nights_available[selected_night][0].device_start_time * 1000;
        const rii_de_slider_ids = {};

        rii_de_data.slice(Math.max(rii_de_data.length - 5, 0)).forEach((rii, i) => {
            if (typeof rii.durationA != "number") {
                rii.durationA = 0;
            }
            rii_de_components[date] = (
                <RIIDESlider
                    key={String(date) + i}
                    rii_de={
                        rii.editeddurationA
                            ? Math.round(rii.editeddurationA)
                            : Math.round(rii.durationA)
                    }
                    id={String(date)}
                />
            );
            // push slider ids
            rii_de_slider_ids[date] = "#rii-de-slider-" + date;
        });

        // DOM render array of components
        ReactDOM.render(
            Object.values(rii_de_components),
            document.querySelector("#rii-de-slider-holder")
        );

        const sliders = {};
        for (let slider_date in rii_de_slider_ids) {
            let node = document.querySelector(rii_de_slider_ids[slider_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            sliders[slider_date] = URL.createObjectURL(blob);
        }
        setRiiDECharts(sliders);
        // remove graph from ui
        return document.body.removeChild(rii_de_slider_holder);
    }

    async function generate_se_circle() {
        // Create a dom element in document
        const se_circle_bar = document.createElement("div");
        se_circle_bar.setAttribute("id", "se-circle-bar");
        document.body.appendChild(se_circle_bar);
        let se_data = props.kpi.tv_analytics["SE"],
            se_components = {};
        const se_circle_ids = {};
        se_data = se_data.filter((v) => v.sleep_efficiency);
        se_data.slice(Math.max(se_data.length - 5, 0)).forEach((se, i) => {
            se_components[se.date] = (
                <SeCircle
                    key={String(se.date) + i}
                    se={se.sleep_efficiency}
                    id={String(se.date)}
                />
            );
            // push slider ids
            se_circle_ids[se.date] = "#se-circle-" + se.date;
        });

        // DOM render array of components
        ReactDOM.render(
            Object.values(se_components),
            document.querySelector("#se-circle-bar")
        );

        const se_circles = {};
        for (let se_circe_date in se_circle_ids) {
            let node = document.querySelector(se_circle_ids[se_circe_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            se_circles[se_circe_date] = URL.createObjectURL(blob);
        }

        setSECharts(se_circles);
        // remove graph from ui
        return document.body.removeChild(se_circle_bar);
    }

    async function generate_single_se_circle() {
        // Create a dom element in document
        const se_circle_bar = document.createElement("div");
        se_circle_bar.setAttribute("id", "se-circle-bar");
        document.body.appendChild(se_circle_bar);
        let se_data = props.kpi.tv_analytics["SE"],
            se_components = {};
        const se_circle_ids = {};
        se_data = se_data.filter((v) => v.sleep_efficiency);
        se_data.slice(Math.max(se_data.length - 5, 0)).forEach((se, i) => {
            se_components[se.date] = (
                <SeCircle
                    key={String(se.date) + i}
                    se={se.sleep_efficiency}
                    id={String(se.date)}
                />
            );
            // push slider ids
            se_circle_ids[se.date] = "#se-circle-" + se.date;
        });

        // DOM render array of components
        ReactDOM.render(
            Object.values(se_components),
            document.querySelector("#se-circle-bar")
        );

        const se_circles = {};
        for (let se_circe_date in se_circle_ids) {
            let node = document.querySelector(se_circle_ids[se_circe_date]);
            // Create a image copy of the components
            const blob = await domtoimage.toBlob(node);
            // assign according to date-ids
            se_circles[se_circe_date] = URL.createObjectURL(blob);
        }

        setSingleSECharts(se_circles);
        // remove graph from ui
        return document.body.removeChild(se_circle_bar);
    }

    function deleteAllManualAnnotations() {
        let ids;
        if (confirm_dialog_type === "delete-system") {
            ids = annotations
                .filter((a) => a.type === "system" || a.type === "system-edit")
                .map((a) => a.annotation_map_id);
        } else if (confirm_dialog_type === "delete-desaturation") {
            ids = annotations
                .filter((a) => a.type === "desaturation")
                .map((a) => a.annotation_map_id);
        } else if (confirm_dialog_type === "delete-multiple") {
            ids = selected_multiple_annotations.map((a) => a.annotation_map_id);
        } else {
            ids = annotations
                .filter((a) => a.type === "custom")
                .map((a) => a.annotation_map_id);
        }
        const { device_id, recording_date } = nights_available[selected_night][0];
        props.delete_annotations({
            ids,
            recording_date,
            device_id,
            doctor_id: props.is_annotator ? props.patient_physician_id : doctor_id,
            patient_id: patient_info.user_id,
            night: dayjs
                .unix(selected_night)
                .utc()
                .format(DATETIME_FORMAT),
        });
        setConfirmDelDialog(false);
    }

    const reset_chartImgs = () => {
        set_chartImgMOV("");
        set_chartImgBR("");
        set_chartImgYDIST("");
        set_chartImgHR("");
        set_chartImgBRV("");
        set_chartImgHRV("");
        set_chartImgSPO2("");
        set_chartImgSPO2TV("");
        set_chartImgPR("");
        set_chartImgSQ("");
        set_chartImgRII("");
        set_chartImgSA("");
        set_chartImgTB("");
        set_chartImgSA("");
        set_chartImgAg("");
        setRIICharts("");
        setRiiDECharts("");
        setSingleRIICharts("");
        set_chartImgSE("");
        set_chartImgODI("");
        set_chartBloodSugar("");
        set_chartImgBodyTemperature("");
        set_chartImgBP("");
        setSECharts("");
        setSingleSECharts("");
    };
    // Graph image plotting on PDF Report End

    const change_time = (type, value) => {
        if (type === "start") {
            change_start_time(value);
        } else {
            change_end_time(value);
        }
        // set_graph_visiblity(false)
    };

    const add_checkup = async (date) => {
        await add_checkup_date({
            patient_id: patients.patient_info.user_id,
            doctor_id: doctor_id,
            checkup_date: date,
        });
        setCheckupDate(dayjs.utc().toDate());
    };

    const markCheckUpDate = async (checkupId) => {
        let upcomingchecklist = document.getElementById("upcoming-checkups-list");
        let pastchecklist = document.getElementById("past-checkups-list");
        if (upcomingchecklist) {
            upcomingchecklist.classList.add("in-progress");
        }
        if (pastchecklist) {
            pastchecklist.classList.add("in-progress");
        }
        await checkup_mark_as_complete({
            patient_id: patients.patient_info.user_id,
            doctor_id: doctor_id,
            checkup_date_id: checkupId,
        });
    };

    const select_kpi = (kpi, required_to_sort_array_kpis = false, multiple) => {
        if (windowViewActive) {
            setWindowViewActive(false);
        }
        if (required_to_sort_array_kpis) {
            const new_sorted_array_kpis = { ...sorted_array_kpis };
            for (const [key, value] of Object.entries(new_sorted_array_kpis)) {
                if (key === kpi) {
                    new_sorted_array_kpis[kpi] = !value;
                }
            }
            set_sorted_array_kpis(new_sorted_array_kpis);
        }
        const {
            device_start_time,
            device_stop_time,
            device_id,
            recording_date,
        } = nights_available[selected_night][0];

        if (multiple && Array.isArray(kpi) && selected_night) {
            fetch_s3_kpi_data({
                graph_type: [...kpi, "SQB"],
                multiple,
                device_start_time: device_start_time,
                device_stop_time: device_stop_time,
                recording_date: recording_date,
                patient_id: patient_info.user_id,
                device_id: device_id,
            });
            const new_selected_kpis = {};
            kpi.forEach((v) => {
                new_selected_kpis[v] = true;
                if (summaryKpisList.indexOf(v) > -1) {
                    fetch_summary(device_id, v, recording_date);
                }
            });
            set_selected_kpis(new_selected_kpis);
        } else {
            const new_selected_kpis = { ...selected_kpis };
            if (selected_kpis[kpi]) {
                delete new_selected_kpis[kpi];
                if (kpi == "BR") {
                    preventResetDataTable.current = {
                        ...preventResetDataTable.current,
                        BR: false,
                    };
                    set_summary_table_1([]);
                }
                if (kpi == "HR") {
                    preventResetDataTable.current = {
                        ...preventResetDataTable.current,
                        HR: false,
                    };
                    set_summary_table_2([]);
                }
                if (kpi == "MOV") {
                    set_summary_table_3([]);
                }
                if (kpi == "SPO2") {
                    preventResetDataTable.current = {
                        ...preventResetDataTable.current,
                        SPO2: false,
                    };
                    set_summary_table_6([]);
                }
                if (kpi == "PR") {
                    preventResetDataTable.current = {
                        ...preventResetDataTable.current,
                        PR: false,
                    };
                    set_summary_table_7([]);
                }
            } else {
                if (selected_night) {
                    const { device_id, recording_date } = nights_available[
                        selected_night
                    ][0];
                    if (summaryKpisList.indexOf(kpi) > -1) {
                        fetch_summary(device_id, kpi, recording_date);
                    }
                    new_selected_kpis[kpi] = true;
                }
            }

            set_selected_kpis(new_selected_kpis);

            ls.set(
                "kpi-" + doctor_id + "-" + patient_info.user_id + "-" + kpi,
                new_selected_kpis[kpi] ? new_selected_kpis[kpi] : false
            );

            if (new_selected_kpis[kpi]) {
                // fetch_kpi_data({
                //     graph_type: kpi,
                //     device_start_time: nights_available[selected_night][0].device_start_time,
                //     device_stop_time: nights_available[selected_night][0].device_stop_time,
                //     recording_date: nights_available[selected_night][0].recording_date,
                //     patient_id: patient_info.user_id,
                //     device_id: nights_available[selected_night][0].device_id,
                // });
                fetch_s3_kpi_data({
                    graph_type: kpi,
                    device_start_time:
                        nights_available[selected_night][0].device_start_time,
                    device_stop_time:
                        nights_available[selected_night][0].device_stop_time,
                    recording_date: nights_available[selected_night][0].recording_date,
                    patient_id: patient_info.user_id,
                    device_id: nights_available[selected_night][0].device_id,
                });
            }
        }
        if (
            props.kpi.tv_analytics == null &&
            night_view === "single_night" &&
            selected_night
        ) {
            fetch_tv_kpi_data({
                graph_type: "SE",
                patient_id: patient_info.user_id,
                device_start_time:
                    nights_available[selected_night][0].device_start_time,
                device_stop_time: nights_available[selected_night][0].device_stop_time,
            });
        }

        reset_chartImgs();
    };

    // eslint-disable-next-line no-unused-vars
    const select_sqb_kpi = () => {
        // fetch_kpi_data({
        //     graph_type: 'SQB',
        //     device_start_time: nights_available[selected_night][0].device_start_time,
        //     device_stop_time: nights_available[selected_night][0].device_stop_time,
        //     recording_date: nights_available[selected_night][0].recording_date,
        //     patient_id: patient_info.user_id,
        //     device_id: nights_available[selected_night][0].device_id,
        // });
        fetch_s3_kpi_data({
            graph_type: "SQB",
            device_start_time: nights_available[selected_night][0].device_start_time,
            device_stop_time: nights_available[selected_night][0].device_stop_time,
            recording_date: nights_available[selected_night][0].recording_date,
            patient_id: patient_info.user_id,
            device_id: nights_available[selected_night][0].device_id,
        });
    };

    const onRiiParametersChange = (values) => {
        const denominators = { GSD: true, TST: true, TBT: true, TBR: true };
        const hasDenominator = values.filter((v) => denominators[v]);
        if (hasDenominator.length > 1) {
            const filteredDenoms = riiParameters.filter((v) => denominators[v]);
            setRiiParameters(values.filter((v) => !filteredDenoms.includes(v)));
            calculateRii(
                annotations,
                values.filter((v) => !filteredDenoms.includes(v))
            );
        } else if (hasDenominator.length) {
            setRiiParameters(values);
            calculateRii(annotations, values);
        }
    };

    const select_tv_kpi = (kpi) => {
        if (kpi === "ODI" && props.membership_type === "paid") {
            return;
        }
        const new_selected_kpis = { ...selected_tv_kpis };
        if (selected_tv_kpis[kpi]) {
            delete new_selected_kpis[kpi];
            set_trigger_reload([]);
        } else {
            new_selected_kpis[kpi] = true;
        }

        set_selected_tv_kpis(new_selected_kpis);

        ls.set(
            "tv-kpi-" + doctor_id + "-" + patient_info.user_id + "-" + kpi,
            new_selected_kpis[kpi] ? new_selected_kpis[kpi] : false
        );

        const calc_tv_night = {
            from:
                dayjs(tv_night_from)
                    .set({ hour: 9, minute: 0, second: 0 })
                    .toDate()
                    .getTime() / 1000,
            to:
                dayjs(tv_night_to)
                    .set({ hour: 9, minute: 0, second: 0 })
                    .toDate()
                    .getTime() / 1000,
        };

        if (typeof kpi !== "object" && new_selected_kpis[kpi]) {
            fetch_tv_kpi_data({
                graph_type: kpi,
                patient_id: patient_info.user_id,
                device_start_time: Math.round(calc_tv_night.from).toString(),
                device_stop_time: Math.round(calc_tv_night.to).toString(),
            });
        }
    };

    const fetch_ahi_summary = () => {
        const { device_id, recording_date } = nights_available[selected_night][0];
        fetch_summary(device_id, "AHI", recording_date);
    };

    const fetch_odi_summary = () => {
        if (nights_available) {
            const { device_id, recording_date } = nights_available[selected_night][0];
            fetch_summary(device_id, "ODI", recording_date);
        }
    };

    const select_actigraph_dates = (date) => {
        const new_selected_actigraph_dates = { ...selected_actigraph_dates };
        if (selected_actigraph_dates[date]) {
            delete new_selected_actigraph_dates[date];
            // set_trigger_reload([])
        } else {
            new_selected_actigraph_dates[date] = true;
        }

        set_selected_actigraph_dates(new_selected_actigraph_dates);
    };

    const fetch_gsd_summary = () => {
        const { device_id, recording_date } = nights_available[selected_night][0];
        fetch_summary(device_id, "GSD", recording_date);
    };

    useEffect(
        () => {
            if (available_kpis && available_kpis.includes("SPO2")) {
                fetch_odi_summary();
            }
        },
        [available_kpis]
    );

    const [diseaseList, setDiseaseList] = useState([]);
    const [comment, set_comment] = useState({ commentText: "" });
    const [diseaseMenuOpenFlag, setDiseaseMenuOpenFlag] = useState(false);

    const diseaseMenuToggle = () => {
        setDiseaseMenuOpenFlag(!diseaseMenuOpenFlag);
        if (!diseaseMenuOpenFlag) {
            setDiseaseList(patients.fetch_disease_list_data);
        }
    };

    const add_comment = async () => {
        const { user_id } = patient_info;
        var { commentText, id } = comment;
        //performing replace operations to support the single quotes and backslashes
        let inputText = commentText.replace(/\\/g, "\\\\");
        inputText = inputText.replace(/'/g, "\\'");

        const input_data = { user_id, comment: inputText };

        const commentFromList = patients.fetch_comment_data.find(
            (c) => c.id === id
        );

        set_comment({ commentText: "" });
        commentInputRef.current.blur();

        if (!id) {
            await props.add_patient_comment(input_data);
        } else if (id && commentFromList.comment !== inputText) {
            await props.update_patient_comment({
                ...input_data,
                id: id,
                updated_date: dayjs.utc().toDate(),
            });
        } else {
            return;
        }
    };

    const delete_comment = async (id) => {
        const { user_id } = patient_info;
        if (window.confirm("Are you sure you want to delete this comment?")) {
            patients.fetch_comment_data = patients.fetch_comment_data.filter(
                (c) => c.id !== id
            );
            await props.delete_patient_comment({ id: id, user_id });
        }
    };

    const onSubmitComment = (e) => {
        if (e.keyCode == 13 && e.target.value.trim() !== "") {
            add_comment();
            e.preventDefault();
        }
    };

    const get_mean = (e) => {
        const processedYData = e.target.series[0].processedYData;

        let count = 0;
        let total = 0;

        processedYData.forEach((p) => {
            if (p && !isNaN(p)) {
                total += p;
                count++;
            }
        }, 0);

        const mean = total / count;

        return Math.floor(mean * 100) / 100;
    };

    if (!patient_info) return null;

    let nightList;
    if (nights_available && Object.keys(nights_available).length > 0) {
        nightList = Object.keys(nights_available).map(
            (date) =>
                new Date(
                    dayjs(date * 1000)
                        .utc()
                        .format("MMMM DD, YYYY HH:mm:ss")
                )
        );
    }

    const CustomDateInput = forwardRef(({ value }, ref) => (
        <button
            className="custom-date-input"
            onMouseDown={() => {
                let calendarBlock = document.querySelector(".calendar-block");
                let isOpen =
                    calendarBlock &&
                    calendarBlock.querySelector(".react-datepicker-popper");
                nightCalendarRef.current.setOpen(!isOpen);
            }}
            ref={ref}
        >
            {value}
        </button>
    ));

    const CustomFromDateInput = forwardRef(({ value }, ref) => (
        <button
            disabled={!tv_duration || (tv_duration && tv_duration.type !== "custom")}
            className={
                "custom-from-date-input " +
                (!tv_duration || (tv_duration && tv_duration.type !== "custom")
                    ? " disabled "
                    : "")
            }
            onMouseDown={() => {
                let calendarBlock = document.querySelector(".duration-calendar-from");
                let isOpen =
                    calendarBlock &&
                    calendarBlock.querySelector(".react-datepicker-popper");
                nightFromCalendarRef.current.setOpen(!isOpen);
            }}
            ref={ref}
        >
            {value ? value : "Select Date"}
        </button>
    ));

    const CustomToDateInput = forwardRef(({ value }, ref) => (
        <button
            disabled={!tv_duration || (tv_duration && tv_duration.type !== "custom")}
            className={
                "custom-to-date-input " +
                (!tv_duration || (tv_duration && tv_duration.type !== "custom")
                    ? " disabled "
                    : "")
            }
            onMouseDown={() => {
                let calendarBlock = document.querySelector(".duration-calendar-to");
                let isOpen =
                    calendarBlock &&
                    calendarBlock.querySelector(".react-datepicker-popper");
                nightToCalendarRef.current.setOpen(!isOpen);
            }}
            ref={ref}
        >
            {value ? value : "Select Date"}
        </button>
    ));

    const AddCheckUpLink = forwardRef(({ onClick }, ref) => (
        <div
            id="addCheckUpLink"
            className="checkup-link"
            onClick={onClick}
            ref={ref}
        >
            Add Checkup
        </div>
    ));

    const ActionButton = forwardRef(() => (
        <div className="calendar-footer">
            <div
                className="btn cancel-btn"
                onClick={() => {
                    checkUpCalendarRef.current.setOpen(false);
                    setCheckupDate(dayjs.utc().toDate());
                }}
            >
                CANCEL
            </div>
            <div
                className="btn ok-btn"
                onClick={() => {
                    add_checkup(checkupDate);
                    checkUpCalendarRef.current.setOpen(false);
                }}
            >
                ADD
            </div>
        </div>
    ));
    const togglePatientDetails = () => {
        const patientDetails = document.getElementById("patient-details");
        for (let i = 0; i < patientDetails.classList.length; i = i + 1) {
            if (patientDetails.classList[i] === "hidden") {
                patientDetails.classList.remove("hidden");
                return;
            }
        }

        patientDetails.classList.add("hidden");
    };

    const getLoaderContent = () => {
        return (
            <div
                style={!isOpenReportDownloadDialog ? { position: "absolute" } : null}
                className={"loader-overlay"}
            >
                <div className="full-page-loader">
                    <div className="custom-loader">
                        <img src={image_loader} alt="Loading" />
                    </div>
                    <div className="loader-text">Please wait...</div>
                </div>
            </div>
        );
    };

    const handleCalendarClose = () => {
        const calendarButton = document.querySelector(".custom-date-input");
        calendarButton.classList.remove("calendar-open");
    };
    const handleCalendarOpen = () => {
        const calendarButton = document.querySelector(".custom-date-input");
        calendarButton.classList.add("calendar-open");
    };

    const handleFromCalendarClose = () => {
        const calendarButton = document.querySelector(".custom-from-date-input");
        calendarButton.classList.remove("calendar-open");
    };
    const handleFromCalendarOpen = () => {
        if (tv_duration && tv_duration.type === "custom") {
            const calendarButton = document.querySelector(".custom-from-date-input");
            calendarButton.classList.add("calendar-open");
        }
    };

    const handleToCalendarClose = () => {
        const calendarButton = document.querySelector(".custom-to-date-input");
        calendarButton.classList.remove("calendar-open");
    };
    const handleToCalendarOpen = () => {
        if (tv_duration && tv_duration.type === "custom") {
            const calendarButton = document.querySelector(".custom-to-date-input");
            calendarButton.classList.add("calendar-open");
        }
    };

    const toggleArtifectsOnGraphs = () => {
        set_show_artifects_flag(!show_artifects_flag);
    };

    const togglePlotbandsOnGraphs = () => {
        set_show_plotbands(!show_plotbands);
    };

    const toggleAnnotatoinsSidebar = () => {
        const graphContainer = document.querySelector("#graph-container");

        if (!show_annotations_sidebar_flag) {
            graphContainer.classList.add("active");
        } else {
            graphContainer.classList.remove("active");
        }

        set_show_annotations_sidebar_flag(!show_annotations_sidebar_flag);
    };

    const light_opacity = "0.2";
    const medium_opacity = "0.4";
    const annotation_colours = [
        {
            label: "",
            value: "#3C3C3C",
            dark: "rgba(60, 60, 60, 1)",
            light: `rgba(60, 60, 60, ${light_opacity})`,
            medium: `rgba(60, 60, 60, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#959595",
            dark: "rgba(149, 149, 149, 1)",
            light: `rgba(149, 149, 149, ${light_opacity})`,
            medium: `rgba(149, 149, 149, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#B4AAD6",
            dark: "rgba(180, 170, 214, 1)",
            light: `rgba(180, 170, 214, ${light_opacity})`,
            medium: `rgba(180, 170, 214, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#521CAE",
            dark: "rgba(82, 28, 174, 1)",
            light: `rgba(82, 28, 174, ${light_opacity})`,
            medium: `rgba(82, 28, 174, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#DA7171",
            dark: "rgba(218, 113, 113, 1)",
            light: `rgba(218, 113, 113, ${light_opacity})`,
            medium: `rgba(218, 113, 113, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#E1D356",
            dark: "rgba(225, 211, 86, 1)",
            light: `rgba(225, 211, 86, ${light_opacity})`,
            medium: `rgba(225, 211, 86, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#44B477",
            dark: "rgba(68, 180, 119, 1)",
            light: `rgba(68, 180, 119, ${light_opacity})`,
            medium: `rgba(68, 180, 119, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#EE814C",
            dark: "rgba(238, 129, 76, 1)",
            light: `rgba(238, 129, 76, ${light_opacity})`,
            medium: `rgba(238, 129, 76, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#927B71",
            dark: "rgb(191, 172, 172, 1)",
            light: `rgba(191, 172, 172, ${light_opacity})`,
            medium: `rgba(191, 172, 172, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#8B3B3B",
            dark: "rgba(139, 59, 59, 1)",
            light: `rgba(139, 59, 59, ${light_opacity})`,
            medium: `rgba(139, 59, 59, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#B5D8ED",
            dark: "rgba(181,216,237)",
            light: `rgba(181, 216, 237, ${light_opacity})`,
            medium: `rgba(181, 216, 237, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#0F4473",
            dark: "rgba(15,68,115)",
            light: `rgba(15,68,115, ${light_opacity})`,
            medium: `rgba(15,68,115, ${medium_opacity})`,
        },
        {
            label: "",
            value: "#E4E0F0",
            dark: "rgba(228,224,240)",
            light: `rgba(228,224,240, ${light_opacity})`,
            medium: `rgba(228,224,240, ${medium_opacity})`,
        },
    ];

    const showEditAnnotationPopup = (id) => {
        set_view_annotation_flag(false);

        let annotation = {};
        annotations.map((a) => {
            if (a.annotation_map_id === id) {
                annotation = a;
            }
        });

        set_selected_annotation(annotation);
        set_annotation_map_id(id);
        set_edit_annotation_flag(true);
        set_annotate(true);
    };

    const showViewAnnotationPopup = (id) => {
        set_edit_annotation_flag(false);

        let annotation = {};
        annotations.map((a) => {
            if (a.annotation_map_id === id) {
                annotation = a;
            }
        });

        set_selected_annotation(annotation);
        set_annotation_map_id(id);
        set_view_annotation_flag(true);
        set_annotate(true);
    };

    const saveKpiPreferenceData = (kpiArray) => {
        set_sorted_array_kpis(kpiArray);
    };
    const saveTVKpiPreferenceData = (kpiTVArray) => {
        set_sorted_tv_array_kpis(kpiTVArray);
    };

    const textMaxLength = 1024 * 10;

    let tv_max_from_date = dayjs()
        .subtract(1, "d")
        .toDate();
    if (
        tv_night_to &&
        tv_max_from_date >
        dayjs(tv_night_to)
            .subtract(1, "d")
            .toDate()
    ) {
        tv_max_from_date = dayjs(tv_night_to)
            .subtract(1, "d")
            .toDate();
    }
    const saveChannelsObj = () => {
        set_show_loader(true);
        update_kpi_preference({
            new_sorted_array_kpis: JSON.stringify(sorted_array_kpis),
            physician_id: doctor_id,
        });
        setTimeout(() => {
            set_show_loader(false);
        }, 1000);
    };
    const save_trend_view_kpi_preference = () => {
        var new_preference_trendview_kpi = {};
        Object.keys(sorted_tv_array_kpis).forEach((item) => {
            if (selected_tv_kpis[item]) {
                new_preference_trendview_kpi[item] = true;
            } else {
                new_preference_trendview_kpi[item] = false;
            }
        });

        set_show_loader(true);
        update_trendview_kpi_preference({
            new_sorted_array_trendview_kpis: JSON.stringify(
                new_preference_trendview_kpi
            ),
            physician_id: doctor_id,
        });
        setTimeout(() => {
            set_show_loader(false);
        }, 1000);
    };

    const RPMReport = () => {
        return (
            <LazyPatientReportRPM
                data={props}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                reportComment={reportComment}
                rangeFrom={dayjs.utc(rangeFrom).format("HH:mm")}
                rangeTo={dayjs.utc(rangeTo).format("HH:mm")}
                breathData={summary_table_1}
                spo2Data={[...summary_table_6, spo2_details]}
                prData={summary_table_7}
                recordingData={summary_table_8}
                chartImgBR={chartImgBR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                //Not required
                chartImgMOV={chartImgMOV}
                chartImgYDIST={chartImgYDIST}
                chartImgSA={chartImgSA}
                chartImgTB={chartImgTB}
                singleSECharts={singleSECharts}
                chartImgBRV={chartImgBRV}
                chartImgHRV={chartImgHRV}
                singleriiCharts={singleriiCharts}
            />
        );
    };

    const NightlyEn = () => {
        return (
            <LazyPhysicianReportNightlyEN
                data={props}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                reportComment={reportComment}
                selected_night={selected_night}
                rangeFrom={dayjs.utc(rangeFrom).format("HH:mm")}
                rangeTo={dayjs.utc(rangeTo).format("HH:mm")}
                breathData={summary_table_1}
                spo2Data={[...summary_table_6, spo2_details]}
                prData={summary_table_7}
                odiData={summary_table_11}
                recordingData={summary_table_8}
                chartImgSPO2={chartImgSPO2}
                riiDECharts={riiDECharts}
            />
        );
    };

    const NightlyDe = () => {
        return (
            <LazyPhysicianReportNightlyDE
                data={props}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                reportComment={reportComment}
                selected_night={selected_night}
                rangeFrom={dayjs.utc(rangeFrom).format("HH:mm")}
                rangeTo={dayjs.utc(rangeTo).format("HH:mm")}
                breathData={summary_table_1}
                spo2Data={[...summary_table_6, spo2_details]}
                prData={summary_table_7}
                odiData={summary_table_11}
                recordingData={summary_table_8}
                chartImgSPO2={chartImgSPO2}
                riiDECharts={riiDECharts}
            />
        );
    };

    const PhysicianEN = () => {
        return (
            <LazyPhysicianReportEN
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
            />
        );
    };

    const PhysicianENS = () => {
        return (
            <LazyPhysicianReportENStudy
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
            />
        );
    };

    const PhysicianDE = () => {
        return (
            <LazyPhysicianReportDE
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
            />
        );
    };

    const PhysicianDES = () => {
        return (
            <LazyPhysicianReportDEStudy
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
            />
        );
    };

    const PhysicianDU = () => {
        return (
            <LazyPhysicianReportDU
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
            />
        );
    };

    const PatientTVReport = () => {
        return (
            <LazyPatientTvReport
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                riiCharts={riiCharts}
                hospitalName={props.doctor_info.organisation_name}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                chartImgSQ={chartImgSQ}
                chartImgRII={chartImgRII}
                chartImgSE={chartImgSE}
                chartImgODI={chartImgODI}
                chartImgBP={chartImgBP}
                chartImgWeight={chartImgWeight}
                chartImgBloodSugar={chartImgBloodSugar}
                chartImgBodyTemperature={chartImgBodyTemperature}
            />
        );
    };

    const PhysicianUSInsomnia = () => {
        return (
            <LazyPatientInsomniaReport
                data={{
                    ...props,
                    device_info: props.device_info ? props.device_info : {},
                }}
                patient_id={
                    patients.patient_info.user_id ? patients.patient_info.user_id : ""
                }
                riiDECharts={riiDECharts}
                seCharts={seCharts}
                reportLogo={reportLogo}
                waveImage={wave}
                footerWave={foot}
                selected_night={selected_night}
                ratingImage={ratingImage}
                reportComment={reportComment}
                tv_duration={tv_duration}
                tv_night_from={tv_night_from}
                tv_night_to={tv_night_to}
                tv_kpis={tv_kpis}
                nights_available={nights_available}
                chartImgSPO2TV={chartImgSPO2TV}
                chartImgBR={chartImgBR}
                chartImgHR={chartImgHR}
                chartImgSPO2={chartImgSPO2}
                chartImgPR={chartImgPR}
                selectedDates={selectedDates}
                selectedKpi={selected_tv_kpis}
                vital_parameters={vital_parameters}
                summary_stats={summary_table_17}
                chartImgAG={chartImgAg}
                actigraph={actigraph}
            />
        );
    };

    return (
        <div className="app-wrapper" style={{ padding: "0px" }}>
            <div className="d-flex patient-detail-wrap">
                {/* <div className="col-12 col-md-4 col-lg-3 col-xl-2" style={{position: window.innerWidth < 600 ? "relative" : "sticky", top: "72px", height: "700px", overflow: "scroll"}}>
        <Summary
          fetching_ml_kpi_summary={fetching_ml_kpi_summary}
        />
        {
          <div className="col-12 d-flex flex-column align-items-center">
            <Button className="my-3" color="primary" variant="outlined" onClick={() => set_show_patient_info(true)} >Show Patient Info</Button>
          </div>
        }
      </div> */}
                <Tabs className="side-tabs custom-tabs">
                    <TabList>
                        <Tab>
                            <IntlMessages id="po.overview" />
                        </Tab>
                        <Tab>
                            <IntlMessages id="po.patientDetails" />
                        </Tab>
                        <Tab disabled={night_view === "multiple_night"}>
                            <IntlMessages id="po.summary" />
                        </Tab>
                    </TabList>
                    <TabPanel className="tab-panel-content">
                        <div className="filter-block trend-block">
                            <div
                                className={
                                    "switch-block-bg " +
                                    (night_view === "multiple_night" ? "trend-view-active" : "")
                                }
                            >
                                <div
                                    className={
                                        "switch-btn " +
                                        (night_view === "single_night" ? " active" : "")
                                    }
                                    onClick={() => {
                                        set_night_view("single_night");
                                        set_actigraph_view(false);
                                    }}
                                >
                                    <IntlMessages id="po.oneNight" />
                                </div>
                                <div
                                    className={
                                        "switch-btn " +
                                        (night_view === "multiple_night" ? " active" : "")
                                    }
                                    onClick={() => {
                                        if (!props.kpi.reset_tv_analytics) {
                                            props.reset_tv_kpi_data("omitSE");
                                        }
                                        set_night_view("multiple_night");
                                        if (!tv_duration) {
                                            const p_create_date_time = dayjs(patient_info.createdAt)
                                                .format("YYYY-MM-DD")
                                                .valueOf();
                                            const diff_days = dayjs().diff(p_create_date_time);
                                            const tv_duration_data = [...tv_duration_options];
                                            tv_duration_data.forEach((d, i) => {
                                                if (
                                                    diff_days >= 2 &&
                                                    diff_days < 3 &&
                                                    [3].indexOf(i) > -1
                                                ) {
                                                    d.disabled = false;
                                                } else if (
                                                    diff_days >= 3 &&
                                                    diff_days < 10 &&
                                                    [0, 3].indexOf(i) > -1
                                                ) {
                                                    d.disabled = false;
                                                } else if (
                                                    diff_days >= 10 &&
                                                    diff_days < 30 &&
                                                    [0, 1, 3].indexOf(i) > -1
                                                ) {
                                                    d.disabled = false;
                                                } else if (diff_days >= 30) {
                                                    d.disabled = false;
                                                }
                                            });

                                            set_tv_duration_options(tv_duration_data);

                                            if (diff_days >= 2 && diff_days < 3) {
                                                set_tv_duration(tv_duration_data[3]);

                                                // const cal_start_date = moment().subtract(3, 'd').toDate();
                                                const cal_start_date = dayjs(
                                                    dayjs().format("YYYY-MM-DD 00:00:00")
                                                )
                                                    .subtract(2, "d")
                                                    .toDate();
                                                set_tv_night_from(cal_start_date);

                                                const cal_start_end = dayjs()
                                                    .subtract(1, "d")
                                                    .toDate();
                                                set_tv_night_to(cal_start_end);
                                            } else if (diff_days >= 3) {
                                                set_tv_duration(tv_duration_data[0]);

                                                const cal_start_date = dayjs()
                                                    .subtract(parseInt(tv_duration_data[0].value), "d")
                                                    .toDate();
                                                set_tv_night_from(cal_start_date);

                                                const cal_start_end = dayjs()
                                                    .subtract(1, "d")
                                                    .toDate();
                                                set_tv_night_to(cal_start_end);
                                            }
                                        }
                                    }}
                                >
                                    <IntlMessages id="po.trendView" />
                                </div>
                            </div>
                        </div>
                        {night_view === "single_night" && (
                            <>
                                <div className="filter-block calendar-block">
                                    <label className="filter-label">
                                        <IntlMessages id="po.selectNights" />
                                    </label>
                                    {!fetching_nights_available &&
                                        (!nightList || (nightList && nightList.length === 0)) && (
                                            <div className="no-data-text">
                                                <IntlMessages id="po.selectNightsMsg" />
                                            </div>
                                        )}
                                    {!fetching_nights_available &&
                                        nightList &&
                                        nightList.length > 0 && (
                                            <DatePicker
                                                ref={nightCalendarRef}
                                                selected={
                                                    new Date(
                                                        dayjs(selected_night * 1000)
                                                            .utc()
                                                            .format("MMMM DD, YYYY HH:mm:ss")
                                                    )
                                                }
                                                onChange={(date) => onChangeSelectedNight(date)}
                                                onCalendarClose={handleCalendarClose}
                                                onCalendarOpen={handleCalendarOpen}
                                                includeDates={nightList}
                                                dateFormat="dd MMM yyyy"
                                                customInput={<CustomDateInput ref={ref} />}
                                                calendarClassName="custom-calendar"
                                                renderCustomHeader={({
                                                    date,
                                                    decreaseMonth,
                                                    increaseMonth,
                                                    prevMonthButtonDisabled,
                                                    nextMonthButtonDisabled,
                                                }) => (
                                                    <div className="calendar-controls">
                                                        <div className="left-controls">
                                                            {/* <span>{dayjs.months(getMonth(date))} </span> */}
                                                            <span>{dayjs(date).format("MMMM")} </span>
                                                            <span>{dayjs(date).year()}</span>
                                                        </div>
                                                        <div className="right-controls">
                                                            <span
                                                                className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                                                onClick={decreaseMonth}
                                                                disabled={prevMonthButtonDisabled}
                                                            />
                                                            <span
                                                                className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                                                onClick={increaseMonth}
                                                                disabled={nextMonthButtonDisabled}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                        )}
                                </div>
                                <div className="filter-block">
                                    <label className="filter-label">
                                        <IntlMessages id="po.selectChannels" />
                                    </label>
                                    <span className="show-channels" onClick={saveChannelsObj}>
                                        <IntlMessages id="po.saveAs" />
                                    </span>
                                    {!fetching_available_kpis &&
                                        (!available_kpis ||
                                            (available_kpis && available_kpis.length === 0)) && (
                                            <div className="no-data-text">
                                                <IntlMessages id="po.selectChannelsMsg" />
                                            </div>
                                        )}
                                    {fetching_nights_available === false &&
                                        fetching_available_kpis === false &&
                                        available_kpis &&
                                        available_kpis.length > 0 && (
                                            <KpiListComp
                                                night_view={night_view}
                                                nights_available={nights_available}
                                                fetching_kpi_data={fetching_kpi_data}
                                                select_kpi={select_kpi}
                                                selected_kpis={selected_kpis}
                                                available_kpis={available_kpis}
                                                sorted_kpis={sorted_kpis}
                                                physician_info={physician_info}
                                                set_sorted_kpis={set_sorted_kpis}
                                                sorted_array_kpis={sorted_array_kpis}
                                                set_sorted_array_kpis={(kpiArray) =>
                                                    saveKpiPreferenceData(kpiArray)
                                                }
                                            />
                                        )}
                                </div>
                                {nights_available &&
                                    Object.keys(nights_available).length > 0 &&
                                    available_kpis &&
                                    available_kpis.length > 0 && (
                                        <div className="filter-block">
                                            <label className="filter-label">
                                                <IntlMessages id="main.actions" />
                                            </label>
                                            {props.membership_type !== "paid" &&
                                                non_graph_available_kpis &&
                                                non_graph_available_kpis.indexOf("AP_timing") > -1 &&
                                                non_graph_available_kpis &&
                                                annotations &&
                                                (annotations.length === 0 ||
                                                    (annotations.length > 0 &&
                                                        !annotations.find((a) => a.type === "system"))) ? (
                                                no_system_annotations ? (
                                                    <div className="action-block beta disabled-field">
                                                        <div className="beta-block" />
                                                        <label>
                                                            <IntlMessages id="so.noSystemAnnotationsFound" />
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <div className="action-block beta">
                                                        <div className="beta-block" />
                                                        <label
                                                            onClick={() =>
                                                                generateSystemAnnotationsHandle(
                                                                    "system",
                                                                    "AP_timing"
                                                                )
                                                            }
                                                        >
                                                            <IntlMessages id="so.generateSystemAnnotations" />
                                                        </label>
                                                    </div>
                                                )
                                            ) : (
                                                ""
                                            )}
                                            {props.membership_type !== "paid" &&
                                                annotations &&
                                                annotations.length > 0 &&
                                                annotations.find((a) => a.type === "system") && (
                                                    <div
                                                        className={
                                                            "action-block show-annotation-btn" +
                                                            (show_system_annotations_flag ? " active" : "")
                                                        }
                                                    >
                                                        <Checkbox
                                                            id="show-system-annotation-on-graph-checkbox"
                                                            className="action-checkbox"
                                                            value="biomakers"
                                                            checked={show_system_annotations_flag}
                                                            disableRipple={true}
                                                            icon={
                                                                <img src={icon_checkbox_outline} alt="Icon" />
                                                            }
                                                            checkedIcon={
                                                                <img src={icon_checkbox} alt="Icon" />
                                                            }
                                                            inputProps={{
                                                                "aria-label": "Show System Annotations",
                                                            }}
                                                            onChange={() => {
                                                                set_show_system_annotations_flag(
                                                                    !show_system_annotations_flag
                                                                );
                                                            }}
                                                            classes={{ checked: "action-checkbox-checked" }}
                                                        />
                                                        <label htmlFor="show-system-annotation-on-graph-checkbox">
                                                            <IntlMessages id="po.showSystem" />
                                                        </label>
                                                    </div>
                                                )}
                                            <div
                                                className={
                                                    "action-block show-annotation-btn" +
                                                    (show_annotations_flag ? " active" : "")
                                                }
                                            >
                                                <Checkbox
                                                    id="show-annotation-on-graph-checkbox"
                                                    className="action-checkbox"
                                                    value="biomakers"
                                                    checked={show_annotations_flag}
                                                    disableRipple={true}
                                                    icon={<img src={icon_checkbox_outline} alt="Icon" />}
                                                    checkedIcon={<img src={icon_checkbox} alt="Icon" />}
                                                    inputProps={{
                                                        "aria-label": "Show Annotations",
                                                    }}
                                                    onChange={() => {
                                                        set_show_annotations_flag(!show_annotations_flag);
                                                    }}
                                                    classes={{ checked: "action-checkbox-checked" }}
                                                />
                                                <label htmlFor="show-annotation-on-graph-checkbox">
                                                    <IntlMessages id="po.showCustom" />
                                                </label>
                                            </div>
                                            {props.membership_type !== "paid" &&
                                                non_graph_available_kpis &&
                                                non_graph_available_kpis.indexOf("DSAT") > -1 &&
                                                non_graph_available_kpis &&
                                                annotations &&
                                                (annotations.length === 0 ||
                                                    (annotations.length > 0 &&
                                                        !annotations.find(
                                                            (a) => a.type === "desaturation"
                                                        ))) ? (
                                                no_system_desaturations ? (
                                                    <div className="action-block beta disabled-field">
                                                        <div className="beta-block" />
                                                        <label>
                                                            <IntlMessages id="so.noDesaturationsFound" />
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <div className="action-block beta">
                                                        <div className="beta-block" />
                                                        <label
                                                            onClick={() =>
                                                                generateSystemAnnotationsHandle(
                                                                    "desaturation",
                                                                    "DSAT"
                                                                )
                                                            }
                                                        >
                                                            <IntlMessages id="so.generateDesaturationEvents" />
                                                        </label>
                                                    </div>
                                                )
                                            ) : (
                                                ""
                                            )}
                                            {props.membership_type !== "paid" &&
                                                annotations &&
                                                annotations.length > 0 &&
                                                annotations.find((a) => a.type === "desaturation") && (
                                                    <div
                                                        className={
                                                            "action-block show-desaturation-btn" +
                                                            (show_desaturations_flag ? " active" : "")
                                                        }
                                                    >
                                                        <Checkbox
                                                            id="show-desaturations-on-graph-checkbox"
                                                            className="action-checkbox"
                                                            value="biomakers"
                                                            checked={show_desaturations_flag}
                                                            disableRipple={true}
                                                            icon={
                                                                <img src={icon_checkbox_outline} alt="Icon" />
                                                            }
                                                            checkedIcon={
                                                                <img src={icon_checkbox} alt="Icon" />
                                                            }
                                                            inputProps={{
                                                                "aria-label": "Show Desaturations",
                                                            }}
                                                            onChange={() => {
                                                                set_show_desaturations_flag(
                                                                    !show_desaturations_flag
                                                                );
                                                            }}
                                                            classes={{ checked: "action-checkbox-checked" }}
                                                        />
                                                        <label htmlFor="show-desaturations-on-graph-checkbox">
                                                            <IntlMessages id="po.showDesaturations" />
                                                        </label>
                                                    </div>
                                                )}
                                            {!props.is_annotator && (
                                                <div className="action-block">
                                                    <span className="icon">
                                                        <img alt="download" src={icon_download} />
                                                    </span>
                                                    <label onClick={exportToCSV}>
                                                        <IntlMessages id="po.downloadDataPoints" />
                                                    </label>
                                                </div>
                                            )}
                                            {isOpenReportDownloadDialog && (
                                                <LazyPatientReportDialog
                                                    document={
                                                        !showReport
                                                            ? null
                                                            : reportType === "en-RPM"
                                                                ? RPMReport()
                                                                : reportType === "en-pyn"
                                                                    ? NightlyEn()
                                                                    : reportType === "de-pyn"
                                                                        ? NightlyDe()
                                                                        : null
                                                    }
                                                    fileName={
                                                        reportType === "en-RPM"
                                                            ? `${props.patient_info.patient_code}_${dayjs(
                                                                selected_night * 1000
                                                            ).format("YYYYMMDD")}_rpm_report.pdf`
                                                            : reportType === "en-pyn"
                                                                ? `${props.patient_info.patient_code}_${dayjs(
                                                                    selected_night * 1000
                                                                ).format("YYYYMMDD")}_nightly_report_en.pdf`
                                                                : reportType === "de-pyn"
                                                                    ? `${props.patient_info.patient_code}_${dayjs(
                                                                        selected_night * 1000
                                                                    ).format("YYYYMMDD")}_nightly_report_de.pdf`
                                                                    : null
                                                    }
                                                    sorted_array_kpis={sorted_array_kpis}
                                                    rangeFrom={rangeFrom}
                                                    rangeTo={rangeTo}
                                                    showReport={showReport}
                                                    is_paid={props.membership_type === "paid"}
                                                    isMultinight={night_view === "multiple_night"}
                                                    openReportDialog={isOpenReportDownloadDialog}
                                                    closeReportDownloadDialog={
                                                        handle_toggleReportDownloadDialog
                                                    }
                                                    onDownloadReportClick={handle_onDownloadReportClick}
                                                    //   uploadReport={handleUploadReport}
                                                    downloadReport={handleDownloadReport}
                                                    showButton={show_loader}
                                                    automated_report_url={patients.automated_report_url}
                                                    automated_report_failure_msg={
                                                        patients.automated_report_failure_msg
                                                    }
                                                />
                                            )}

                                            <div
                                                className="action-block"
                                                ref={(btnRef) => (generateReportBtn.current = btnRef)}
                                                onClick={handle_toggleReportDownloadDialog}
                                            >
                                                <span className="icon">
                                                    <img alt="download" src={icon_download} />
                                                </span>
                                                <label>
                                                    <IntlMessages id="po.generateReport" />
                                                </label>
                                            </div>
                                            <div
                                                className="action-block"
                                                onClick={() => {
                                                    refresh_statistics({
                                                        patient_id: patient_info.user_id,
                                                        device_id:
                                                            nights_available[selected_night][0].device_id,
                                                        recording_date:
                                                            nights_available[selected_night][0]
                                                                .recording_date,
                                                        kpi: "GSD",
                                                    });
                                                }}
                                            >
                                                <span className="icon">
                                                    <img alt="download" src={icon_reset_active} />
                                                </span>
                                                <label>
                                                    <IntlMessages id="po.manualCorrrections" />
                                                </label>
                                            </div>
                                        </div>
                                    )}
                            </>
                        )}
                        {night_view === "multiple_night" && (
                            <div className="filter-block trend-block">
                                <label className="filter-label">
                                    <IntlMessages id="newpatient.duration" />
                                </label>
                                <Select
                                    className="custom-react-select custom-select-box"
                                    classNamePrefix="custom-react-select"
                                    options={tv_duration_options}
                                    isOptionDisabled={(option) => option.disabled === true}
                                    isDisabled={false}
                                    isLoading={false}
                                    isClearable={false}
                                    isRtl={false}
                                    isSearchable={false}
                                    menuPlacement="bottom"
                                    // defaultValue={tv_duration}
                                    value={tv_duration}
                                    onChange={onChangeTRDuration}
                                />
                                <div className="grey-calendar-wrapper duration-calendar-wrapper">
                                    <div className="duration-calendar-block duration-calendar-from">
                                        <label className="filter-label">
                                            <IntlMessages id="so.from" />
                                        </label>
                                        {!fetching_nights_available &&
                                            nightList &&
                                            nightList.length > 0 && (
                                                <DatePicker
                                                    disabled={
                                                        !tv_duration ||
                                                        (tv_duration && tv_duration.type !== "custom")
                                                    }
                                                    // minDate={patient_info && moment(patient_info.createdAt).toDate()}
                                                    minDate={
                                                        patient_info &&
                                                        new Date(
                                                            dayjs
                                                                .utc(patient_info.createdAt)
                                                                .format("YYYY-MM-DD 00:00:00")
                                                        )
                                                    }
                                                    maxDate={tv_max_from_date}
                                                    highlightDates={nightList}
                                                    ref={nightFromCalendarRef}
                                                    selected={tv_night_from}
                                                    onChange={(date) => onChangeSelectedNightFrom(date)}
                                                    onCalendarClose={handleFromCalendarClose}
                                                    onCalendarOpen={handleFromCalendarOpen}
                                                    dateFormat="dd MMM yyyy"
                                                    customInput={<CustomFromDateInput ref={ref} />}
                                                    calendarClassName="custom-calendar"
                                                    renderCustomHeader={({
                                                        date,
                                                        decreaseMonth,
                                                        increaseMonth,
                                                        prevMonthButtonDisabled,
                                                        nextMonthButtonDisabled,
                                                    }) => (
                                                        <div className="calendar-controls">
                                                            <div className="left-controls">
                                                                <span>{dayjs(date).format("MMMM")} </span>
                                                                <span>{dayjs(date).year()}</span>
                                                            </div>
                                                            <div className="right-controls">
                                                                <span
                                                                    className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                                                    onClick={decreaseMonth}
                                                                    disabled={prevMonthButtonDisabled}
                                                                />
                                                                <span
                                                                    className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                                                    onClick={increaseMonth}
                                                                    disabled={nextMonthButtonDisabled}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            )}
                                    </div>
                                    <div className="duration-calendar-block duration-calendar-to">
                                        <label className="filter-label">
                                            <IntlMessages id="so.to" />
                                        </label>
                                        {!fetching_nights_available &&
                                            nightList &&
                                            nightList.length > 0 && (
                                                <DatePicker
                                                    popperPlacement="bottom-end"
                                                    disabled={
                                                        !tv_duration ||
                                                        (tv_duration && tv_duration.type !== "custom")
                                                    }
                                                    minDate={dayjs(tv_night_from)
                                                        .add(1, "d")
                                                        .toDate()}
                                                    maxDate={dayjs()
                                                        .subtract(1, "d")
                                                        .toDate()}
                                                    highlightDates={nightList}
                                                    ref={nightToCalendarRef}
                                                    selected={tv_night_to}
                                                    onChange={(date) => onChangeSelectedNightTo(date)}
                                                    onCalendarClose={handleToCalendarClose}
                                                    onCalendarOpen={handleToCalendarOpen}
                                                    dateFormat="dd MMM yyyy"
                                                    customInput={<CustomToDateInput ref={ref} />}
                                                    calendarClassName="custom-calendar"
                                                    renderCustomHeader={({
                                                        date,
                                                        decreaseMonth,
                                                        increaseMonth,
                                                        prevMonthButtonDisabled,
                                                        nextMonthButtonDisabled,
                                                    }) => (
                                                        <div className="calendar-controls">
                                                            <div className="left-controls">
                                                                <span>{dayjs(date).format("MMMM")} </span>
                                                                <span>{dayjs(date).year()}</span>
                                                            </div>
                                                            <div className="right-controls">
                                                                <span
                                                                    className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                                                    onClick={decreaseMonth}
                                                                    disabled={prevMonthButtonDisabled}
                                                                />
                                                                <span
                                                                    className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                                                    onClick={increaseMonth}
                                                                    disabled={nextMonthButtonDisabled}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            )}
                                    </div>
                                </div>
                                <>
                                    <div className="filter-block">
                                        <label className="filter-label">
                                            <IntlMessages id="po.selectChannels" />
                                        </label>
                                        <span
                                            className="show-channels"
                                            onClick={save_trend_view_kpi_preference}
                                        >
                                            <IntlMessages id="po.saveAs" />
                                        </span>
                                        {(!nights_available ||
                                            (nights_available &&
                                                Object.keys(nights_available).length === 0)) && (
                                                <div className="no-data-text">
                                                    <IntlMessages id="po.selectChannelsMsg" />
                                                </div>
                                            )}
                                    </div>

                                    {fetching_nights_available === false &&
                                        nights_available &&
                                        Object.keys(nights_available).length > 0 &&
                                        tv_kpis &&
                                        tv_kpis.length > 0 && (
                                            <KpiListComp
                                                night_view={night_view}
                                                nights_available={nights_available}
                                                fetching_kpi_data={fetching_tv_kpi_data}
                                                select_kpi={select_tv_kpi}
                                                remove_kpi={props.reset_tv_kpi_data}
                                                selected_kpis={selected_tv_kpis}
                                                available_kpis={tv_kpis}
                                                sorted_kpis={sorted_tv_kpis}
                                                physician_info={physician_info}
                                                set_sorted_kpis={set_sorted_tv_kpis}
                                                sorted_array_kpis={sorted_tv_array_kpis}
                                                set_sorted_array_kpis={(kpiTVArray) =>
                                                    saveTVKpiPreferenceData(kpiTVArray)
                                                }
                                            />
                                        )}
                                    <div>
                                        {tv_analytics["SQ"] &&
                                            selected_tv_kpis["SQ"] &&
                                            tv_analytics["SQ"].length > 0 && (
                                                <div className="toggle-block">
                                                    <div className="toggle-switch">
                                                        <label className="switch">
                                                            Toggle Actigraph View
                                                        </label>
                                                        <input
                                                            type="checkbox"
                                                            checked={actigraph_view}
                                                            onChange={() =>
                                                                handleToggleActiGraphView(actigraph_view)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        {/* WILL BE DEPLOYED WITH 4.0.0 */}
                                        {actigraph_view &&
                                            selected_tv_kpis["SQ"] && (
                                                <div className="filter-block">
                                                    <label className="filter-label">
                                                        Click on dates to toggle
                                                        {/* <IntlMessages id="po.selectChannels" /> */}
                                                    </label>
                                                    <span
                                                        className="show-channels"
                                                        onClick={save_trend_view_kpi_preference}
                                                    >
                                                        {/* <IntlMessages id="po.saveAs" /> */}
                                                    </span>
                                                    {(!nights_available ||
                                                        (nights_available &&
                                                            Object.keys(nights_available).length === 0)) && (
                                                            <div className="no-data-text">
                                                                <IntlMessages id="po.selectChannelsMsg" />
                                                            </div>
                                                        )}
                                                    {fetching_actigraph === false &&
                                                        actigraph &&
                                                        Object.keys(actigraph).length > 0 > 0 && (
                                                            <DateListComp
                                                                available_dates={actigraph_dates}
                                                                sorted_dates={sorted_actigraph_dates}
                                                                sorted_array_dates={sorted_actigraph_dates}
                                                                set_sorted_dates={set_sorted_actigraph_dates}
                                                                select_date={select_actigraph_dates}
                                                                selected_dates={selected_actigraph_dates}
                                                                fetching_actigraph={fetching_actigraph}
                                                            />
                                                        )}
                                                </div>
                                            )}
                                    </div>
                                    {fetching_nights_available === false &&
                                        nights_available &&
                                        Object.keys(nights_available).length > 0 &&
                                        tv_kpis &&
                                        tv_kpis.length > 0 && (
                                            <div className="filter-block">
                                                <label className="filter-label">ACTIONS</label>
                                                {isOpenReportDownloadDialog && (
                                                    <LazyPatientReportDialog
                                                        document={
                                                            !showReport
                                                                ? null
                                                                : reportType === "en"
                                                                    ? PatientTVReport()
                                                                    : reportType === "en-us"
                                                                        ? PhysicianUSInsomnia()
                                                                        : reportType === "en-py"
                                                                            ? PhysicianEN()
                                                                            : reportType === "de-py"
                                                                                ? PhysicianDE()
                                                                                : reportType === "du-pys"
                                                                                    ? PhysicianDU()
                                                                                    : reportType === "de-pys"
                                                                                        ? PhysicianDES()
                                                                                        : reportType === "en-pys"
                                                                                            ? PhysicianENS()
                                                                                            : null
                                                        }
                                                        fileName={
                                                            reportType === "en"
                                                                ? `${device_info
                                                                    ? device_info.device_id
                                                                    : props.patient_info.patient_code
                                                                }_trend_view_report.pdf`
                                                                : reportType === "en-py"
                                                                    ? `${device_info
                                                                        ? device_info.device_id
                                                                        : props.patient_info.patient_code
                                                                    }_trend_view_report.pdf`
                                                                    : reportType === "en-us"
                                                                        ? `${device_info
                                                                            ? device_info.device_id
                                                                            : props.patient_info.patient_code
                                                                        }_${dayjs(tv_night_from).format(
                                                                            "YYYYMMDD"
                                                                        )}-${dayjs(tv_night_to).format(
                                                                            "YYYYMMDD"
                                                                        )}_insomnia_report.pdf`
                                                                        : reportType === "en-py"
                                                                            ? `${device_info
                                                                                ? device_info.device_id
                                                                                : props.patient_info.patient_code
                                                                            }_${dayjs(tv_night_from).format(
                                                                                "YYYYMMDD"
                                                                            )}-${dayjs(tv_night_to).format(
                                                                                "YYYYMMDD"
                                                                            )}_en.pdf`
                                                                            : reportType === "de-py"
                                                                                ? `${device_info
                                                                                    ? device_info.device_id
                                                                                    : props.patient_info.patient_code
                                                                                }_${dayjs(tv_night_from).format(
                                                                                    "YYYYMMDD"
                                                                                )}-${dayjs(tv_night_to).format(
                                                                                    "YYYYMMDD"
                                                                                )}_de.pdf`
                                                                                : reportType === "du-pys"
                                                                                    ? `${device_info
                                                                                        ? device_info.device_id
                                                                                        : props.patient_info
                                                                                            .patient_code
                                                                                    }_${dayjs(tv_night_from).format(
                                                                                        "YYYYMMDD"
                                                                                    )}-${dayjs(tv_night_to).format(
                                                                                        "YYYYMMDD"
                                                                                    )}_study_du.pdf`
                                                                                    : reportType === "en-pys"
                                                                                        ? `${device_info
                                                                                            ? device_info.device_id
                                                                                            : props.patient_info
                                                                                                .patient_code
                                                                                        }_${dayjs(tv_night_from).format(
                                                                                            "YYYYMMDD"
                                                                                        )}-${dayjs(tv_night_to).format(
                                                                                            "YYYYMMDD"
                                                                                        )}_study_en.pdf`
                                                                                        : reportType === "de-pys"
                                                                                            ? `${device_info
                                                                                                ? device_info.device_id
                                                                                                : props.patient_info
                                                                                                    .patient_code
                                                                                            }_${dayjs(tv_night_from).format(
                                                                                                "YYYYMMDD"
                                                                                            )}-${dayjs(tv_night_to).format(
                                                                                                "YYYYMMDD"
                                                                                            )}_study_de.pdf`
                                                                                            : null
                                                        }
                                                        sorted_array_kpis={selected_tv_kpis}
                                                        openReportDialog={isOpenReportDownloadDialog}
                                                        jira_keys={jira_key}
                                                        nights_available={
                                                            selected_tv_kpis["SQ"] && tv_analytics["SQ"]
                                                        }
                                                        rangeFrom={tv_night_from}
                                                        showReport={showReport}
                                                        rangeTo={tv_night_to}
                                                        isMultinight={night_view === "multiple_night"}
                                                        is_paid={props.membership_type === "paid"}
                                                        closeReportDownloadDialog={
                                                            handle_toggleReportDownloadDialog
                                                        }
                                                        onDownloadReportClick={handle_onDownloadReportClick}
                                                        //uploadReport={handleUploadReport}
                                                        showButton={show_loader}
                                                        downloadReport={handleDownloadReport}
                                                        automated_report_url={patients.automated_report_url}
                                                        automated_report_failure_msg={
                                                            patients.automated_report_failure_msg
                                                        }
                                                    />
                                                )}

                                                <div
                                                    className="action-block"
                                                    onClick={handle_toggleReportDownloadDialog}
                                                >
                                                    <span className="icon">
                                                        <img alt="download" src={icon_download} />
                                                    </span>
                                                    <label>
                                                        <IntlMessages id="po.generateReport" />
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                </>
                            </div>
                        )}
                    </TabPanel>
                    <TabPanel className="tab-panel-content">
                        <div className="filter-block">
                            <div>
                                <label className="filter-label">
                                    <IntlMessages id="newpatient.conditions" />
                                </label>

                                <div className="diseaselist-wrap">
                                    <MSelect
                                        multiple
                                        disabled={props.is_annotator}
                                        classes={{
                                            root: "diseaselist-root",
                                            icon: "diseaselist-icon",
                                            select: "diseaselist-select",
                                            selectMenu: "diseaselist-select-menu",
                                        }}
                                        value={selectedDiseases}
                                        onChange={onSelectDisease}
                                        MenuProps={{
                                            getContentAnchorEl: null,
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left",
                                            },
                                            classes: {
                                                paper: "diseaselist-dropdown",
                                            },
                                        }}
                                        onOpen={diseaseMenuToggle}
                                        open={diseaseMenuOpenFlag}
                                        onClose={diseaseMenuToggle}
                                        className="diseaselist-field"
                                        input={<Input id="select-multiple-checkbox" />}
                                        renderValue={(disease_list) =>
                                            disease_list.length +
                                            " item" +
                                            (disease_list.length > 1 ? "s " : " ") +
                                            "selected"
                                        }
                                    >
                                        <Input
                                            className="multiselect-search"
                                            id="disease_list_searchBox"
                                            placeholder="Search condition"
                                            onChange={(e) => {
                                                var inputValue = e.target.value.trim();
                                                var array = [];
                                                array = patients.fetch_disease_list_data.filter(
                                                    (disease) => {
                                                        if (
                                                            disease.disease_description.match(
                                                                new RegExp(
                                                                    inputValue
                                                                        .split("")
                                                                        .join("\\w*")
                                                                        .replace(/\W/, ""),
                                                                    "i"
                                                                )
                                                            )
                                                        ) {
                                                            return disease;
                                                        }
                                                    }
                                                );
                                                setDiseaseList(array);
                                            }}
                                        />
                                        {diseaseList.length > 0 ? (
                                            diseaseList.map((disease) => (
                                                <MenuItem
                                                    className="multi-select-item"
                                                    key={"d" + disease.disease_id}
                                                    value={disease.disease_description}
                                                >
                                                    <Checkbox
                                                        className="multi-select-check"
                                                        id={"disease-checkbox-" + disease.disease_id}
                                                        checked={
                                                            selectedDiseases.indexOf(
                                                                disease.disease_description
                                                            ) > -1
                                                        }
                                                        icon={
                                                            <img src={icon_checkbox_outline} alt="Icon" />
                                                        }
                                                        checkedIcon={<img src={icon_checkbox} alt="Icon" />}
                                                    />
                                                    <ListItemText
                                                        className="multi-select-text"
                                                        primary={disease.disease_description}
                                                    />
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <div className="no-data">
                                                <IntlMessages id="newpatient.noConditionFound" />
                                            </div>
                                        )}
                                    </MSelect>
                                </div>
                                <div className="selected-options-wrap">
                                    {selectedDiseases.map((value, i) => (
                                        <Chip
                                            className="selected-option"
                                            key={value + i}
                                            label={value}
                                            onDelete={() =>
                                                selectedDiseases.length > 1 && onDeleteDisease(value)
                                            }
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                        {fetch_patients_qna_data &&
                            fetch_patients_qna_data["Q_01"] && (
                                <div className="filter-block checkup-filter-block">
                                    <label className="filter-label">
                                        <IntlMessages id="po.questionnaire" />
                                    </label>
                                    <div>
                                        {["01", "02", "03", "04", "05", "06", "07", "08", "09"].map(
                                            (qKey) => (
                                                <div key={qKey}>
                                                    <p className="qna_question">
                                                        <IntlMessages id={`po.Q_${qKey}`} />
                                                    </p>
                                                    <p className="qna_answer">
                                                        {fetch_patients_qna_data[`Q_${qKey}`] ||
                                                            fetch_patients_qna_data[`Q_${qKey}`] === 0
                                                            ? fetch_patients_qna_data[`Q_${qKey}`]
                                                            : "NA"}
                                                    </p>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            )}
                        {fetch_patients_qna_data &&
                            fetch_patients_qna_data["C_01"] && (
                                <div className="filter-block checkup-filter-block">
                                    <label className="filter-label">
                                        <IntlMessages id="po.questionnaire" />
                                    </label>
                                    <div>
                                        {["01", "02", "03"].map((qKey) => (
                                            <div key={qKey}>
                                                <p className="qna_question">
                                                    <IntlMessages id={`po.C_${qKey}`} />
                                                </p>
                                                <p className="qna_answer">
                                                    {fetch_patients_qna_data[`C_${qKey}`]
                                                        ? qKey === "02"
                                                            ? fetch_patients_qna_data[`C_${qKey}`].join(", ")
                                                            : fetch_patients_qna_data[`C_${qKey}`]
                                                        : "NA"}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        {/* Hidden as per client comments */}
                        <div className="filter-block checkup-filter-block" hidden={true}>
                            <label className="filter-label">
                                <IntlMessages id="so.checkups" />
                            </label>
                            <Tabs className="custom-tabs bg-gray inner-tabs">
                                <TabList>
                                    <Tab>
                                        <IntlMessages id="Upcoming" />
                                    </Tab>
                                    <Tab>
                                        <IntlMessages id="so.dome" />
                                    </Tab>
                                </TabList>
                                <TabPanel>
                                    <div id="upcoming-checkups-list" className="checkups-list">
                                        {upcomingCheckups && upcomingCheckups.length > 0 ? (
                                            upcomingCheckups.map((data) => (
                                                <div
                                                    key={"upcoming-checkup-date-" + data.checkup_date_id}
                                                    className="checkup-block"
                                                >
                                                    <Checkbox
                                                        onChange={() => {
                                                            markCheckUpDate(data.checkup_date_id);
                                                        }}
                                                        checked={data.mark_as_complete_flag == 1}
                                                        id={data.checkup_date}
                                                        className="checkup-checkbox"
                                                        icon={<img src={icon_checkbox_round} alt="Icon" />}
                                                        checkedIcon={
                                                            <img
                                                                src={icon_checkbox_checked_round}
                                                                alt="Icon"
                                                            />
                                                        }
                                                        inputProps={{
                                                            "aria-label": `'${dayjs(data.checkup_date).format(
                                                                "DD.MM.YYYY"
                                                            )}'`,
                                                        }}
                                                        classes={{ checked: "action-checkbox-checked" }}
                                                        title={
                                                            data.mark_as_complete_flag == 1
                                                                ? "Unmark"
                                                                : "Mark"
                                                        }
                                                    />
                                                    <label
                                                        className="checkup-label"
                                                        htmlFor={`${data.checkup_date}`}
                                                    >
                                                        {dayjs(data.checkup_date).format("DD.MM.YYYY")}
                                                    </label>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="checkup-block">
                                                <IntlMessages id="so.noUpcomingCheckups" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="checkup-calendar-wrap">
                                        <DatePicker
                                            id="checkUp-date-picker"
                                            shouldCloseOnSelect={false}
                                            ref={checkUpCalendarRef}
                                            renderCustomHeader={({
                                                date,
                                                decreaseMonth,
                                                increaseMonth,
                                                prevMonthButtonDisabled,
                                                nextMonthButtonDisabled,
                                            }) => (
                                                <>
                                                    <div className="calendar-header">
                                                        <div className="calendar-title">
                                                            <IntlMessages id="so.addCheckupDate" />
                                                        </div>
                                                        <button
                                                            className="calendar-close"
                                                            onClick={() => {
                                                                checkUpCalendarRef.current.setOpen(false);
                                                            }}
                                                        >
                                                            X
                                                        </button>
                                                    </div>
                                                    <div className="calendar-controls">
                                                        <div className="left-controls">
                                                            <span>{dayjs(date).format("MMMM")} </span>
                                                            <span>{dayjs(date).year()}</span>
                                                        </div>
                                                        <div className="right-controls">
                                                            <span
                                                                className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                                                onClick={decreaseMonth}
                                                                disabled={prevMonthButtonDisabled}
                                                            />
                                                            <span
                                                                className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                                                onClick={increaseMonth}
                                                                disabled={nextMonthButtonDisabled}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            todayButton={<ActionButton />}
                                            minDate={dayjs
                                                .utc()
                                                .toDate()
                                                .setDate(
                                                    dayjs
                                                        .utc()
                                                        .toDate()
                                                        .getDate() + 1
                                                )}
                                            calendarClassName="custom-calendar checkup-calendar"
                                            selected={checkupDate}
                                            onChange={(date) => {
                                                setCheckupDate(date);
                                            }}
                                            customInput={<AddCheckUpLink />}
                                            excludeDates={patients.unavailableDates}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div id="past-checkups-list" className="checkups-list">
                                        {patients.pastCheckups &&
                                            patients.pastCheckups.length > 0 ? (
                                            patients.pastCheckups.map((data) => (
                                                <div
                                                    key={"past-checkup-date-" + data.checkup_date_id}
                                                    className="checkup-block"
                                                >
                                                    <Checkbox
                                                        // disabled={true}
                                                        onChange={() => {
                                                            markCheckUpDate(data.checkup_date_id);
                                                        }}
                                                        id={data.checkup_date}
                                                        checked={data.mark_as_complete_flag == 1}
                                                        className="checkup-checkbox"
                                                        icon={<img src={icon_checkbox_round} alt="Icon" />}
                                                        checkedIcon={
                                                            <img
                                                                src={icon_checkbox_checked_round}
                                                                alt="Icon"
                                                            />
                                                        }
                                                        inputProps={{
                                                            "aria-label": `'${dayjs(data.checkup_date).format(
                                                                "DD.MM.YYYY"
                                                            )}'`,
                                                        }}
                                                        classes={{
                                                            checked: "action-checkbox-checked",
                                                            disabled: "action-checkbox-disabled",
                                                        }}
                                                    />

                                                    <label
                                                        className="checkup-label"
                                                        htmlFor={`${data.checkup_date}`}
                                                    >
                                                        {dayjs(data.checkup_date).format("DD.MM.YYYY")}
                                                    </label>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="checkup-block">
                                                <IntlMessages id="so.noPastCheckups" />
                                            </div>
                                        )}
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                        <div className="filter-block">
                            <label className="filter-label">
                                <IntlMessages id="newpatient.comments" />
                            </label>
                            <div className="bg-gray">
                                <div className="comment-block">
                                    <FormControl className="comment-box-wrapper">
                                        <InputBase
                                            disabled={props.is_annotator}
                                            inputRef={commentInputRef}
                                            classes={{
                                                root: "comment-input",
                                                input: "comment-placeholder",
                                            }}
                                            placeholder="Enter comment"
                                            rowsMax="3"
                                            multiline
                                            onChange={(e) =>
                                                set_comment({ ...comment, commentText: e.target.value })
                                            }
                                            inputProps={{ maxLength: textMaxLength }}
                                            onKeyDown={(e) => onSubmitComment(e)}
                                            value={comment.commentText}
                                        />
                                        <div className="comment-pagination counter-block">
                                            <div>(Max character limit: {textMaxLength})</div>
                                            <div>
                                                {comment.commentText.length}/{textMaxLength}
                                            </div>
                                        </div>
                                    </FormControl>
                                    <div className="comments-list">
                                        {patients.fetch_comment_data.length ? (
                                            Object.values(patients.fetch_comment_data)
                                                .slice(firstComment, lastComment)
                                                .map((c, index) => (
                                                    <div
                                                        tabIndex={-1}
                                                        key={"c-" + index + "-" + c.user_id}
                                                    >
                                                        <div className="comment-details">
                                                            <small>
                                                                {dayjs(c.created_date).format(
                                                                    "DD.MM.YYYY h:mm A"
                                                                )}
                                                            </small>
                                                            <div className="comment-icons">
                                                                <span className="icon">
                                                                    <img
                                                                        src={icon_edit_small}
                                                                        alt="Edit"
                                                                        title="Edit"
                                                                        onClick={() => {
                                                                            commentInputRef.current.focus();
                                                                            set_comment({
                                                                                id: c.id,
                                                                                commentText: c.comment,
                                                                            });
                                                                        }}
                                                                    />
                                                                </span>
                                                                <span className="icon">
                                                                    <img
                                                                        src={icon_delete}
                                                                        alt="Delete"
                                                                        title="Delete"
                                                                        onClick={() => {
                                                                            delete_comment(c.id);
                                                                        }}
                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <p className="comment-text">{c.comment}</p>
                                                    </div>
                                                ))
                                        ) : (
                                            <div className="no-data">
                                                <IntlMessages id="so.noCommentsAvailable" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="comment-block comment-pagination-block"
                                    hidden={patients.fetch_comment_data.length == 0}
                                >
                                    <div className="comment-pagination">
                                        <div className="comment-pagination-left">
                                            <span>
                                                <IntlMessages id="so.rowsPerPage" />
                                            </span>
                                            <Select
                                                className="comment-pages custom-react-select comment-page-select"
                                                classNamePrefix="custom-react-select"
                                                options={pages_options}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={false}
                                                menuPlacement="top"
                                                defaultValue={pages_options[0]}
                                                onChange={(row) => {
                                                    setFirstComment(0);
                                                    setPageNumber(1);
                                                    setCommentsPerPage(row.value);
                                                    setLastComment(Number(row.value));
                                                }}
                                            />
                                        </div>
                                        <div className="comment-page-number">
                                            {pageNumber} -{" "}
                                            {Math.ceil(
                                                patients.fetch_comment_data.length / commentsPerPage
                                            )}{" "}
                                            of{" "}
                                            {Math.ceil(
                                                patients.fetch_comment_data.length / commentsPerPage
                                            )}
                                        </div>
                                    </div>
                                    <div className="pagination-arrows">
                                        <IconButton
                                            onClick={() => {
                                                if (
                                                    firstComment != 0 &&
                                                    firstComment >= commentsPerPage
                                                ) {
                                                    setLastComment(firstComment);
                                                    setFirstComment(
                                                        Number(firstComment) - Number(commentsPerPage)
                                                    );
                                                    // setLastComment(lastComment + commentsPerPage);
                                                    pageNumber >= 2
                                                        ? setPageNumber(pageNumber - 1)
                                                        : setPageNumber(1);
                                                } else if (firstComment < commentsPerPage) {
                                                    setFirstComment(0);
                                                    setLastComment(
                                                        Number(firstComment) +
                                                        (commentsPerPage - firstComment)
                                                    );
                                                    pageNumber >= 2
                                                        ? setPageNumber(pageNumber - 1)
                                                        : setPageNumber(1);
                                                }
                                            }}
                                            disabled={pageNumber === 1}
                                            aria-label="Previous Page"
                                        >
                                            <KeyboardArrowLeft />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => {
                                                if (lastComment <= patients.fetch_comment_data.length) {
                                                    setFirstComment(Number(lastComment));
                                                    setLastComment(
                                                        Number(lastComment) + Number(commentsPerPage)
                                                    );
                                                    setPageNumber(pageNumber + 1);
                                                }
                                            }}
                                            disabled={
                                                pageNumber ==
                                                Math.ceil(
                                                    patients.fetch_comment_data.length / commentsPerPage
                                                )
                                            }
                                            aria-label="Next Page"
                                        >
                                            <KeyboardArrowRight />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    {summary_table_1.length +
                        summary_table_2.length +
                        summary_table_3.length +
                        summary_table_4.length +
                        summary_table_5.length +
                        summary_table_6.length +
                        summary_table_7.length +
                        summary_table_8.length +
                        summary_table_9.length +
                        summary_table_12.length +
                        summary_table_13.length >
                        0 ? (
                        <TabPanel className="summary-tab-content tab-panel-content">
                            {summary_table_13 && summary_table_13.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="70%">
                                                <IntlMessages id="so.recordedWeight" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_13.map((summary, index) => (
                                            <TableRow key={"summary-table-13-" + index}>
                                                <TableCell width="70%">
                                                    <b>{summary.weight} KGs</b>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_8 &&
                                summary_table_8.length > 0 &&
                                summary_table_17 &&
                                summary_table_17.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="so.recordingInformation" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_8.map((summary, index) => (
                                            <TableRow key={"summary-table-8-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {summary_table_17.map((summary, index) => (
                                            <TableRow key={"summary-table-17-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : summary.name === "Total Bed Time"
                                                            ? Number(summary.durationA).toFixed(2)
                                                            : summary.durationA}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_9 && summary_table_9.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="so.RII" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_9.map((summary, index) => (
                                            <TableRow key={"summary-table-9-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {(summary_table_11 &&
                                summary_table_11.length > 0 &&
                                props.membership_type !== "paid") ||
                                (summary_table_11 &&
                                    !summary_table_11.length &&
                                    props.membership_type !== "paid") ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="so.ODI" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_11.map((summary, index) => (
                                            <TableRow key={"summary-table-11-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {summary_table_12.map((summary, index) => (
                                            <TableRow key={"summary-table-4-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {/* {
                                (summary_table_12 && summary_table_12.length > 0) ?
                                    <Table className="summary-table">
                                        {/* <TableHead>
                                            <TableRow>
                                                <TableCell width="115px">Auto OXYGEN DESATURATION INDEX (ODI)</TableCell>
                                                <TableCell width="25%"><IntlMessages id="so.nightAVG"></IntlMessages></TableCell>
                                                <TableCell width="25%"><IntlMessages id="so.durationAVG"></IntlMessages></TableCell>
                                            </TableRow>
                                        </TableHead> 
                                        <TableBody>
                                            {summary_table_12.map((summary, index) => (
                                                <TableRow key={'summary-table-4-' + index}>
                                                    <TableCell width="115px">{summary.name}</TableCell>
                                                    <TableCell width="25%">
                                                        {
                                                            isNaN(summary.nightA) ?
                                                                summary.nightA
                                                                :
                                                                Number(summary.nightA).toFixed(2)
                                                        }
                                                    </TableCell>
                                                    <TableCell width="25%">
                                                        {
                                                            isNaN(summary.durationA) ?
                                                                summary.durationA
                                                                :
                                                                Number(summary.durationA).toFixed(2)
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    : null
                            } */}
                            {Array.isArray(summary_table_10) ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="so.customizedIndex" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key="dropdown-key-edit-btn">
                                            <TableCell
                                                width="100%"
                                                colSpan={3}
                                                className="rii-params-edit"
                                            >
                                                <a
                                                    href="# "
                                                    onClick={(e) => {
                                                        e.persist();
                                                        e.preventDefault();
                                                        toggleTreeSelect(!treeSelect);
                                                    }}
                                                    className="back-link"
                                                >
                                                    <abbr title="Toggle to customize the parameters for calculating rii.">
                                                        {!treeSelect ? (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 20 20"
                                                                fill="currentColor"
                                                            >
                                                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 20 20"
                                                                fill="currentColor"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                                                    clipRule="evenodd"
                                                                />
                                                            </svg>
                                                        )}
                                                    </abbr>
                                                </a>
                                            </TableCell>
                                        </TableRow>
                                        {treeSelect && (
                                            <TableRow key="dropdown-key">
                                                <TableCell width="100%" colSpan={3}>
                                                    <TreeSelect
                                                        treeData={treeData}
                                                        value={riiParameters}
                                                        onChange={onRiiParametersChange}
                                                        treeCheckable={true}
                                                        showCheckedStrategy={TreeSelect.SHOW_ALL}
                                                        placeholder={"Please select"}
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {summary_table_10.map((summary, index) => (
                                            <TableRow key={"summary-table-10-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_1.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="main.breathingRate" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_1.map((summary, index) => (
                                            <TableRow key={"summary-table-1-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_2.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="main.pulseRateRadar" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_2.map((summary, index) => (
                                            <TableRow key={"summary-table-2-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_3.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="main.bodyMovement" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_3.map((summary, index) => (
                                            <TableRow key={"summary-table-3-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_4.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="so.recording" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_4.map((summary, index) => (
                                            <TableRow key={"summary-table-4-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_5 && summary_table_5.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">AHI </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_5.map((summary, index) => (
                                            <TableRow key={"summary-table-4-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_6.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">SpO2</TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_6.map((summary, index) => (
                                            <TableRow key={"summary-table-2-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_7.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="115px">
                                                <IntlMessages id="main.pulseRate" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.nightAVG" />
                                            </TableCell>
                                            <TableCell width="25%">
                                                <IntlMessages id="so.durationAVG" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summary_table_7.map((summary, index) => (
                                            <TableRow key={"summary-table-2-" + index}>
                                                <TableCell width="115px">{summary.name}</TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.nightA)
                                                        ? summary.nightA
                                                        : Number(summary.nightA).toFixed(2)}
                                                </TableCell>
                                                <TableCell width="25%">
                                                    {isNaN(summary.durationA)
                                                        ? summary.durationA
                                                        : Number(summary.durationA).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : null}
                            {summary_table_14 && summary_table_14.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="70%">SYMPTOMS HISTORY</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <div
                                        style={{
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                            overflowX: "hidden",
                                        }}
                                    >
                                        {summary_table_14.map((summary, index) => (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        padding: "10px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "3px",
                                                            backgroundColor: "#0E95FC",
                                                            marginLeft: "7px",
                                                            marginRight: "8px",
                                                            marginTop: index === 0 ? "8px" : "-20px",
                                                            height:
                                                                summary_table_14.length === 1
                                                                    ? "0px"
                                                                    : index === summary_table_14.length - 1
                                                                        ? "36px"
                                                                        : "auto",
                                                        }}
                                                    />
                                                    <div style={{ position: "absolute" }}>
                                                        <img src={icon_clock} alt="clock icon" />
                                                    </div>
                                                    <div
                                                        style={{
                                                            backgroundColor: "#F2F2F2",
                                                            borderRadius: "3px",
                                                            padding: "8px",
                                                            paddingBottom: "12px",
                                                            marginLeft: "12px",
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                textTransform: "uppercase",
                                                                lineHeight: "14px",
                                                                color: "#767676",
                                                            }}
                                                        >
                                                            {dayjs(Number(summary["timestamp"])).format(
                                                                "HH:mm \xa0\xa0DD, MMM YYYY"
                                                            )}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                marginTop: "6px",
                                                                lineHeight: "14px",
                                                                letterSpacing: "0.5px",
                                                            }}
                                                        >
                                                            {summary["symptom_medication_value"]}
                                                            {/* Fever, Cough, Shortness of breath, Fatigue, Body aches, Headache, Loss of taste and smell,
                                                                    Sore throat, Congestion and runny nose, Nausea and Diarrhea */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                </Table>
                            ) : null}
                            {summary_table_15 && summary_table_15.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="70%">MEDICATION HISTORY</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <div
                                        style={{
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                            overflowX: "hidden",
                                        }}
                                    >
                                        {summary_table_15.map((summary, index) => (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        padding: "10px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "3px",
                                                            backgroundColor: "#0E95FC",
                                                            marginLeft: "7px",
                                                            marginRight: "8px",
                                                            marginTop: index === 0 ? "8px" : "-20px",
                                                            height:
                                                                summary_table_15.length === 1
                                                                    ? "0px"
                                                                    : index === summary_table_15.length - 1
                                                                        ? "36px"
                                                                        : "auto",
                                                        }}
                                                    />
                                                    <div style={{ position: "absolute" }}>
                                                        <img src={icon_clock} alt="clock icon" />
                                                    </div>
                                                    <div
                                                        style={{
                                                            backgroundColor: "#F2F2F2",
                                                            borderRadius: "3px",
                                                            padding: "8px",
                                                            paddingBottom: "12px",
                                                            marginLeft: "12px",
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                textTransform: "uppercase",
                                                                lineHeight: "14px",
                                                            }}
                                                        >
                                                            {dayjs(Number(summary["timestamp"])).format(
                                                                "HH:mm \xa0\xa0DD, MMM YYYY"
                                                            )}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                marginTop: "6px",
                                                                lineHeight: "14px",
                                                            }}
                                                        >
                                                            {summary["symptom_medication_value"]}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                </Table>
                            ) : null}
                            {summary_table_16 && summary_table_16.length > 0 ? (
                                <Table className="summary-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="70%">DIET PLAN</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <div
                                        style={{
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                            overflowX: "hidden",
                                        }}
                                    >
                                        {summary_table_16.map((summary, index) => (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        padding: "10px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "3px",
                                                            backgroundColor: "#0E95FC",
                                                            marginLeft: "7px",
                                                            marginRight: "8px",
                                                            marginTop: index === 0 ? "8px" : "-20px",
                                                            height:
                                                                summary_table_16.length === 1
                                                                    ? "0px"
                                                                    : index === summary_table_16.length - 1
                                                                        ? "36px"
                                                                        : "auto",
                                                        }}
                                                    />
                                                    <div style={{ position: "absolute" }}>
                                                        <img src={icon_clock} alt="clock icon" />
                                                    </div>
                                                    <div
                                                        style={{
                                                            backgroundColor: "#F2F2F2",
                                                            borderRadius: "3px",
                                                            padding: "8px",
                                                            paddingBottom: "12px",
                                                            marginLeft: "12px",
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                textTransform: "uppercase",
                                                                lineHeight: "14px",
                                                            }}
                                                        >
                                                            {dayjs(Number(summary["timestamp"])).format(
                                                                "HH:mm \xa0\xa0DD, MMM YYYY"
                                                            )}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                marginTop: "6px",
                                                                lineHeight: "14px",
                                                            }}
                                                        >
                                                            {summary["symptom_medication_value"]}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                </Table>
                            ) : null}
                        </TabPanel>
                    ) : (
                        <TabPanel>
                            <div className="no-data summary-table">
                                <IntlMessages id="so.noPatientSummary" />
                            </div>
                        </TabPanel>
                    )}
                </Tabs>
                <Drawer
                    open={show_patient_info}
                    anchor="right"
                    style={{ top: "20px", overflowY: "auto" }}
                >
                    <div
                        className="d-flex flex-column align-items-center py-3"
                        style={{
                            maxWidth: "400px",
                            height: "100%",
                            overflowY: "auto",
                            backgroundColor: "#f4f4f7",
                        }}
                    >
                        <Fab
                            style={{ position: "fixed", bottom: "8px", zIndex: 3 }}
                            className="bg-danger text-white"
                            onClick={() => set_show_patient_info()}
                        >
                            <Close />
                        </Fab>
                    </div>
                </Drawer>
                <div className="container-wrap">
                    <div className="patient-info">
                        {patient_info.created_by !== SAMPLE_PATIENT_PHYSICIAN ? (
                            <div onClick={togglePatientDetails} className="patient-bio">
                                <div className="patient-name">
                                    {patient_info.first_name && patient_info.last_name
                                        ? patient_info.first_name + " " + patient_info.last_name
                                        : patient_info.patient_code}{" "}
                                    <i className="zmdi zmdi-chevron-right zmdi-hc-fw" />
                                </div>
                                <span className="details-link">
                                    <IntlMessages id="po.patientInfo" />
                                </span>
                                <div
                                    className="device-name"
                                    style={{ fontSize: "12px", cursor: "default" }}
                                >
                                    {device_info ? "Device Id :" + device_info.device_id : "-"}
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="patient-name">
                                    {patient_info.first_name && patient_info.last_name
                                        ? patient_info.first_name + " " + patient_info.last_name
                                        : patient_info.patient_code}{" "}
                                    <i className="zmdi zmdi-chevron-right zmdi-hc-fw" />
                                </div>
                            </div>
                        )}
                        <div className="patient-details hidden" id="patient-details">
                            {/* <i className="close-icon zmdi zmdi-close zmdi-hc-fw" onClick={togglePatientDetails}></i> */}
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="newpatient.gender" />
                                </label>
                                <span>
                                    {patient_info.gender == "O"
                                        ? "Other"
                                        : patient_info.gender == "M"
                                            ? "Male"
                                            : "Female"}
                                </span>
                            </div>
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="newpatient.yearofBirth" />
                                </label>
                                <span>
                                    {patient_info.date_of_birth !== null
                                        ? new Date(patient_info.date_of_birth).getFullYear()
                                        : "--/--/----"}
                                </span>
                            </div>
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="newpatient.weight" />
                                </label>
                                <span>{patient_info.weight}</span>
                            </div>
                            {/* <div className="details-block">
                    <label>STATUS</label>
                    <span>{patient_info.active_flag == 0 ? 'Inactive' : 'Active'}</span>
                </div> */}
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="newpatient.height" />
                                </label>
                                <span>{patient_info.height}</span>
                            </div>
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="appModule.bmi" />
                                </label>
                                <span>{patient_info.bmi}</span>
                            </div>
                            <div className="details-block">
                                <label>
                                    <IntlMessages id="so.device" />
                                </label>
                                <span>{device_info ? device_info.device_id : "NA"}</span>
                            </div>
                            <div className="details-block details-block-more-link">
                                <Link
                                    to={`/app/view_patient_info/id=${patients.patient_info.user_id
                                        }`}
                                >
                                    <IntlMessages id="so.more" /> <br />
                                    <IntlMessages id="so.details" />{" "}
                                    <i className="zmdi zmdi-chevron-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    {!fetching_nights_available &&
                        night_view === "single_night" &&
                        !device_info &&
                        (!nights_available ||
                            Object.keys(nights_available).length === 0) && (
                            <span>
                                <b>
                                    <IntlMessages id="so.noAssessmentMsg" />{" "}
                                    <Link
                                        to={`/app/view_patient_info/id=${patients.patient_info.user_id
                                            }`}
                                    >
                                        <IntlMessages id="so.clickHere" />
                                    </Link>
                                    .
                                </b>
                            </span>
                        )}
                    {!fetching_nights_available &&
                        night_view === "single_night" &&
                        device_info &&
                        (!nights_available ||
                            Object.keys(nights_available).length === 0) && (
                            <span>
                                <b>
                                    <IntlMessages id="po.patientInfoMsg" />
                                    <br />
                                    <IntlMessages id="so.assessmentSchedule" />{" "}
                                    {getLocalMoment(
                                        device_info.device_allocation_date,
                                        "DD MMM YYYY"
                                    )}
                                    <IntlMessages id="so.toThe" />{" "}
                                    {getLocalMoment(
                                        device_info.device_deallocation_date,
                                        "DD MMM YYYY"
                                    )}
                                    .
                                </b>
                            </span>
                        )}
                    {/* {
                        (
                            night_view === 'multiple_night'
                            && !fetching_tv_kpi_data
                            && !tv_duration
                        ) && (
                            <span><b>Select duration to display graphical overview.</b></span>
                        )
                    } */}
                    {night_view === "multiple_night" &&
                        tv_duration &&
                        !fetching_tv_kpi_data &&
                        Object.keys(selected_tv_kpis).length === 0 && (
                            <span>
                                <b>
                                    <IntlMessages id="so.selectChannelMsg" />
                                </b>
                            </span>
                        )}
                    {isNotEmpty(nights_available) &&
                        isNotEmpty(selected_night) && (
                            <AnnotateDialog
                                // available_kpis={available_kpis}
                                selected_night={selected_night}
                                device_id={nights_available[selected_night][0].device_id}
                                recording_date={
                                    nights_available[selected_night][0].recording_date
                                }
                                selected_kpis={selected_kpis}
                                annotate={annotate}
                                setKeyComboValue={setKeyComboValue}
                                set_annotate={set_annotate}
                                annotate_range={annotate_range}
                                set_annotate_range={set_annotate_range}
                                // annotation_kpis={annotation_kpis}
                                // change_annotation_kpis={change_annotation_kpis}
                                add_new_annotation={add_new_annotation}
                                edit_annotation={edit_annotation}
                                sorted_kpis={sorted_kpis}
                                annotation_colours={annotation_colours}
                                annotation_categories={annotation_categories}
                                add_annotation_category={add_annotation_category}
                                edit_annotation_category={edit_annotation_category}
                                delete_annotation_category={delete_annotation_category}
                                patient_id={patients.patient_info.user_id}
                                doctor_id={doctor_id}
                                patient_physician_id={props.patient_physician_id}
                                is_annotator={props.is_annotator}
                                selected_annotation={selected_annotation}
                                set_selected_annotation={set_selected_annotation}
                                annotation_map_id={annotation_map_id}
                                set_annotation_map_id={set_annotation_map_id}
                                edit_annotation_flag={edit_annotation_flag}
                                set_edit_annotation_flag={set_edit_annotation_flag}
                                view_annotation_flag={view_annotation_flag}
                                set_view_annotation_flag={set_view_annotation_flag}
                                showEditAnnotationPopup={showEditAnnotationPopup}
                            />
                        )}
                    {nights_available &&
                        night_view === "single_night" &&
                        Object.keys(nights_available).length > 0 && (
                            <div className="d-flex justify-content-between mb-2">
                                <div className="left-map">
                                    {device_info &&
                                        !props.is_annotator && (
                                            <Link
                                                className="show-real-time-data-link"
                                                to={`/app/device_testing?id=${btoa(
                                                    patients.patient_info.patient_code
                                                )}&did=${btoa(device_info.device_id)}&back=${btoa(
                                                    "pd-" + patient_info.user_id
                                                )}`}
                                            >
                                                <IntlMessages id="so.realTimeData" />
                                            </Link>
                                        )}
                                    {available_kpis &&
                                        available_kpis.length > 0 &&
                                        analytics &&
                                        //  !show_loader &&
                                        props.is_annotator && (
                                            <span
                                                onClick={() => setSamplePatient(true)}
                                                style={{ color: "#0E95FC", cursor: "pointer" }}
                                            >
                                                Add to Sample Patient
                                            </span>
                                        )}
                                </div>
                                <div className="right-map">
                                    {available_kpis &&
                                        available_kpis.length > 0 && (
                                            <>
                                                <span
                                                    title="Undo Zoom"
                                                    className={
                                                        "graph-zoom-actions" + (canUndo ? " active" : "")
                                                    }
                                                    onClick={undo}
                                                >
                                                    <img
                                                        src={canUndo ? icon_undo_active : icon_undo}
                                                        alt="Graph Undo Icon"
                                                    />
                                                </span>
                                                <span
                                                    title="Redo Zoom"
                                                    className={
                                                        "graph-zoom-actions" + (canRedo ? " active" : "")
                                                    }
                                                    onClick={redo}
                                                >
                                                    <img
                                                        src={canRedo ? icon_redo_active : icon_redo}
                                                        alt="Graph Redo Icon"
                                                    />
                                                </span>
                                                <span
                                                    title="Reset Zoom"
                                                    className={
                                                        "graph-zoom-actions" +
                                                        (canUndo || canRedo ? " active" : "")
                                                    }
                                                    onClick={reset}
                                                >
                                                    <img
                                                        src={
                                                            canUndo || canRedo
                                                                ? icon_reset_active
                                                                : icon_reset
                                                        }
                                                        alt="Graph Reset Icon"
                                                    />
                                                </span>
                                            </>
                                        )}
                                    {available_kpis &&
                                        available_kpis.length > 0 && (
                                            <span
                                                className="hideandshow-artifects"
                                                onClick={togglePlotbandsOnGraphs}
                                            >
                                                {show_plotbands && "Hide Thresholds"}
                                                {!show_plotbands && "Show Thresholds"}
                                            </span>
                                        )}
                                    {available_kpis &&
                                        available_kpis.length > 0 &&
                                        analytics &&
                                        analytics["SQB"] && (
                                            <span
                                                className="hideandshow-artifects"
                                                onClick={toggleArtifectsOnGraphs}
                                            >
                                                {show_artifects_flag && "Hide artefacts"}
                                                {!show_artifects_flag && "Show artefacts"}
                                            </span>
                                        )}
                                    {available_kpis &&
                                        available_kpis.length > 0 && (
                                            <span
                                                className="hideandshow-annotation"
                                                onClick={toggleAnnotatoinsSidebar}
                                            >
                                                {show_annotations_sidebar_flag &&
                                                    "Hide annotation list"}
                                                {!show_annotations_sidebar_flag &&
                                                    "Show annotation list"}
                                            </span>
                                        )}
                                </div>
                            </div>
                        )}
                    {night_view === "single_night" && (
                        <div className="graph-annotation-wrap" id="graph-container">
                            {Object.keys(selected_kpis).length > 0 &&
                                start_time &&
                                end_time &&
                                analytics && (
                                    <Charts
                                        annotation_flags={annotation_flags}
                                        set_annotation_flags={(flag) => set_annotation_flags(flag)}
                                        show_artifects_flag={show_artifects_flag}
                                        show_plotbands={show_plotbands}
                                        show_annotations_sidebar_flag={
                                            show_annotations_sidebar_flag
                                        }
                                        customTimeRange={customTimeRange}
                                        setCustomTimeRange={setCustomTimeRange}
                                        Highstock={Highstock}
                                        zoom_type={zoom_type}
                                        kpi_names={kpi_names}
                                        // select_kpi={select_kpi}
                                        analytics={analytics}
                                        recording_meta={recording_meta}
                                        set_annotate={set_annotate}
                                        set_annotate_range={set_annotate_range}
                                        annotations={annotations}
                                        selected_kpis={selected_kpis}
                                        set_selected_kpis={set_selected_kpis}
                                        get_mean={get_mean}
                                        update_extremes={update_extremes}
                                        sorted_kpis={sorted_kpis}
                                        set_sorted_kpis={set_sorted_kpis}
                                        sorted_array_kpis={sorted_array_kpis}
                                        set_sorted_array_kpis={(kpiArray) =>
                                            saveKpiPreferenceData(kpiArray)
                                        }
                                        annotation_colours={annotation_colours}
                                        show_system_annotations_flag={show_system_annotations_flag}
                                        show_desaturations_flag={show_desaturations_flag}
                                        show_annotations_flag={show_annotations_flag}
                                        // showViewAnnotationPopup={showViewAnnotationPopup}
                                        showEditAnnotationPopup={showEditAnnotationPopup}
                                        show_Custom_Annotation_Flag={show_Custom_Annotation_Flag}
                                        set_show_Custom_Annotation_Flag={
                                            set_show_Custom_Annotation_Flag
                                        }
                                        show_System_Annotation={show_System_Annotation}
                                        set_show_System_Annotation={set_show_System_Annotation}
                                        show_Desaturations={show_Desaturations}
                                        set_show_Desaturations={set_show_Desaturations}
                                        handle_artifects_flag={handle_artifects_flag}
                                        set_handle_artifects_flag={set_handle_artifects_flag}
                                        handle_annotations_sidebar_flag={
                                            handle_annotations_sidebar_flag
                                        }
                                        set_handle_annotations_sidebar_flag={
                                            set_handle_annotations_sidebar_flag
                                        }
                                        windowViewActive={windowViewActive}
                                        setWindowViewActive={setWindowViewActive}
                                        vital_parameters={vital_parameters}
                                    />
                                )}
                            {(fetching_available_kpis || fetching_kpi_data || show_loader) &&
                                getLoaderContent()
                                // <div className="loader-overlay">
                                //     <div className="full-page-loader">
                                //         <div className="custom-loader">
                                //             <img src={image_loader} alt="Loading" />
                                //         </div>
                                //         <div className="loader-text">Please wait...</div>
                                //     </div>
                                // </div>
                            }
                            {show_annotations_sidebar_flag ? (
                                <div className="annotation-sidebar">
                                    {annotationSidebarSubContent}
                                </div>
                            ) : null}
                        </div>
                    )}
                    {night_view === "multiple_night" && (
                        <div className="graph-annotation-wrap" id="tv-graph-container">
                            {available_kpis &&
                                available_kpis.length > 0 && (
                                    <span
                                        className="hideandshow-artifects"
                                        onClick={togglePlotbandsOnGraphs}
                                    >
                                        {show_plotbands && "Hide Thresholds"}
                                        {!show_plotbands && "Show Thresholds"}
                                    </span>
                                )}
                            {nights_available &&
                                Object.keys(nights_available).length > 0 &&
                                Object.keys(selected_tv_kpis).length > 0 &&
                                tv_duration &&
                                tv_night_from &&
                                tv_night_to &&
                                tv_analytics &&
                                !fetching_tv_kpi_data && (
                                    <TvCharts
                                        Highstock={Highstock}
                                        zoom_type={zoom_type}
                                        update_extremes={update_extremes}
                                        night_view={night_view}
                                        customTimeRange={customTimeRange}
                                        setCustomTimeRange={setCustomTimeRange}
                                        kpi_names={kpi_names}
                                        select_tv_kpi={select_tv_kpi}
                                        tv_analytics={tv_analytics}
                                        selected_tv_kpis={selected_tv_kpis}
                                        sorted_tv_kpis={sorted_tv_kpis}
                                        set_sorted_tv_kpis={set_sorted_tv_kpis}
                                        show_plotbands={show_plotbands}
                                        vital_parameters={vital_parameters}
                                    />
                                )}
                            {nights_available &&
                                Object.keys(nights_available).length > 0 &&
                                Object.keys(selected_tv_kpis).length > 0 &&
                                tv_duration &&
                                tv_night_from &&
                                tv_night_to &&
                                tv_analytics &&
                                tv_analytics["SPO2"] &&
                                tv_analytics["SPO2"].length > 0 &&
                                !fetching_tv_kpi_data && (
                                    <TrendSingleNightGraphs tv_analytics={tv_analytics["SPO2"]} />
                                )}

                            {(fetching_tv_kpi_data || show_loader) && getLoaderContent()}
                        </div>
                    )}
                    {actigraph_view && (
                        <div className="graph-annotation-wrap" id="tv-graph-container">
                            {actigraph &&
                                Object.keys(actigraph).length > 0 &&
                                Object.keys(selected_actigraph_dates).length > 0 &&
                                tv_duration &&
                                tv_night_from &&
                                tv_night_to &&
                                tv_analytics["SQ"] &&
                                tv_analytics["SQ"].length > 0 &&
                                selected_tv_kpis["SQ"] &&
                                // tv_analytics["SPO2"] &&
                                // tv_analytics["SPO2"].length > 0 &&
                                !fetching_actigraph && (
                                    <>
                                        <div>
                                            <h4 className="mt-5">Actigraph's</h4>
                                            <ul className="actigraph-legends">
                                                <p className="actigraph-legends-sleep">sleep</p>
                                                <p className="actigraph-legends-awake">awake</p>
                                                <p className="actigraph-legends-unknown">unknown</p>
                                            </ul>
                                        </div>
                                        <TrendNightGraphs
                                            actigraph={actigraph}
                                            actigraph_meta={actigraph_meta}
                                            Highstock={Highstock}
                                            selected_actigraph_dates={selected_actigraph_dates}
                                            selected_dates={selected_actigraph_dates}
                                            zoom_type={zoom_type}
                                            available_dates={actigraph_dates}
                                            update_extremes={update_extremes}
                                            sorted_dates={sorted_actigraph_dates}
                                            set_sorted_dates={set_sorted_actigraph_dates}
                                            customTimeRange={customTimeRange}
                                            setCustomTimeRange={setCustomTimeRange}
                                            night_view={night_view}
                                            tv_analytics={tv_analytics}
                                            actigraph_view={actigraph_view}
                                        />
                                    </>
                                )}
                            {(fetching_tv_kpi_data || show_loader) && getLoaderContent()}
                        </div>
                    )}
                    {confirm_del_dialog && (
                        <ConfirmDeleteDialog
                            onCancel={() => setConfirmDelDialog(false)}
                            onConfirm={deleteAllManualAnnotations}
                            confirm_dialog_type={confirm_dialog_type}
                            multiple_count={selected_multiple_annotations.length}
                            custom_count={
                                annotations.filter((a) => a.type === "custom").length
                            }
                            system_count={
                                annotations.filter(
                                    (a) => a.type === "system" || a.type === "system-edit"
                                ).length
                            }
                            desaturation_count={
                                annotations.filter((a) => a.type === "desaturation").length
                            }
                        />
                    )}
                    {/* {confirmModal && (
            <ConfirmUploadDialog
              onCancel={() => {
                setConfirmModal(false);
                if (props.is_error) {
                  props.reset_report_error();
                }
              }}
              onConfirm={downloadReport}
              fileName={finalFileName}
              jiraKey={selectedJiraKey}
              isError={props.is_error}
              errorMsg={props.error}
            />
          )} */}
                    {samplePatient && (
                        <SamplePatientUpload
                            samplePatients={patients.sample_patient_list}
                            onCancel={() => {
                                setSamplePatient(false);
                            }}
                            data={{
                                recording_date:
                                    nights_available[selected_night][0].recording_date,
                            }}
                        />
                    )}
                </div>
            </div>
            {/* Dummy image element for the report footer */}
            <img
                alt=""
                onLoad={convert}
                id="foot"
                style={{ height: "100%", width: "100%" }}
                src={footerWave}
            />
            <img
                alt=""
                id="head"
                style={{ height: "100%", width: "100%" }}
                src={waveImage}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    ...state.patients,
    patients: state.patients,
    kpi: state.kpi,
    realtime: state.realtime,
    is_annotator: state.user.is_annotator,
    membership_type: state.user.user_details.membership_type,
    patient_physician_id: state.patients.patient_physician_info
        ? state.patients.patient_physician_info.physician_id
        : 0,
    doctor_id: state.user.user_details.user_id,
    doctor_info: state.user.user_details,
    rii_parameters: state.user.user_details.rii_parameters,
    physician_info: state.patients.physician_info,
    fetch_patients_qna_data: state.patients.fetch_patients_qna_data,
    // kpi_order : state.user.user_details.kpi_order_preference,
});

const mapDispatchToProps = (dispatch) => ({
    reset_tv_kpi_data: (payload) => dispatch(reset_tv_kpi_data_action(payload)),
    fetch_nights_available: (payload) =>
        dispatch(fetch_nights_available_action(payload)),
    fetch_available_kpis: (payload) =>
        dispatch(fetch_available_kpis_action(payload)),
    fetch_patient_data: (patient_id) =>
        dispatch(fetch_patient_data_action(patient_id)),
    fetch_patients_qna_response: (query) =>
        dispatch(fetch_patients_qna_response_action(query)),
    // fetch_kpi_data: (query) => dispatch(fetch_kpi_data_action(query)),
    fetch_s3_kpi_data: (query) => dispatch(fetch_s3_kpi_data_action(query)),
    fetch_tv_kpi_data: (query) => dispatch(fetch_tv_kpi_data_action(query)),
    fetch_actigraph: (query) => dispatch(fetch_actigraph_action(query)),
    // get_kpi_summary: (payload) => dispatch(get_kpi_summary_action(payload)),
    // get_ml_kpi_summary: (payload) => dispatch(get_ml_kpi_summary_action(payload)),
    fetch_annotations: (payload) => dispatch(fetch_annotations_action(payload)),
    add_new_annotation: (payload) => dispatch(add_new_annotation_action(payload)),
    edit_annotation: (payload) => dispatch(edit_annotation_action(payload)),
    add_patient_comment: (payload) =>
        dispatch(add_patient_comment_action(payload)),
    fetch_patient_comment: (payload) =>
        dispatch(fetch_patient_comment_action(payload)),
    update_patient_comment: (payload) =>
        dispatch(update_patient_comment_action(payload)),
    delete_patient_comment: (payload) =>
        dispatch(delete_patient_comment_action(payload)),
    fetch_disease_list: (payload) => dispatch(fetch_disease_list_action(payload)),
    fetch_patient_disease: (payload) =>
        dispatch(fetch_patient_disease_action(payload)),
    fetch_checkup_dates: (payload) =>
        dispatch(fetch_checkup_dates_action(payload)),
    add_checkup_date: (payload) => dispatch(add_checkup_date_action(payload)),
    checkup_mark_as_complete: (payload) =>
        dispatch(checkup_mark_as_complete_action(payload)),
    fetch_annotation_categories: (payload) =>
        dispatch(fetch_annotation_categories_action(payload)),
    add_annotation_category: (payload) =>
        dispatch(add_annotation_category_action(payload)),
    edit_annotation_category: (payload) =>
        dispatch(edit_annotation_category_action(payload)),
    delete_annotation_category: (payload) =>
        dispatch(delete_annotation_category_action(payload)),
    fetch_patients_summary: (payload) =>
        dispatch(fetch_patients_summary_action(payload)),
    fetch_patient_medication_symptoms_history: (payload) =>
        dispatch(fetch_patient_medication_symptoms_history_action(payload)),
    fetch_patients_rii_summary: (query) =>
        dispatch(fetch_patients_rii_summary_action(query)),
    fetch_user_countries: () => dispatch(fetch_user_countries_action()),
    generate_system_annotations: (payload) =>
        dispatch(generate_system_annotations_action(payload)),
    //  upload_patient_report: (payload) =>
    //  dispatch(upload_patient_report_action(payload)),
    //   fetch_patient_jira_cards_data: (payload) =>
    //     dispatch(fetch_patient_jira_cards_data_action(payload)),
    update_kpi_preference: (payload) =>
        dispatch(update_kpi_preference_action(payload)),
    update_trendview_kpi_preference: (payload) =>
        dispatch(update_trendview_kpi_preference_action(payload)),
    delete_annotations: (payload) => dispatch(delete_annotations_action(payload)),
    reset_report_error: () => dispatch(reset_report_error_action()),
    refresh_statistics: (payload) => dispatch(refresh_statistics_action(payload)),
    generate_report_data: (payload) =>
        dispatch(generate_report_data_action(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SinglePatient);
